<mat-card class="sticky-header p-y-0" [style.background-color]="sharedService.purple" *ngIf="!showSubmitted">
  <mat-card-content>
    <div class="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-start items-start sm:items-center">
      <mat-icon class="medium-icon m-24">group</mat-icon>
      <h2 class="f-s-20" *ngIf="!renewing">Apply For a Facilitator License</h2>
      <h2 class="f-s-20" *ngIf="renewing">Renew Facilitator License</h2>
      <h2 class="f-s-20 flex items-center gap-2" *ngIf="facilitatorLicense.licenseId"> {{facilitatorLicense.licenseId}}
        <button mat-icon-button (click)="sharedService.copyToClipboard(facilitatorLicense.licenseId)"
                matTooltip="Copy to Clipboard" matTooltipShowDelay=800 aria-label="Copy to Clipboard">
          <mat-icon>content_copy</mat-icon>
        </button>
      </h2>
      <span class="flex-1"></span>
      <button mat-flat-button color="primary"
        *ngIf="viewForm && ((facilitatorLicenses.length > 1) || (facilitatorLicenses.length == 1 && facilitatorLicense.status != 'Pending'))" (click)="closeApplication()">Close</button>
        <button mat-flat-button color="primary"
        *ngIf="renewing" (click)="closeApplication()">Close</button>
    </div>
  </mat-card-content>
</mat-card>

<div *ngIf="viewForm && !showSubmitted" class="flex w-full flex-col gap-4" style="overflow-x: auto;">
  <mat-stepper class="readable-stepper" [orientation]="sharedService.isMobile? 'vertical' : 'horizontal'" #facilitatorStepper
    [selectedIndex]="step" (selectionChange)="changeStep($event)">
    <!--Getting Started-->
    <mat-step>
      <ng-template matStepLabel>
        <span matTooltip="Getting Started" matTooltipPosition="below" [matTooltipShowDelay]="500">Getting Started</span>
      </ng-template>
      <div class="p-b-8 flex flex-col gap-2">
        <mat-card>
          <mat-card-title>
            <span>
              Thank you for your interest in applying for a psilocybin facilitator license
              through the Oregon Psilocybin Services - Training Program, Licensing, and Compliance system (TLC).
            </span>
          </mat-card-title>
          <mat-card-content>

          <div style="padding-top: 2em" class="flex flex-col lg:flex-row gap-3">
            <ul class="flex flex-col gap-2">
              <strong class="f-s-16">Facilitator License Requirements:</strong>
              <li class="f-s-16">
                Must be 21 years of age or older
              </li>
              <li class="f-s-16">
                Must have a high school diploma (or equivalent)
              </li>
              <li class="f-s-16" *ngIf="!sharedService.isAfterJan1st2027()">
                Must complete a facilitator training program with curriculum that has been approved by OPS
              </li>
              <li class="f-s-16" *ngIf="sharedService.isAfterJan1st2027()">
                Must complete a facilitator training program with curriculum that has been approved by OPS or by a training program that meets or exceeds OPS curriculum approval
              </li>
              <li class="f-s-16">
                Must pass the OPS Regulations Exam
              </li>
              <li class="f-s-16">
                Must pass a criminal background check
              </li>
              <li class="f-s-16">
                Must pay a license application fee
              </li>
              <li class="f-s-16">
                Must pay an annual license fee
              </li>
            </ul>

            <ul class="flex flex-col gap-2 f-s-16">
              <strong>The completed application packet contains the following:</strong>
              <li class="f-s-16">
                Completed and signed facilitator license application
              </li>
              <li class="f-s-16">
                Uploaded copy of the front and back of a valid, unexpired government-issued photo identification for the applicant
              </li>
              <li class="f-s-16" *ngIf="!sharedService.isAfterJan1st2027()">
                Uploaded certificate of completion from a psilocybin facilitator training program with OPS approved curriculum
              </li>
              <li class="f-s-16" *ngIf="sharedService.isAfterJan1st2027()">
                Uploaded certificate of completion from psilocybin facilitator training programs with OPS approved curriculum or by an out of state training program that meets or exceeds OPS curriculum. Currently the only other state that meets or exceeds OPS curriculum is the State of Colorado
              </li>
              <li class="f-s-16">
                Uploaded copy of the applicant's social equity plan
              </li>
              <li class="f-s-16">
                A passing score of 75 percent or better on the OPS administered exam
              </li>
              <li class="f-s-16">
                <strong>$150</strong> Non-refundable facilitator license application fee paid and cleared
              </li>
            </ul>
          </div>

          <div style="padding-top: 2em" class="flex flex-row">
            <ul class="flex flex-col gap-2 f-s-16">
              <strong>Important Notes: </strong>
              <li class="f-s-16">
                Please review each section of the application to ensure it is complete
              </li>
              <li class="f-s-16">
                Toward the end of the application, a fee page will describe how to submit the application fee which may be paid online or in-person
              </li>
              <li class="f-s-16">
                OPS will not review an application packet until the application fee is paid and cleared.
                You have 90 days from the date of application submission to pay the application fee or it will be closed.
              </li>
              <li class="f-s-16">
                <strong>Incomplete and Insufficient Application Statuses:</strong>
              </li>
              <div style="padding-left: 1em;" class="flex flex-col gap-2">
                <li class="f-s-16" *ngIf="showNewIncompleteDates(facilitatorLicense.applicationDate)">
                  Incomplete: An application is considered incomplete if the application is missing required information
                  (e.g., the application fee has not been paid or the applicant did not submit fingerprints).
                  If the application is incomplete, we will notify you by email to give you an opportunity to make your application complete.
                  You have 30 days from the initial date you are notified to complete your application. If you fail to do so, the application will be closed.
                </li>
                <li class="f-s-16" *ngIf="showNewIncompleteDates(facilitatorLicense.applicationDate)">
                  Insufficient: An application is considered insufficient if the complete application or site inspection
                  does not meet requirements outlined in statute or rule. If the application is insufficient,
                  we will notify you by email to give you an opportunity to meet requirements.
                  You will have 30 days from the initial date you are notified to meet requirements, or your application will be denied.
                </li>

                <li class="f-s-16" *ngIf="!showNewIncompleteDates(facilitatorLicense.applicationDate)">
                  Incomplete: An application is considered incomplete if the application is missing required information
                  (e.g., the application fee has not been paid or the applicant did not submit fingerprints).
                  If the application is incomplete, we will notify you by email to give you an opportunity to make your application complete.
                  You have 90 days from the initial date you are notified to complete your application. If you fail to do so, the application will be closed.
                </li>
                <li class="f-s-16" *ngIf="!showNewIncompleteDates(facilitatorLicense.applicationDate)">
                  Insufficient: An application is considered insufficient if the complete application or site inspection
                  does not meet requirements outlined in statute or rule. If the application is insufficient,
                  we will notify you by email to give you an opportunity to meet requirements.
                  You will have 90 days from the initial date you are notified to meet requirements, or your application will be denied.
                </li>
              </div>
            </ul>
          </div>

          <div style="padding-top: 2em" class="flex flex-col gap-2 f-s-16">
            <span>
              <strong>When you click the continue button at the bottom of this page, you will proceed to the psilocybin facilitator license application.</strong>
              The application automatically saves in TLC. You may exit the application and come back later to complete and submit the application, if needed.
            </span>
          </div>
          <div style="padding-top: 2em;" class="flex flex-col gap-2 f-s-16">
            <span>
              <strong>DISCLAIMER:</strong>
              Psilocybin remains a schedule I drug under the federal Controlled Substances Act.
              Applicants are responsible for making their own determinations regarding the legal risks associated with participating in this program.
              The information you provide in your application materials, including applicant name, is subject to disclosure under Oregon's public records laws.
            </span>
          </div>
          </mat-card-content>
        </mat-card>

        <div *ngIf="!hasApplication && showStartButton">
          <button mat-flat-button type="button" color="primary" (click)="startApplication()">Start Application</button>
        </div>
        <div *ngIf="hasApplication" class="p-t-16 flex flex-row w-full md:w-1/2">
          <button mat-raised-button matStepperNext>Continue</button>
        </div>
      </div>
    </mat-step>

    <!--Applicant-->
    <mat-step [stepControl]="applicantForm" *ngIf="facilitatorLicenses.length > 0">
      <form [formGroup]="applicantForm">
        <ng-template matStepLabel>
          <span class="text-red-400" *ngIf="(!applicantForm.valid && !applicantForm.pristine && !licenseLocked) || !applicantDocumentsValid || !additionalDocumentsValid"
            matTooltip="Personal Information Incomplete" matTooltipPosition="below" [matTooltipShowDelay]="500">
            Applicant Information Incomplete</span>
          <span *ngIf="(applicantForm.valid || applicantForm.pristine || licenseLocked) && (applicantDocumentsValid && additionalDocumentsValid)"
            matTooltip="Applicant Information" matTooltipPosition="below" [matTooltipShowDelay]="500">Applicant Information</span>
        </ng-template>
        <div style="max-width: 100%; overflow-x: auto; box-sizing: border-box;">
        <div class="flex flex-col" style="max-width: 100%; min-width: 0;">
          <div class="flex flex-col 2xl:flex-row gap-2" style="min-width: 0;">
            <mat-card class="w-full 2xl:w-1/2" style="min-width: 0; box-sizing: border-box;">
              <mat-card-title>
                <div class="flex flex-col 2xl:flex-row">
                  <span class="flex-1">Applicant Information</span>
                  <div class="flex flex-row gap-2 justify-start items-center">
                    <span class="f-s-16"><strong>Facilitator Id</strong></span>
                    <span class="f-s-16" id="programId">{{facilitatorLicense.licenseId}}</span>
                    <button mat-icon-button (click)="sharedService.copyToClipboard(facilitatorLicense.licenseId)" color="primary"
                            matTooltip="Copy to Clipboard" matTooltipShowDelay=800 aria-label="Copy to Clipboard">
                      <mat-icon>content_copy</mat-icon>
                    </button>
                  </div>
                </div>
              </mat-card-title>
              <mat-card-content class="f-s-16">
                <div class="flex flex-col gap-2">
                  <span id="legalNameLabel"><strong>Legal Name</strong></span>
                  <div class="flex flex-col md:flex-row gap-2">
                    <mat-form-field class="w-full md:w-[40%]">
                      <input matInput placeholder="First" formControlName="legalFirstName" aria-describedby="legalNameLabel">
                      <mat-error role="alert" *ngIf="applicantForm.get('legalFirstName').invalid"> Error: Please enter your first name
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field class="w-full md:w-[40%]">
                      <input matInput placeholder="Last" formControlName="legalLastName" aria-describedby="legalNameLabel">
                      <mat-error role="alert" *ngIf="applicantForm.get('legalLastName').invalid"> Error: Please enter your last name
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field class="w-full md:w-[20%]">
                      <input matInput placeholder="Middle" formControlName="legalMiddleName" aria-describedby="legalNameLabel">
                    </mat-form-field>
                  </div>

                  <span id="preferredNameLabel"><strong>Preferred Name</strong></span>
                  <div class="flex flex-col md:flex-row gap-2">
                    <mat-form-field class="w-full md:w-[40%]">
                      <input matInput placeholder="First" formControlName="preferredFirstName" aria-describedby="preferredNameLabel">
                    </mat-form-field>

                    <mat-form-field class="w-full md:w-[40%]">
                      <input matInput placeholder="Last" formControlName="preferredLastName" aria-describedby="preferredNameLabel">
                    </mat-form-field>

                    <mat-form-field class="w-full md:w-[20%]">
                      <input matInput placeholder="Middle" formControlName="preferredMiddleName" aria-describedby="preferredNameLabel">
                    </mat-form-field>
                  </div>

                  <div class="flex flex-col f-s-16">
                    <span id="priorNamesLabel"><strong>Prior Names and Aliases</strong></span>
                    <span>This information is used for the purposes of the background check</span>
                    <div class="flex flex-col lg:flex-row gap-2">
                      <mat-form-field class="w-full md:w-[80%]">
                        <input matInput placeholder="Name, other name, any other names"
                          formControlName="alternateNames" aria-describedby="priorNamesLabel">
                      </mat-form-field>

                      <mat-form-field>
                        <mat-label id="dateOfBirthLabel">Date of Birth</mat-label>
                        <input placeholder="mm/dd/yyyy" formControlName="dob" matInput [matDatepicker]="dob"
                          [max]="sharedService.today" aria-describedby="dateOfBirthLabel" />
                        <mat-datepicker-toggle matSuffix [for]="dob"></mat-datepicker-toggle>
                        <mat-datepicker #dob>
                          <mat-datepicker-actions>
                            <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                            <button mat-button matDatepickerCancel>Cancel</button>
                          </mat-datepicker-actions>
                        </mat-datepicker>
                        <mat-error role="alert" *ngIf="applicantForm.get('dob').value > sharedService.today">
                          Error: Please choose an earlier date.
                        </mat-error>
                        <mat-error role="alert" *ngIf="applicantForm.get('dob').hasError('required')"> Error: Date of birth is required
                        </mat-error>
                        <mat-error role="alert" *ngIf="!applicantForm.get('dob').hasError('required') && !isAgeValid(21)"> Error: Date of Birth must be 21+
                        </mat-error>
                      </mat-form-field>

                    </div>
                  </div>

                  <div class="flex flex-col f-s-16">
                    <span><strong>*SOCIAL SECURITY NUMBER DISCLOSURE:</strong></span>
                    <span style="padding-top: 1em; padding-left: 1em"><strong>• </strong>
                      As part of your application for an initial or renewal license, Federal and State laws require you to provide your
                      Social Security Number (SSN),
                      if you have one, to Oregon Psilocybin Services for child support enforcement purposes (42 USC § 666(a)(13) & ORS
                      25.785).
                      If you are an applicant or licensee and you have an SSN but fail to provide your SSN, Oregon Psilocybin Services may
                      refuse to process your application.
                      Your SSN will be used only for child support enforcement purposes unless you confirm your agreement that OPS can use
                      it for administrative purposes
                      as well.
                    </span>

                    <span style="padding-top: 1em; padding-left: 1em">
                      <strong>IMPORTANT NOTE: If you do not have a social security number, you may still be licensed or permitted by Oregon
                        Psilocybin Services.</strong>
                    </span>

                    <span id="ssnDisclosure" style="padding-top: 1em; padding-left: 1em"><strong>• </strong>
                      Based on our authority under OAR 333-333-4100, we are requesting your voluntary consent to use your SSN for the
                      following administrative purposes only:
                      to positively confirm your identity during the criminal records check. Oregon Psilocybin Services will not deny you
                      any rights, benefits or privileges
                      otherwise provided by law if you do not consent to use of your SSN for these administrative purposes (5 USC§
                      552(a)).
                      <strong>Please check the appropriate box next to the social security field indicating whether you consent or do not
                        consent.</strong>
                    </span>
                    <div class="flex flex-col lg:flex-row gap-4 justify-start items-center">
                      <mat-form-field class="w-full md:w-[25%]">
                        <input matInput placeholder="SSN" formControlName="ssn" mask="000-00-0000" aria-describedby="ssnDisclosure">
                        <mat-error role="alert" *ngIf="validateSsn()"> Error: SSN is Required
                        </mat-error>
                      </mat-form-field>
                      <mat-checkbox formControlName="noSsn">
                        I don't have a social security number
                      </mat-checkbox>
                    </div>
                    <span class="f-s-16">Do you consent to use of SSN for purposes of confirming identity during a criminal records check?</span>
                    <mat-error role="alert" *ngIf="validateSsnAttestation()"> Error: Consent choice is Required
                    </mat-error>
                    <div class="flex flex-row gap-2">
                      <div class="flex flex-col gap-2">
                        <mat-checkbox formControlName="ssnAttestation" (click)="changeAttestation(true)">
                          <span class="f-s-16">Yes</span>
                        </mat-checkbox>
                      </div>
                      <div class="flex flex-col gap-2">
                        <mat-checkbox formControlName="ssnNoAttestation" (click)="changeAttestation(false)">
                          <span class="f-s-16">No</span>
                        </mat-checkbox>
                      </div>
                    </div>
                  </div>
                  <div class="flex flex-col gap-3 f-s-16">
                    <span><strong>
                      *For purposes of these questions, “license” means any professional or occupational license, permit or certification that authorizes an individual
                      to engage in an occupation or business, issued by a local, state, or tribal governmental entity, or by a governmental body in another country.
                    </strong></span>
                    <span id="heldLicense" class="text-wrap" [ngStyle]="{'color': applicantForm.get('heldLicense').value == null ? 'red' : ''}">In the last 10 years, have you held a license in Oregon or in another state or country? If yes, please describe the type of license, what state or country it was issued in, and provide dates that the license was in effect.</span>
                    <mat-radio-group aria-label="Select an option" formControlName="heldLicense" aria-describedby="heldLicense" class="gap-2">
                      <mat-radio-button [value]="true"><span class="f-s-16">Yes</span> </mat-radio-button>
                      <mat-radio-button [value]="false"><span class="f-s-16">No</span></mat-radio-button>
                    </mat-radio-group>
                    <mat-error role="alert" *ngIf="validateHeldLicense()"> Error: This field is required</mat-error>
                    <mat-form-field *ngIf="applicantForm.get('heldLicense').value" class="w-full lg:w-[75%]">
                      <textarea matInput placeholder="Previous Licenses Held" cols="2" formControlName="licensesHeld" aria-describedby="heldLicense"></textarea>
                    </mat-form-field>
                    <mat-error role="alert" *ngIf="validateHeldLicenses()">Error: You must enter the license numbers</mat-error>

                    <span id="deniedLicense" class="text-wrap" [ngStyle]="{'color': applicantForm.get('deniedLicense').value == null ? 'red' : ''}">In the last 10 years, have you been denied a license? If yes, please upload documentation explaining why and provide all relevant information.</span>
                    <mat-radio-group aria-label="Select an option" formControlName="deniedLicense" aria-describedby="deniedLicense" class="gap-2">
                      <mat-radio-button [value]="true"><span class="f-s-16">Yes</span></mat-radio-button>
                      <mat-radio-button [value]="false"><span class="f-s-16">No</span></mat-radio-button>
                    </mat-radio-group>
                    <mat-error role="alert" *ngIf="validateDeniedLicense()"> Error: This field is required</mat-error>
                    <mat-error role="alert" *ngIf="!validDeniedLicenseDocument()"> Error: You must upload a supporting document</mat-error>
                    <div *ngIf="applicantForm.get('deniedLicense').value">
                      <input type="file" class="file-input" (change)="uploadAdditionalDocument($event, deniedLicenseType)"
                        #deniedLicenseUpload />
                      <div class="flex flex-row gap-2">
                        <div class="file-upload">
                          <button type="button" [disabled]="licenseLocked"
                            mat-raised-button color="primary" class="upload-btn" (click)="deniedLicenseUpload.click()">
                            Browse
                            <mat-icon>attach_file</mat-icon>
                          </button>
                        </div>
                      </div>
                    </div>

                    <span id="subjectToDiscipline" class="text-wrap" [ngStyle]="{'color': applicantForm.get('subjectToDiscipline').value == null ? 'red' : ''}">For any license you have held, have you been subject to discipline by the entity that issued the license or had the license suspended or revoked in the last 10 years?
                      If so, please upload documentation explaining the reasons for the discipline or revocation and provide all relevant documentation.</span>
                    <mat-radio-group aria-label="Select an option" formControlName="subjectToDiscipline" aria-describedby="subjectToDiscipline" class="gap-2">
                      <mat-radio-button [value]="true"><span class="f-s-16">Yes</span></mat-radio-button>
                      <mat-radio-button [value]="false"><span class="f-s-16">No</span></mat-radio-button>
                    </mat-radio-group>
                    <mat-error role="alert" *ngIf="validateSubjectToDiscipline()"> Error: This field is required</mat-error>
                    <mat-error role="alert" *ngIf="!validSubjectToDisciplineDocument()"> Error: You must upload a supporting document</mat-error>
                    <div *ngIf="applicantForm.get('subjectToDiscipline').value">
                      <input type="file" class="file-input" (change)="uploadAdditionalDocument($event, subjectToDisciplineType)"
                        #subjectToDisciplineUpload />
                      <div class="flex flex-row gap-2">
                        <div class="file-upload">
                          <button type="button" [disabled]="licenseLocked"
                            mat-raised-button color="primary" class="upload-btn" (click)="subjectToDisciplineUpload.click()">
                            Browse
                            <mat-icon>attach_file</mat-icon>
                          </button>
                        </div>
                      </div>
                    </div>

                    <span id="suedForDamages" class="text-wrap" [ngStyle]="{'color': applicantForm.get('suedForDamages').value == null ? 'red' : ''}">In the last 10 years, have you been sued for money damages related to work you provided under a license? If yes, please upload documentation to explain and provide all relevant documentation.</span>
                    <mat-radio-group aria-label="Select an option" formControlName="suedForDamages" aria-describedby="suedForDamages" class="gap-2">
                      <mat-radio-button [value]="true"><span class="f-s-16">Yes</span></mat-radio-button>
                      <mat-radio-button [value]="false"><span class="f-s-16">No</span></mat-radio-button>
                    </mat-radio-group>
                    <mat-error role="alert" *ngIf="validateSuedForDamages()"> Error: This field is required</mat-error>
                    <mat-error role="alert" *ngIf="!validSuedForDamagesDocument()"> Error: You must upload a supporting document</mat-error>
                    <div *ngIf="applicantForm.get('suedForDamages').value">
                      <input type="file" class="file-input" (change)="uploadAdditionalDocument($event, suedForDamagesType)"
                        #suedForDamagesUpload />
                      <div class="flex flex-row gap-2">
                        <div class="file-upload">
                          <button type="button" [disabled]="licenseLocked"
                            mat-raised-button color="primary" class="upload-btn" (click)="suedForDamagesUpload.click()">
                            Browse
                            <mat-icon>attach_file</mat-icon>
                          </button>
                        </div>
                      </div>
                    </div>

                    <span id="settledAllegations" class="text-wrap" [ngStyle]="{'color': applicantForm.get('settledAllegations').value == null ? 'red' : ''}">In the last 10 years, have you settled allegations or claims against you related to a license? If so, please upload documentation to explain and provide all relevant documentation.</span>
                    <mat-radio-group aria-label="Select an option" formControlName="settledAllegations" aria-describedby="settledAllegations" class="gap-2">
                      <mat-radio-button [value]="true"><span class="f-s-16">Yes</span></mat-radio-button>
                      <mat-radio-button [value]="false"><span class="f-s-16">No</span></mat-radio-button>
                    </mat-radio-group>
                    <mat-error role="alert" *ngIf="validateSettledAllegations()"> Error: This field is required</mat-error>
                    <mat-error role="alert" *ngIf="!validSettledAllegationsDocument()"> Error: You must upload a supporting document</mat-error>
                    <div *ngIf="applicantForm.get('settledAllegations').value">
                      <input type="file" class="file-input" (change)="uploadAdditionalDocument($event, settledAllegationsType)"
                        #settledAllegationsUpload />
                      <div class="flex flex-row gap-2">
                        <div class="file-upload">
                          <button type="button" [disabled]="licenseLocked"
                            mat-raised-button color="primary" class="upload-btn" (click)="settledAllegationsUpload.click()">
                            Browse
                            <mat-icon>attach_file</mat-icon>
                          </button>
                        </div>
                      </div>
                    </div>

                    <span id="allegedAbuse" class="text-wrap" [ngStyle]="{'color': applicantForm.get('allegedAbuse').value == null ? 'red' : ''}">Has anyone ever alleged that you abused a child or an adult? If you answered yes, please upload documentation to explain the events and provide all relevant documentation.</span>
                    <mat-radio-group aria-label="Select an option" formControlName="allegedAbuse" aria-describedby="allegedAbuse" class="gap-2">
                      <mat-radio-button [value]="true"><span class="f-s-16">Yes</span></mat-radio-button>
                      <mat-radio-button [value]="false"><span class="f-s-16">No</span></mat-radio-button>
                    </mat-radio-group>
                    <mat-error role="alert" *ngIf="validateAllegedAbuse()"> Error: This field is required</mat-error>

                    <div *ngIf="applicantForm.get('allegedAbuse').value">
                      <div class="flex flex-row">
                        <span id="substantiatedAllegation" class="text-wrap" [ngStyle]="{'color': applicantForm.get('substantiatedAllegation').value == null ? 'red' : ''}">Was the allegation substantiated? If you answered yes, please upload documentation to explain the events and provide all relevant documentation.</span>
                      </div>
                      <div class="flex flex-row">
                        <mat-radio-group aria-label="Select an option" formControlName="substantiatedAllegation" aria-describedby="substantiatedAllegation" class="gap-2">
                          <mat-radio-button [value]="true"><span class="f-s-16">Yes</span></mat-radio-button>
                          <mat-radio-button [value]="false"><span class="f-s-16">No</span></mat-radio-button>
                        </mat-radio-group>
                      </div>
                    </div>
                    <mat-error role="alert" *ngIf="validateSubstantiatedAllegation()"> Error: This field is required</mat-error>
                    <mat-error role="alert" *ngIf="!validAllegedAbuseDocument()"> Error: You must upload a supporting document</mat-error>

                    <div *ngIf="applicantForm.get('allegedAbuse').value">
                      <input type="file" class="file-input" (change)="uploadAdditionalDocument($event, allegedAbuseType)"
                        #allegedAbuseUpload />
                      <div class="flex flex-row gap-2">
                        <div class="file-upload">
                          <button type="button" [disabled]="licenseLocked"
                            mat-raised-button color="primary" class="upload-btn" (click)="allegedAbuseUpload.click()">
                            Browse
                            <mat-icon>attach_file</mat-icon>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>

            <div class="flex flex-col w-full lg:w-1/2">
              <mat-card>
                <mat-card-title>
                  Contact Information
                </mat-card-title>
                <mat-card-content>
                  <div class="flex flex-col gap-2">
                    <div class="flex flex-col lg:flex-row gap-2">
                      <div class="flex flex-col gap-2 w-full lg:w-1/2">
                        <span id="primaryPhoneLabel" class="f-s-16"><strong>Primary Phone</strong></span>
                        <mat-form-field>
                          <input matInput placeholder="Phone" formControlName="phone" mask="(000) 000-0000 000000" [validation]="false" aria-describedby="primaryPhoneLabel">
                          <mat-error role="alert" *ngIf="applicantForm.get('phone').hasError('required')"> Error: A primary phone number is required
                          </mat-error>
                          <mat-error role="alert" *ngIf="applicantForm.get('phone').hasError('pattern')"> Error: Phone should match this format: 999-999-9999 x1234
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="flex flex-col gap-2 w-full lg:w-1/2">
                        <span id="alternatePhoneLabel" class="f-s-16"><strong>Alternate Phone</strong></span>
                        <mat-form-field>
                          <input matInput placeholder="Alt Phone" formControlName="alternatePhone" mask="(000) 000-0000 000000" [validation]="false" aria-describedby="alternatePhoneLabel">
                          <mat-error role="alert" *ngIf="applicantForm.get('alternatePhone').hasError('pattern')"> Error: Phone should match this format: 999-999-9999 x1234
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <div class="flex flex-col lg:flex-row gap-2">
                      <div class="flex flex-col gap-2 w-full lg:w-1/2">
                        <span id="primaryEmailLabel" class="f-s-16"><strong>Primary Email Address</strong></span>
                        <mat-form-field>
                          <input matInput placeholder="Email" formControlName="email" aria-describedby="primaryEmailLabel">
                          <mat-error role="alert" *ngIf="applicantForm.get('email').hasError('required')"> Error: Please enter an email adress
                          </mat-error>
                          <mat-error role="alert" *ngIf="applicantForm.get('email').hasError('email')"> Error: This doesn't look like a valid email address
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="flex flex-col gap-2 w-full lg:w-1/2">
                        <span id="confirmEmailLabel" class="f-s-16"><strong>Confirm Email Address</strong></span>
                        <mat-form-field>
                          <input matInput placeholder="Confirm Email" formControlName="confirmEmail" aria-describedby="confirmEmailLabel">
                          <mat-error role="alert" *ngIf="validateEmail()"> Error: Email does not match
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <div class="flex flex-col lg:flex-row gap-2">
                      <div class="flex flex-col gap-2 w-full lg:w-1/2">
                        <span id="preferredLanguageLabel" class="f-s-16"><strong>Preferred Language</strong></span>
                        <mat-form-field>
                          <input matInput placeholder="Language" formControlName="language" aria-describedby="preferredLanguageLabel">
                        </mat-form-field>
                      </div>
                    </div>

                    <div class="flex flex-col">
                      <span class="f-s-16"><strong>Other OPS Licenses or Permits</strong></span>
                      <mat-checkbox formControlName="previousLicense" (change)="validatePreviousLicense()">
                        Check the box if the applicant applied for or received any other licenses or permits from Oregon Psilocybin Services
                      </mat-checkbox>
                      <div class="m-t-8 flex flex-col" *ngIf="this.applicantForm.get('previousLicense').value">
                        <span id="affiliatedLicensesLabel"`>Please provide the license id(s) for each Oregon Psilocybin Services license.</span>
                        <mat-form-field>
                          <input matInput formControlName="affiliatedLicenses" aria-describedby="affiliatedLicensesLabel">
                          <mat-label style="color:red" *ngIf="applicantForm.get('affiliatedLicenses').value == ''">Affiliated Licenses*</mat-label>
                          <mat-label style="color:grey" *ngIf="applicantForm.get('affiliatedLicenses').value != ''">Affiliated Licenses</mat-label>
                          <mat-error role="alert" *ngIf="validatePreviousLicense()"> Error: Please provide all license numbers
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>

              <mat-card *ngIf="showRequiredApplicantDataAttestation(facilitatorLicense.applicationDate)">
                <mat-card-title class="f-s-16">
                  Required 303 Applicant and Licensee REAL & SOGI Data
                </mat-card-title>
                <mat-card-content>
                  <div class="flex flex-col gap-2 f-s-16">
                    <span>Senate Bill 303 (SB 303) was adopted by the Oregon Legislature in 2023 and is now codified in
                      <a  href="https://www.oregonlegislature.gov/bills_laws/ors/ors475A.html#:~:text=475A.372%20Requirement%20of%20psilocybin%20service%20center%20operator%20to%20collect%2c%20maintain%2c%20aggregate%20and%20submit%20to%20Oregon%20Health%20Authority%20specified%20information"
                        target="_blank" rel="noreferrer noopener" style="word-break: break-all; white-space: normal;">ORS 475A.372</a>
                      and
                      <a  href="https://www.oregonlegislature.gov/bills_laws/ors/ors475A.html#:~:text=475A.374%20Oregon%20Health%20Authority%20collection%2c%20publication%20of%20certain%20data%3b%20rules."
                        target="_blank" rel="noreferrer noopener" style="word-break: break-all; white-space: normal;">ORS 475A.374</a>
                      . SB 303 requires Oregon Psilocybin Services (OPS) to collect and compile information about OPS license applicants and licensees. The 303 Applicant Data is kept separate from your application materials and will not be used to make any decisions related to your license application.
                    </span>
                    <span>All initial and renewal applicants are required to click the link below and complete the questions as part of the OPS application process: </span>
                    <a routerLink="/applicant-data"  target="_blank">https://psilocybin.oregon.gov/applicant-data</a>

                    <span>By signing below, the applicant hereby attests and confirms that:</span>
                    <ul>
                      <li>The Required 303 Applicant and Licensee REAL & SOGI Data form has been completed and submitted in accordance with applicable Oregon Administrative Rules (OAR).</li>
                      <li>The information provided on the Required 303 Applicant and Licensee REAL & SOGI Data form is true, accurate, and complete to the best of the applicant's knowledge at the time of submission.</li>
                      <li>The applicant understands that submission of this form is a required component of the licensure or application process under ORS Chapter 475A and applicable to OAR 333-333.</li>
                      <li>The applicant acknowledges that providing false information may result in administrative penalties.</li>
                    </ul>
                    <span><strong>Signature:</strong></span>
                    <mat-form-field class="flex md:w-1/2 w-full">
                      <mat-label>Signature</mat-label>
                      <input matInput placeholder="Signature" formControlName="realSogiSignature" aria-describedby="realSogiSignature">
                      <mat-error role="alert" *ngIf="applicantForm.get('realSogiSignature').invalid"> Error: Please provide a signature
                      </mat-error>
                    </mat-form-field>
                    <span><strong>Date 303 Applicant and Licensee REAL & SOGI Data form was submitted:</strong></span>
                    <mat-form-field class="flex md:w-1/2 w-full">
                      <mat-label>Date Submitted</mat-label>
                      <input placeholder="mm/dd/yyyy" formControlName="realSogiDate" matInput [matDatepicker]="realSogiDate"/>
                      <mat-datepicker-toggle matSuffix [for]="realSogiDate"></mat-datepicker-toggle>
                      <mat-datepicker #realSogiDate>
                        <mat-datepicker-actions>
                          <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                          <button mat-button matDatepickerCancel>Cancel</button>
                        </mat-datepicker-actions>
                      </mat-datepicker>
                      <mat-error role="alert" *ngIf="applicantForm.get('realSogiDate').invalid"> Error: Please provide a date for when the Applicant and Licensee REAL & SOGI Data form was submitted
                      </mat-error>
                    </mat-form-field>


                  </div>
                </mat-card-content>
              </mat-card>

              <mat-card>
                <mat-card-title>Address</mat-card-title>
                <mat-card-content>
                  <div class="flex flex-col">
                    <span id="physicalAddressLabel"><strong class="f-s-16">Physical Address</strong></span>
                    <div class="flex flex-col md:flex-row gap-4">
                      <mat-form-field class="w-full md:w-[50%]">
                        <input matInput placeholder="Street Apt/Unit/Suite" formControlName="physicalStreet" aria-describedby="physicalAddressLabel">
                        <mat-error role="alert" *ngIf="applicantForm.get('physicalStreet').invalid"> Error: Please provide a street
                        </mat-error>
                      </mat-form-field>

                      <mat-form-field class="w-full md:w-[50%]">
                        <input matInput placeholder="City" formControlName="physicalCity" aria-describedby="physicalAddressLabel">
                        <mat-error role="alert" *ngIf="applicantForm.get('physicalCity').invalid"> Error: Please provide a city
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="flex flex-col md:flex-row gap-4">
                      <mat-form-field class="w-full">
                        <mat-label>State/US territory/freely associated state</mat-label>
                        <mat-select formControlName="physicalState">
                          <mat-option *ngFor="let state of sharedService.states" value={{state}}>{{state}}</mat-option>
                        </mat-select>
                        <mat-error role="alert" *ngIf="applicantForm.get('physicalState').invalid"> Error: Please provide a state, US territory or freely associated state
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="flex flex-col md:flex-row gap-4">
                      <mat-form-field class="w-full md:w-[40%]">
                        <input matInput placeholder="Zip" formControlName="physicalZip" aria-describedby="physicalAddressLabel">
                        <mat-error role="alert" *ngIf="applicantForm.get('physicalZip').hasError('required')"> Error: Please provide a zipcode
                        </mat-error>
                        <mat-error role="alert" *ngIf="applicantForm.get('physicalZip').hasError('pattern')"> Error: Zipcode should match this format: 99999 or 99999-1234
                        </mat-error>
                      </mat-form-field>

                      <mat-form-field *ngIf="applicantForm.get('physicalState').value === 'OR'" class="w-full md:w-[40%]">
                        <mat-label>County</mat-label>
                        <mat-select formControlName="physicalCounty">
                          <mat-option>-- None --</mat-option>
                          <mat-option *ngFor="let county of sharedService.counties" value={{county}}>{{county}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="m-t-8 flex flex-col f-s-16">
                    <div class="flex flex-row gap-6 items-center">
                      <span id="mailingAddressLabel"><strong>Mailing Address</strong></span>
                      <mat-checkbox formControlName="mailingIsPhysical" (change)="mailingIsSame()">
                        Same as physical
                      </mat-checkbox>
                    </div>
                    <div [@slideInOut] *ngIf="!applicantForm.get('mailingIsPhysical').value" class="flex flex-col">
                      <div class="flex flex-col md:flex-row gap-4">
                        <mat-form-field class="w-full md:w-[50%]">
                          <input matInput placeholder="Street Apt/Unit/Suite" formControlName="mailingStreet"
                            (blur)="validateMailingStreet()" aria-describedby="mailingAddressLabel">
                          <mat-error role="alert" *ngIf="validateMailingStreet()"> Error: Please provide a street
                          </mat-error>
                        </mat-form-field>

                        <mat-form-field class="w-full md:w-[50%]">
                          <input matInput placeholder="City" formControlName="mailingCity" (blur)="validateMailingCity()" aria-describedby="mailingAddressLabel">
                          <mat-error role="alert" *ngIf="validateMailingCity()"> Error: Please provide a city
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="flex flex-col md:flex-row gap-4">
                        <mat-form-field class="w-full">
                          <mat-label>State/US territory/freely associated state</mat-label>
                          <mat-select formControlName="mailingState" (blur)="validateMailingState()">
                            <mat-option *ngFor="let state of sharedService.states" value={{state}}>{{state}}</mat-option>
                          </mat-select>
                          <mat-error role="alert" *ngIf="validateMailingState()"> Error: Please provide a state, US territory or freely associated state
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="flex flex-col md:flex-row gap-4">
                        <mat-form-field class="w-full md:w-[40%]">
                          <input matInput placeholder="Zip" formControlName="mailingZip" (blur)="validateMailingZip()" aria-describedby="mailingAddressLabel">
                          <mat-error role="alert" *ngIf="validateMailingZip()"> Error: Please provide a zipcode
                          </mat-error>
                          <mat-error role="alert" *ngIf="applicantForm.get('mailingZip').hasError('pattern')"> Error: Zipcode should match this format: 99999 or 99999-1234
                          </mat-error>
                        </mat-form-field>

                        <mat-form-field *ngIf="applicantForm.get('mailingState').value === 'OR'" class="w-full md:w-[40%]">
                          <mat-label>County</mat-label>
                          <mat-select formControlName="mailingCounty">
                            <mat-option>-- None --</mat-option>
                            <mat-option *ngFor="let county of sharedService.counties" value={{county}}>{{county}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>

                  <app-residential-history [applicantId]="facilitatorLicense.applicants[0]?.id"
                                           [residentialHistory]="facilitatorLicense.applicants[0]?.residentialHistory"
                                           [licenseLocked]="licenseLocked">
                  </app-residential-history>
                </mat-card-content>
              </mat-card>

              <mat-card *ngIf="sharedService.isAfterJan1st()">
                <mat-card-title>Licensed By</mat-card-title>
                <mat-card-content>
                  <div class="flex flex-col gap-3 f-s-16">
                    <span>Are you licensed by the boards listed below?</span>

                    <mat-card class="flex flex-col gap-2" *ngIf="sharedService.isAfterJan1st2027()">
                      <span id="occupationalTherapyLicensingBoard" class="text-wrap" [ngStyle]="{'color': (applicantForm.get('occupationalTherapyLicensingBoard').value == null && sharedService.isAfterJan1st2027())? 'red' : ''}">The Occupational Therapy Licensing Board</span>
                      <mat-radio-group aria-label="Select an option" formControlName="occupationalTherapyLicensingBoard" aria-describedby="occupationalTherapyLicensingBoard" class="gap-2">
                        <mat-radio-button [value]="true"><span class="f-s-16">Yes</span> </mat-radio-button>
                        <mat-radio-button [value]="false"><span class="f-s-16">No</span></mat-radio-button>
                      </mat-radio-group>
                      <mat-form-field *ngIf="applicantForm.get('occupationalTherapyLicensingBoard').value" class="w-full lg:w-[75%]">
                        <textarea matInput placeholder="License Number" cols="2" formControlName="occupationalTherapyLicensingBoardLicenseNumber" aria-describedby="occupationalTherapyLicensingBoard"></textarea>
                        <mat-error role="alert" *ngIf="validateOccupationalTherapyLicensingBoardLicenseNumber()"> Error: This field is required</mat-error>
                      </mat-form-field>
                      <mat-form-field *ngIf="applicantForm.get('occupationalTherapyLicensingBoard').value">
                        <mat-label>Expiration date of license</mat-label>
                        <input placeholder="mm/dd/yyyy" formControlName="occupationalTherapyLicensingBoardExpirationDate" matInput [matDatepicker]="occupationalTherapyLicensingBoardExpirationDate"/>
                        <mat-datepicker-toggle matSuffix [for]="occupationalTherapyLicensingBoardExpirationDate"></mat-datepicker-toggle>
                        <mat-datepicker #occupationalTherapyLicensingBoardExpirationDate>
                          <mat-datepicker-actions>
                            <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                            <button mat-button matDatepickerCancel>Cancel</button>
                          </mat-datepicker-actions>
                        </mat-datepicker>
                        <mat-error role="alert" *ngIf="validateOccupationalTherapyLicensingBoardExpirationDate()"> Error: This field is required</mat-error>
                      </mat-form-field>
                    </mat-card>

                    <mat-card class="flex flex-col gap-2">
                      <span id="boardOfLicensedCounselors" class="text-wrap" [ngStyle]="{'color': (applicantForm.get('boardOfLicensedCounselors').value == null && sharedService.isAfterJan1st())? 'red' : ''}">The Oregon Board of Licensed Professional Counselors and Therapists</span>
                      <mat-radio-group aria-label="Select an option" formControlName="boardOfLicensedCounselors" aria-describedby="boardOfLicensedCounselors" class="gap-2">
                        <mat-radio-button [value]="true"><span class="f-s-16">Yes</span> </mat-radio-button>
                        <mat-radio-button [value]="false"><span class="f-s-16">No</span></mat-radio-button>
                      </mat-radio-group>
                      <mat-form-field *ngIf="applicantForm.get('boardOfLicensedCounselors').value" class="w-full lg:w-[75%]">
                        <textarea matInput placeholder="License Number" cols="2" formControlName="boardOfLicensedCounselorsLicenseNumber" aria-describedby="boardOfLicensedCounselors"></textarea>
                        <mat-error role="alert" *ngIf="validateBoardOfLicensedCounselorsLicenseNumber()"> Error: This field is required</mat-error>
                      </mat-form-field>
                      <mat-form-field *ngIf="applicantForm.get('boardOfLicensedCounselors').value">
                        <mat-label>Expiration date of license</mat-label>
                        <input placeholder="mm/dd/yyyy" formControlName="boardOfLicensedCounselorsExpirationDate" matInput [matDatepicker]="boardOfLicensedCounselorsExpirationDate"/>
                        <mat-datepicker-toggle matSuffix [for]="boardOfLicensedCounselorsExpirationDate"></mat-datepicker-toggle>
                        <mat-datepicker #boardOfLicensedCounselorsExpirationDate>
                          <mat-datepicker-actions>
                            <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                            <button mat-button matDatepickerCancel>Cancel</button>
                          </mat-datepicker-actions>
                        </mat-datepicker>
                        <mat-error role="alert" *ngIf="validateBoardOfLicensedCounselorsExpirationDate()"> Error: This field is required</mat-error>
                      </mat-form-field>
                    </mat-card>

                    <mat-card class="flex flex-col gap-2">
                      <span id="boardOfNaturopathic" class="text-wrap" [ngStyle]="{'color': (applicantForm.get('boardOfNaturopathic').value == null && sharedService.isAfterJan1st()) ? 'red' : ''}">The Oregon Board of Naturopathic Medicine</span>
                      <mat-radio-group aria-label="Select an option" formControlName="boardOfNaturopathic" aria-describedby="boardOfNaturopathic" class="gap-2">
                        <mat-radio-button [value]="true"><span class="f-s-16">Yes</span></mat-radio-button>
                        <mat-radio-button [value]="false"><span class="f-s-16">No</span></mat-radio-button>
                      </mat-radio-group>

                      <mat-form-field *ngIf="applicantForm.get('boardOfNaturopathic').value" class="w-full lg:w-[75%]">
                        <textarea matInput placeholder="License Number" cols="2" formControlName="boardOfNaturopathicLicenseNumber" aria-describedby="boardOfNaturopathic"></textarea>
                        <mat-error role="alert" *ngIf="validateBoardOfNaturopathicLicenseNumber()"> Error: This field is required</mat-error>
                      </mat-form-field>

                      <mat-form-field *ngIf="applicantForm.get('boardOfNaturopathic').value">
                        <mat-label>Expiration date of license</mat-label>
                        <input placeholder="mm/dd/yyyy" formControlName="boardOfNaturopathicExpirationDate" matInput [matDatepicker]="boardOfNaturopathicExpirationDate"/>
                        <mat-datepicker-toggle matSuffix [for]="boardOfNaturopathicExpirationDate"></mat-datepicker-toggle>
                        <mat-datepicker #boardOfNaturopathicExpirationDate>
                          <mat-datepicker-actions>
                            <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                            <button mat-button matDatepickerCancel>Cancel</button>
                          </mat-datepicker-actions>
                        </mat-datepicker>
                        <mat-error role="alert" *ngIf="validateBoardOfNaturopathicExpirationDate()"> Error: This field is required</mat-error>
                      </mat-form-field>
                    </mat-card>

                    <mat-card class="flex flex-col gap-2" *ngIf="sharedService.isAfterJan1st2027()">
                      <span id="boardOfPhysicalTherapy" class="text-wrap" [ngStyle]="{'color': (applicantForm.get('boardOfPhysicalTherapy').value == null && sharedService.isAfterJan1st2027())? 'red' : ''}">The Oregon Board of Physical Therapy</span>
                      <mat-radio-group aria-label="Select an option" formControlName="boardOfPhysicalTherapy" aria-describedby="boardOfPhysicalTherapy" class="gap-2">
                        <mat-radio-button [value]="true"><span class="f-s-16">Yes</span> </mat-radio-button>
                        <mat-radio-button [value]="false"><span class="f-s-16">No</span></mat-radio-button>
                      </mat-radio-group>
                      <mat-form-field *ngIf="applicantForm.get('boardOfPhysicalTherapy').value" class="w-full lg:w-[75%]">
                        <textarea matInput placeholder="License Number" cols="2" formControlName="boardOfPhysicalTherapyLicenseNumber" aria-describedby="boardOfPhysicalTherapy"></textarea>
                        <mat-error role="alert" *ngIf="validateBoardOfPhysicalTherapyLicenseNumber()"> Error: This field is required</mat-error>
                      </mat-form-field>
                      <mat-form-field *ngIf="applicantForm.get('boardOfPhysicalTherapy').value">
                        <mat-label>Expiration date of license</mat-label>
                        <input placeholder="mm/dd/yyyy" formControlName="boardOfPhysicalTherapyExpirationDate" matInput [matDatepicker]="boardOfPhysicalTherapyExpirationDate"/>
                        <mat-datepicker-toggle matSuffix [for]="boardOfPhysicalTherapyExpirationDate"></mat-datepicker-toggle>
                        <mat-datepicker #boardOfPhysicalTherapyExpirationDate>
                          <mat-datepicker-actions>
                            <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                            <button mat-button matDatepickerCancel>Cancel</button>
                          </mat-datepicker-actions>
                        </mat-datepicker>
                        <mat-error role="alert" *ngIf="validateBoardOfPhysicalTherapyExpirationDate()"> Error: This field is required</mat-error>
                      </mat-form-field>
                    </mat-card>

                    <mat-card class="flex flex-col gap-2">
                      <span id="medicalBoard" class="text-wrap" [ngStyle]="{'color': (applicantForm.get('medicalBoard').value == null && sharedService.isAfterJan1st()) ? 'red' : ''}">The Oregon Medical Board</span>
                      <mat-radio-group aria-label="Select an option" formControlName="medicalBoard" aria-describedby="medicalBoard" class="gap-2">
                        <mat-radio-button [value]="true"><span class="f-s-16">Yes</span></mat-radio-button>
                        <mat-radio-button [value]="false"><span class="f-s-16">No</span></mat-radio-button>
                      </mat-radio-group>


                      <mat-form-field *ngIf="applicantForm.get('medicalBoard').value" class="w-full lg:w-[75%]">
                        <textarea matInput placeholder="License Number" cols="2" formControlName="medicalBoardLicenseNumber" aria-describedby="medicalBoard"></textarea>
                        <mat-error role="alert" *ngIf="validateMedicalBoardLicenseNumber()"> Error: This field is required</mat-error>
                      </mat-form-field>

                      <mat-form-field *ngIf="applicantForm.get('medicalBoard').value">
                        <mat-label>Expiration date of license</mat-label>
                        <input placeholder="mm/dd/yyyy" formControlName="medicalBoardExpirationDate" matInput [matDatepicker]="medicalBoardExpirationDate"/>
                        <mat-datepicker-toggle matSuffix [for]="medicalBoardExpirationDate"></mat-datepicker-toggle>
                        <mat-datepicker #medicalBoardExpirationDate>
                          <mat-datepicker-actions>
                            <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                            <button mat-button matDatepickerCancel>Cancel</button>
                          </mat-datepicker-actions>
                        </mat-datepicker>
                        <mat-error role="alert" *ngIf="validateMedicalBoardExpirationDate()"> Error: This field is required</mat-error>
                      </mat-form-field>
                    </mat-card>

                    <mat-card class="flex flex-col gap-2">
                      <span id="boardOfPsychology" class="text-wrap" [ngStyle]="{'color': (applicantForm.get('boardOfPsychology').value == null && sharedService.isAfterJan1st()) ? 'red' : ''}">The Oregon Board of Psychology</span>
                      <mat-radio-group aria-label="Select an option" formControlName="boardOfPsychology" aria-describedby="boardOfPsychology" class="gap-2">
                        <mat-radio-button [value]="true"><span class="f-s-16">Yes</span></mat-radio-button>
                        <mat-radio-button [value]="false"><span class="f-s-16">No</span></mat-radio-button>
                      </mat-radio-group>


                      <mat-form-field *ngIf="applicantForm.get('boardOfPsychology').value" class="w-full lg:w-[75%]">
                        <textarea matInput placeholder="License Number" cols="2" formControlName="boardOfPsychologyLicenseNumber" aria-describedby="boardOfPsychology"></textarea>
                        <mat-error role="alert" *ngIf="validateBoardOfPsychologyLicenseNumber()"> Error: This field is required</mat-error>
                      </mat-form-field>

                      <mat-form-field *ngIf="applicantForm.get('boardOfPsychology').value">
                        <mat-label>Expiration date of license</mat-label>
                        <input placeholder="mm/dd/yyyy" formControlName="boardOfPsychologyExpirationDate" matInput [matDatepicker]="boardOfPsychologyExpirationDate"/>
                        <mat-datepicker-toggle matSuffix [for]="boardOfPsychologyExpirationDate"></mat-datepicker-toggle>
                        <mat-datepicker #boardOfPsychologyExpirationDate>
                          <mat-datepicker-actions>
                            <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                            <button mat-button matDatepickerCancel>Cancel</button>
                          </mat-datepicker-actions>
                        </mat-datepicker>
                        <mat-error role="alert" *ngIf="validateBoardOfPsychologyExpirationDate()"> Error: This field is required</mat-error>
                      </mat-form-field>
                    </mat-card>

                    <mat-card class="flex flex-col gap-2">
                      <span id="boardOfNursing" class="text-wrap" [ngStyle]="{'color': (applicantForm.get('boardOfNursing').value == null && sharedService.isAfterJan1st()) ? 'red' : ''}">The Oregon State Board of Nursing</span>
                      <mat-radio-group aria-label="Select an option" formControlName="boardOfNursing" aria-describedby="boardOfNursing" class="gap-2">
                        <mat-radio-button [value]="true"><span class="f-s-16">Yes</span></mat-radio-button>
                        <mat-radio-button [value]="false"><span class="f-s-16">No</span></mat-radio-button>
                      </mat-radio-group>

                      <mat-form-field *ngIf="applicantForm.get('boardOfNursing').value" class="w-full lg:w-[75%]">
                        <textarea matInput placeholder="License Number" cols="2" formControlName="boardOfNursingLicenseNumber" aria-describedby="boardOfNursing"></textarea>
                        <mat-error role="alert" *ngIf="validateBoardOfNursingLicenseNumber()"> Error: This field is required</mat-error>
                      </mat-form-field>

                      <mat-form-field *ngIf="applicantForm.get('boardOfNursing').value">
                        <mat-label>Expiration date of license</mat-label>
                        <input placeholder="mm/dd/yyyy" formControlName="boardOfNursingExpirationDate" matInput [matDatepicker]="boardOfNursingExpirationDate"/>
                        <mat-datepicker-toggle matSuffix [for]="boardOfNursingExpirationDate"></mat-datepicker-toggle>
                        <mat-datepicker #boardOfNursingExpirationDate>
                          <mat-datepicker-actions>
                            <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                            <button mat-button matDatepickerCancel>Cancel</button>
                          </mat-datepicker-actions>
                        </mat-datepicker>
                        <mat-error role="alert" *ngIf="validateBoardOfNursingExpirationDate()"> Error: This field is required</mat-error>
                      </mat-form-field>
                    </mat-card>

                    <mat-card class="flex flex-col gap-2">
                      <span id="boardOfSocialWorkers" class="text-wrap" [ngStyle]="{'color': (applicantForm.get('boardOfSocialWorkers').value == null && sharedService.isAfterJan1st()) ? 'red' : ''}">The State Board of Licensed Social Workers</span>
                      <mat-radio-group aria-label="Select an option" formControlName="boardOfSocialWorkers" aria-describedby="boardOfSocialWorkers" class="gap-2">
                        <mat-radio-button [value]="true"><span class="f-s-16">Yes</span> </mat-radio-button>
                        <mat-radio-button [value]="false"><span class="f-s-16">No</span></mat-radio-button>
                      </mat-radio-group>

                      <mat-form-field *ngIf="applicantForm.get('boardOfSocialWorkers').value" class="w-full lg:w-[75%]">
                        <textarea matInput placeholder="License Number" cols="2" formControlName="boardOfSocialWorkersLicenseNumber" aria-describedby="boardOfSocialWorkers"></textarea>
                        <mat-error role="alert" *ngIf="validateBoardOfSocialWorkersLicenseNumber()"> Error: This field is required</mat-error>
                      </mat-form-field>

                      <mat-form-field *ngIf="applicantForm.get('boardOfSocialWorkers').value">
                        <mat-label>Expiration date of license</mat-label>
                        <input placeholder="mm/dd/yyyy" formControlName="boardOfSocialWorkersExpirationDate" matInput [matDatepicker]="boardOfSocialWorkersExpirationDate"/>
                        <mat-datepicker-toggle matSuffix [for]="boardOfSocialWorkersExpirationDate"></mat-datepicker-toggle>
                        <mat-datepicker #boardOfSocialWorkersExpirationDate>
                          <mat-datepicker-actions>
                            <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                            <button mat-button matDatepickerCancel>Cancel</button>
                          </mat-datepicker-actions>
                        </mat-datepicker>
                        <mat-error role="alert" *ngIf="validateBoardOfSocialWorkersExpirationDate()"> Error: This field is required</mat-error>
                      </mat-form-field>
                    </mat-card>

                    <mat-card class="flex flex-col gap-2">
                      <span id="boardOfPharmacy" class="text-wrap" [ngStyle]="{'color': (applicantForm.get('boardOfPharmacy').value == null && sharedService.isAfterJan1st()) ? 'red' : ''}">The State Board of Pharmacy</span>
                      <mat-radio-group aria-label="Select an option" formControlName="boardOfPharmacy" aria-describedby="boardOfPharmacy" class="gap-2">
                        <mat-radio-button [value]="true"><span class="f-s-16">Yes</span></mat-radio-button>
                        <mat-radio-button [value]="false"><span class="f-s-16">No</span></mat-radio-button>
                      </mat-radio-group>

                      <mat-form-field *ngIf="applicantForm.get('boardOfPharmacy').value" class="w-full lg:w-[75%]">
                        <textarea matInput placeholder="License Number" cols="2" formControlName="boardOfPharmacyLicenseNumber"></textarea>
                        <mat-error role="alert" *ngIf="validateBoardOfPharmacyLicenseNumber()"> Error: This field is required</mat-error>
                      </mat-form-field>

                      <mat-form-field *ngIf="applicantForm.get('boardOfPharmacy').value">
                        <mat-label>Expiration date of license</mat-label>
                        <input placeholder="mm/dd/yyyy" formControlName="boardOfPharmacyExpirationDate" matInput [matDatepicker]="boardOfPharmacyExpirationDate"/>
                        <mat-datepicker-toggle matSuffix [for]="boardOfPharmacyExpirationDate"></mat-datepicker-toggle>
                        <mat-datepicker #boardOfPharmacyExpirationDate>
                          <mat-datepicker-actions>
                            <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                            <button mat-button matDatepickerCancel>Cancel</button>
                          </mat-datepicker-actions>
                        </mat-datepicker>
                        <mat-error role="alert" *ngIf="validateBoardOfPharmacyExpirationDate()"> Error: This field is required</mat-error>
                      </mat-form-field>
                    </mat-card>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </div>

          <div class="flex flex-col 2xl:flex-row gap-2">
            <mat-card class="w-full 2xl:w-1/2">
              <mat-card-title>
                <span *ngIf="applicantDocumentsValid && showOregonResidency(facilitatorLicense.applicationDate)">
                  Identity and Residency Verification
                </span>
                <span *ngIf="!applicantDocumentsValid && showOregonResidency(facilitatorLicense.applicationDate)" class="text-red-400">
                  Identity and Residency Verification Incomplete
                </span>
                <span *ngIf="applicantDocumentsValid && !showOregonResidency(facilitatorLicense.applicationDate)">
                  Identity Verification
                </span>
                <span *ngIf="!applicantDocumentsValid && !showOregonResidency(facilitatorLicense.applicationDate)" class="text-red-400">
                  Identity Verification Incomplete
                </span>
              </mat-card-title>
              <mat-card-content>
                <div *ngIf="showOregonResidency(facilitatorLicense.applicationDate)" class="flex flex-row">
                <mat-checkbox formControlName="oregonResidency">
                  <span class="text-wrap">I certify that I am a current Oregon resident and have been a resident of Oregon for two or more years</span>
                  <mat-error role="alert" *ngIf="applicantForm.get('oregonResidency').hasError('required') && applicantForm.get('oregonResidency').touched"> Error: You must attest to being an Oregon resident
                  </mat-error>
                </mat-checkbox>
              </div>
              <div class="flex flex-row">
                <mat-checkbox formControlName="highSchoolDiploma">
                  <span class="text-wrap f-s-16">I certify I have a high school diploma or equivalent education as required by ORS 475A.325 (2)(d)</span>
                  <mat-error role="alert" *ngIf="applicantForm.get('highSchoolDiploma').hasError('required') && applicantForm.get('highSchoolDiploma').touched"> Error: You must attest to having a high school diploma or equivalent education
                  </mat-error>
                </mat-checkbox>
              </div>
                <div style="padding-top: 2em" class="flex flex-col f-s-16">
                  <span>You must upload a copy of the <strong><i>front and back</i></strong> of a valid, unexpired government-issued photo identification. Accepted identification includes:</span>
                  <ul>
                    <li>
                      Passport;
                    </li>
                    <li>
                      Driver license, whether issued by the State of Oregon or by another state of the United States - <i>front and back</i>;
                    </li>
                    <li>
                      Identification card issued under ORS 807.400 - <i>front and back</i>;
                    </li>
                    <li>
                      United States military identification card - <i>front and back</i>;
                    </li>
                    <li>
                      An identification card issued by a federally recognized Indian tribe with photo, name and date of birth - <i>front and back</i>; or
                    </li>
                    <li>
                      Any other identification card issued by a state or territory that bears a picture of the person,
                      the name of the person, the person's date of birth and a physical description of the person - <i>front and back</i>
                    </li>
                  </ul>

                  <div class="m-t-8 flex flex-col gap-2">
                    <span class="f-s-14" [ngClass]="applicantDocumentsValid ? '' : 'text-red-400'">Upload Your Identification</span>
                    <input type="file" accept=".doc,.docx,.rtf,.xls,.xlsx,.pdf,.txt,.png,.jpg,.jpeg,.bmp,.mp4" class="file-input" (change)="uploadApplicantDocument($event)"
                      #applicantFileUpload />
                    <div class="flex flex-row gap-2">
                      <div class="file-upload">
                        <button type="button" [disabled]="licenseLocked"
                          mat-raised-button color="primary" class="upload-btn" (click)="applicantFileUpload.click()">
                          Browse
                          <mat-icon>attach_file</mat-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
            <mat-card class="w-full lg:w-1/2">
              <mat-card-title>
                <span>Current Documents</span>
              </mat-card-title>
              <mat-card-content>
                <div class="flex flex-col gap-2 f-s-16">
                  <div *ngIf="!sharedService.mobile" class="flex flex-row md:items-center">
                    <div class="flex w-full md:w-1/2">
                      <span class="f-s-16"><strong>File</strong></span>
                    </div>
                    <div class="flex w-full md:w-1/2 md:flex-row md:items-center md:justify-between">
                      <div class="flex flex-col md:w-[70%]">
                        <span class="f-s-16"><strong>Requirement</strong></span>
                      </div>
                      <div class="flex items-center justify-end">
                      </div>
                    </div>
                  </div>
                  <ng-container *ngFor="let document of facilitatorLicense.applicants[0]?.applicantDocuments">
                    <div class="flex flex-col gap-2 border-b border-gray-200 py-2 last:border-b-0 md:flex-row md:items-center">
                      <div class="flex w-full flex-col md:w-1/2">
                        <span *ngIf="sharedService.mobile" class="f-s-14"><strong>File</strong></span>
                        <span class="w-full break-words text-indigo-A700 f-s-16" style="cursor: pointer" (click)="downloadDocument(document.id, document.name, true)" title="{{document.name}}">{{document.name.length > 15 ? document.name.substring(0,15) + "..." : document.name}}</span>
                      </div>
                      <div class="flex w-full flex-col gap-2 md:w-1/2 md:flex-row md:items-center md:justify-between">
                        <div class="flex flex-col break-words md:w-[70%] f-s-16">
                          <span *ngIf="sharedService.mobile" class="f-s-14"><strong>Requirement</strong></span>
                          <span *ngFor="let type of document.types">
                            {{documentTypeReference[type]}}
                          </span>
                        </div>
                        <div class="flex items-center justify-start md:justify-end">
                          <button *ngIf="!licenseLocked" type="button" mat-icon-button class="m-8" (click)="deleteFile(document.id, document.name, true)"
                            color="warn" aria-label="Delete">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
        </div>
      </form>

      <div class="p-t-16 flex sm:flex-row flex-col gap-2 w-full md:w-1/2">
        <button mat-raised-button matStepperPrevious>{{!licenseLocked? "Save and " : ""}}Back</button>
        <button mat-raised-button matStepperNext>{{!licenseLocked? "Save and " : ""}}Continue</button>
      </div>
    </mat-step>

    <!--Documents-->
    <mat-step [stepControl]="documentsForm" *ngIf="facilitatorLicenses.length > 0">
      <form [formGroup]="documentsForm">
        <ng-template matStepLabel>

          <span *ngIf="((documentsForm.valid && licenseDocumentsValid) || documentsForm.pristine || licenseLocked)"
            matTooltip="Documents" matTooltipPosition="below" [matTooltipShowDelay]="500">Documents</span>

          <span class="text-red-400" *ngIf="((!documentsForm.valid && !documentsForm.pristine) || !licenseDocumentsValid) && !licenseLocked"
            matTooltip="Documents Incomplete" matTooltipPosition="below" [matTooltipShowDelay]="500">Documents Incomplete</span>

          </ng-template>
        <div class="flex flex-col gap-2">
          <div class="flex flex-col lg:flex-row">
            <mat-card class="w-full">
              <mat-card-title>
                The following documentation is required to apply for a Psilocybin Facilitator License:
              </mat-card-title>
              <mat-card-content>
                <ul class="p-b-8 flex flex-col gap-2 f-s-16">
                  <li class="f-s-16" *ngIf="!sharedService.isAfterJan1st2027()">A copy of your certificate of completion from a psilocybin facilitator training program with an OPS approved curriculum</li>
                  <div style="padding-left: 2em" class="flex flex-col" *ngIf="!sharedService.isAfterJan1st2027()">
                    <li class="f-s-16">Please note: the facilitator training program must have an OPS approved curriculum </li>
                  </div>
                  <li class="f-s-16" *ngIf="sharedService.isAfterJan1st2027()">A copy of your certificate of completion from a psilocybin facilitator training program with OPS-approved curriculum or by an out-of-state training program that meets or exceeds OPS curriculum. Currently the only other state that meets or exceeds OPS curriculum is the State of Colorado</li>
                  <li class="f-s-16">Social Equity Plan </li>
                  <li class="f-s-16">If you are requesting a reduced licensing fee, please upload one of the following required supporting documents:</li>

                  <div style="padding-left: 2em" class="flex flex-col">
                    <li class="f-s-16">A copy of a current monthly Supplemental Security Income benefit statement showing dates of coverage</li>
                  </div>
                  <div style="padding-left: 2em" class="flex flex-col">
                    <li class="f-s-16">A copy of the applicant's current eligibility statement or card if enrolled in Oregon Health Plan</li>
                  </div>
                  <div style="padding-left: 2em" class="flex flex-col">
                    <li class="f-s-16">A copy of current proof of food stamp benefits from the Oregon Supplemental Nutrition Assistance Program </li>
                  </div>
                  <div style="padding-left: 2em" class="flex flex-col">
                    <li class="f-s-16">A copy of proof of having served in the Armed Forces, such as but not limited to, submitting a Veteran's Administration form DD-214</li>
                  </div>
                </ul>
              </mat-card-content>
            </mat-card>
          </div>

          <div class="flex flex-col 2xl:flex-row gap-4 w-full">
            <mat-card class="w-full 2xl:w-1/2">
              <mat-card-title>
                Upload Supporting Documents
              </mat-card-title>
              <mat-card-content>
                <div class="flex flex-col gap-2 f-s-16">
                  <span class="f-2-16">For each document select the requirements it verifies</span>
                  <div class="p-t-8 flex flex-col gap-2">

                    <div class="flex flex-col">
                      <mat-checkbox formControlName="trainingCertificate" [labelPosition]="'before'">
                       <span class="f-s-16" [ngClass]="missingTypes[trainingCertificateType]? 'text-red-400' : ''">Training Certificate</span>
                      </mat-checkbox>

                      <mat-checkbox formControlName="socialEquityPlan" [labelPosition]="'before'">
                        <span class="f-s-16" [ngClass]="missingTypes[socialEquityPlanType]? 'text-red-400' : ''">
                          Social Equity Plan
                        </span>
                      </mat-checkbox>

                      <mat-checkbox formControlName="reducedFee" [labelPosition]="'before'">
                        <span class="f-s-16" [ngClass]="missingTypes[reducedFeeType]? 'text-red-400' : ''">
                          Reduced Fee
                        </span>
                      </mat-checkbox>
                    </div>

                    <input type="file" accept=".doc,.docx,.rtf,.xls,.xlsx,.pdf,.txt,.png,.jpg,.jpeg,.bmp,.mp4" class="file-input" (change)="uploadLicenseDocument($event)" #fileUpload />
                    <div class="flex flex-row gap-2">
                      <div class="file-upload">
                        <button [disabled]="!documentsForm.get('trainingCertificate').value &&
                                            !documentsForm.get('socialEquityPlan').value &&
                                            !documentsForm.get('reducedFee').value"
                                mat-raised-button color="primary" class="upload-btn" (click)="fileUpload.click()">
                          Browse
                          <mat-icon>attach_file</mat-icon>
                        </button>
                      </div>
                    </div>

                  </div>
                </div>
              </mat-card-content>
            </mat-card>

            <mat-card class="w-full lg:w-1/2">
              <mat-card-title>
                <span *ngIf="applicantDocumentsValid">Current Documents</span>
              </mat-card-title>
              <mat-card-content>
                <div class="flex flex-col gap-2 f-s-16">
                  <div *ngIf="!sharedService.mobile" class="flex flex-row md:items-center">
                    <div class="flex w-full md:w-1/2">
                      <span class="f-s-16"><strong>File</strong></span>
                    </div>
                    <div class="flex w-full md:w-1/2 md:flex-row md:items-center md:justify-between">
                      <div class="flex flex-col md:w-[70%]">
                        <span class="f-s-16"><strong>Requirement</strong></span>
                      </div>
                      <div class="flex items-center justify-end">
                      </div>
                    </div>
                  </div>
                  <ng-container *ngFor="let document of this.facilitatorLicense.licenseDocuments">
                    <div class="flex flex-col gap-2 border-b border-gray-200 py-2 last:border-b-0 md:flex-row md:items-center">
                      <div class="flex w-full flex-col md:w-1/2">
                        <span *ngIf="sharedService.mobile" class="f-s-14"><strong>File</strong></span>
                        <span class="w-full break-words text-indigo-A700 f-s-16" style="cursor: pointer" (click)="downloadDocument(document.id, document.name, false)" title="{{document.name}}">{{document.name.length > 15 ? document.name.substring(0,15) + "..." : document.name}}</span>
                      </div>
                      <div class="flex w-full flex-col gap-2 md:w-1/2 md:flex-row md:items-center md:justify-between">
                        <div class="flex flex-col break-words md:w-[70%] f-s-16">
                          <span *ngIf="sharedService.mobile" class="f-s-14"><strong>Requirement</strong></span>
                          <span *ngFor="let type of document.types">
                            {{documentTypeReference[type]}}
                          </span>
                        </div>
                        <div class="flex items-center justify-start md:justify-end">
                          <button *ngIf="!licenseLocked" type="button" mat-icon-button class="m-8" (click)="deleteFile(document.id, document.name, false)"
                            color="warn" aria-label="Delete">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </mat-card-content>
            </mat-card>
          </div>

          <div class="flex flex-row">
            <mat-card class="w-full">
              <mat-card-title>
                Training Program Information
              </mat-card-title>
              <mat-card-content>
                <div class="flex flex-col gap-2 w-full lg:w-1/2 f-s-16">
                  <span>Name of Training Program with OHA Approved Curriculum</span>
                  <div class="flex flex-col lg:flex-row gap-2">

                    <div class="flex flex-col gap-2 md:w-[75%] w-full">

                      <mat-form-field>
                        <mat-label>Approved Training Programs</mat-label>
                        <input type="text"
                               placeholder="Training Program"
                               aria-label="Training Program"
                               matInput
                               formControlName="trainingProgram"
                               [matAutocomplete]="auto">
                        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                          <mat-option *ngFor="let trainingProgram of filteredOptions | async" [value]="trainingProgram">
                            {{trainingProgram}}
                          </mat-option>
                        </mat-autocomplete>
                        <mat-error role="alert" *ngIf="validateTrainingProgram()">
                          Error: Training Program is required
                        </mat-error>
                      </mat-form-field>
                  </div>
                  <div class="flex flex-col gap-2 md:w-[25%] w-full">
                    <mat-form-field>
                      <mat-label>Date Completed</mat-label>
                      <input placeholder="mm/dd/yyyy" formControlName="trainingDate" matInput [matDatepicker]="trainingDate"
                        [max]="sharedService.today" />
                      <mat-datepicker-toggle matSuffix [for]="trainingDate"></mat-datepicker-toggle>
                      <mat-datepicker #trainingDate>
                        <mat-datepicker-actions>
                          <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                          <button mat-button matDatepickerCancel>Cancel</button>
                        </mat-datepicker-actions>
                      </mat-datepicker>
                      <mat-error role="alert" *ngIf="documentsForm.get('trainingDate').value > sharedService.today">
                        Error: Please choose an earlier date.
                      </mat-error>
                      <mat-error role="alert" *ngIf="validateTrainingProgramDate()"> Error: Training Date is required
                      </mat-error>
                    </mat-form-field>
                    </div>
                  </div>
                </div>
                <div class="flex flex-col gap-2 w-full lg:w-1/2 f-s-16" *ngIf="sharedService.isAfterJan1st2027()">
                  <span>Name of Training Program with Out-of-State Approved Curriculum</span>
                  <div class="flex flex-col lg:flex-row gap-2">
                    <div class="flex flex-col gap-2 md:w-[75%] w-full">
                      <mat-form-field>
                        <mat-label>Out-of-State Approved Training Program</mat-label>
                        <mat-select formControlName="oosTrainingProgram"
                                    placeholder="Training Program"
                                    aria-label="Training Program">
                          <mat-option [value]="''">-- None --</mat-option>
                          <mat-option *ngFor="let oosTrainingProgram of oosTrainingPrograms" [value]="oosTrainingProgram">
                            {{oosTrainingProgram}}
                          </mat-option>
                        </mat-select>
                        <mat-error role="alert" *ngIf="validateTrainingProgram()">
                          Error: Training Program is required
                        </mat-error>
                      </mat-form-field>
                    </div>
                  <div class="flex flex-col gap-2 md:w-[25%] w-full">
                    <mat-form-field>
                      <mat-label>Date Completed</mat-label>
                      <input placeholder="mm/dd/yyyy" formControlName="oosTrainingDate" matInput [matDatepicker]="oosTrainingDate"
                        [max]="sharedService.today" />
                      <mat-datepicker-toggle matSuffix [for]="oosTrainingDate"></mat-datepicker-toggle>
                      <mat-datepicker #oosTrainingDate>
                        <mat-datepicker-actions>
                          <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                          <button mat-button matDatepickerCancel>Cancel</button>
                        </mat-datepicker-actions>
                      </mat-datepicker>
                      <mat-error role="alert" *ngIf="documentsForm.get('oosTrainingDate').value > sharedService.today">
                        Error: Please choose an earlier date.
                      </mat-error>
                      <mat-error role="alert" *ngIf="validateOosTrainingProgramDate()"> Error: Training Date is required
                      </mat-error>
                    </mat-form-field>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
      </form>
      <div class="p-t-16 flex sm:flex-row flex-col gap-2 w-full md:w-1/2">
        <button mat-raised-button matStepperPrevious>{{!licenseLocked? "Save and " : ""}}Back</button>
        <button mat-raised-button matStepperNext>{{!licenseLocked? "Save and " : ""}}Continue</button>
      </div>
    </mat-step>

    <!--Exam-->
    <mat-step *ngIf="facilitatorLicenses.length > 0">
      <ng-template matStepLabel>
        <span class="text-red-400" *ngIf="facilitatorLicense.examAttempts.length > 0 && !facilitatorLicense.passedExam && !licenseLocked"
          matTooltip="OHA Exam Incomplete" matTooltipPosition="below" [matTooltipShowDelay]="500">OHA Exam Incomplete</span>
        <span *ngIf="facilitatorLicense.examAttempts.length === 0 || facilitatorLicense.passedExam || licenseLocked" matTooltip="OHA Exam"
          matTooltipPosition="below" [matTooltipShowDelay]="500">OHA Exam</span>
      </ng-template>

      <mat-card>
        <mat-card-title>
          Facilitator Exam
        </mat-card-title>
        <mat-card-content>
          <div *ngIf="facilitatorLicense.passedExam" class="flex flex-col gap-6">
            <span *ngIf="sharedService.tablet" class="f-s-16">Exam</span>
            <div class="flex flex-col md:flex-row gap-6">
              <span class="f-s-16 w-[70%]">You have already passed the exam. Please continue through the
                application.</span>
            </div>
            <div class="flex flex-col md:flex-row gap-6">
              <span class="f-s-16 w-[70%]">You passed the exam on {{facilitatorLicense.examDate | date:
                'MM/dd/yyyy'}}</span>
            </div>
          </div>
          <div *ngIf="!facilitatorLicense.passedExam" class="flex flex-col gap-6">
            <span *ngIf="sharedService.tablet" class="f-s-16">Exam</span>

            <span class="f-s-16">Every applicant for a facilitator license must take the required OPS Regulations Exam and
              receive a passing score prior to being issued a facilitator license.
            </span>
            <ul class="flex flex-col gap-2" style="padding-left: 2em">
              <li class="f-s-16">
                A score of 75 percent is passing
              </li>
              <li class="f-s-16" >
                An applicant who does not pass the exam may retake the exam
              </li>
              <li class="f-s-16" style="padding-left: 4em">
                The exam may be retaken immediately
              </li>
              <li class="f-s-16" style="padding-left: 4em">
                There is no limit on exam retakes
              </li>
              <li class="f-s-16" style="padding-left: 2em">
                Applicants may access and refer to the statute and administrative rules found in <a  href="https://www.oregonlegislature.gov/bills_laws/ors/ors475a.html" target="_blank" rel="noreferrer noopener" style="word-break: break-all;
                white-space: normal;">ORS 475A</a> and <a  href="https://secure.sos.state.or.us/oard/displayDivisionRules.action?selectedDivision=7102" target="_blank" rel="noreferrer noopener" style="word-break: break-all;
                white-space: normal;">Oregon Administrative Rules</a> when answering exam questions. It may be helpful to have these links open prior to beginning the exam.
              </li>
              <li class="f-s-16" style="padding-left: 3em">
                <strong>Important Note: </strong>If the exam is exited before completion, the system does not currently have the ability to save the answers and we are working on it. With that, please plan for 30-60 minutes to take the exam. If you must leave the exam,
                you may retake the exam immediately. Please contact us if you need assistance or an alternative exam format.
              </li>
            </ul>

        <div *ngFor="let question of examAttempt.examQuestions; let elementIndex = index" class="flex flex-col gap-2">
          <div class="flex flex-row gap-2">
            <span><strong>({{elementIndex + 1}})</strong></span>
            <span>{{question.text}}</span>
          </div>
          <mat-radio-group style="padding-left: 3em" class="flex flex-col gap-2">
              <div *ngFor="let answer of question.examAnswers; let answerIndex = index" class="flex flex-row gap-2">

                <mat-radio-button [value]="answer" (change)="selectAnswer(answer, question)">
                  <span><strong>({{getAnswerIndexLetter(answerIndex)}}) </strong></span>
                  <span class="text-wrap">{{answer.text}}</span>
                </mat-radio-button>
              </div>
          </mat-radio-group>
        </div>
      </div>
    </mat-card-content>
    </mat-card>
      <div class="p-t-16 flex sm:flex-row flex-col gap-2 w-full md:w-1/2">
        <button mat-raised-button matStepperPrevious>Back</button>
        <button mat-raised-button matStepperNext>Continue</button>
        <button mat-raised-button type="button" color="primary"
          *ngIf="!facilitatorLicense.passedExam && facilitatorLicense.id !== 0" (click)="submitExam()"
          [disabled]="!examAttempt.valid">Submit Exam</button>
      </div>
    </mat-step>

    <!--Fees-->
    <mat-step *ngIf="facilitatorLicenses.length > 0">
      <ng-template matStepLabel>
        <span matTooltip="Fee Information" matTooltipPosition="below" [matTooltipShowDelay]="500">Fee Information</span>
      </ng-template>
      <div class="flex flex-col gap-2 w-full lg:w-1/2">
        <span *ngIf="sharedService.tablet" class="f-s-16">Fees</span>
        <app-payment-notice [canPay]="false" entityType="FacilitatorLicense" feeType="ApplicationFee" [renewal]="renewing"></app-payment-notice>
        <div class="flex sm:flex-row flex-col gap-2 w-full md:w-1/2">
          <button mat-raised-button matStepperPrevious>Back</button>
          <button mat-raised-button matStepperNext>Continue</button>
        </div>
      </div>
    </mat-step>

    <!--Verify and Submit-->
    <mat-step [stepControl]="licenseForm" (ngSubmit)="submitApplication()" *ngIf="facilitatorLicenses.length > 0">
      <ng-template matStepLabel>
        <span matTooltip="Review and Submit" matTooltipPosition="below" [matTooltipShowDelay]="500">Review and Submit</span>
      </ng-template>
      <div class="flex flex-col gap-2">
        <div class="flex flex-col 2xl:flex-row gap-2">
          <mat-card class="w-full 2xl:w-1/2">
            <mat-card-title>
              <span *ngIf="applicantForm.valid || licenseLocked">Applicant Information</span>
              <span class="text-red-400" *ngIf="!applicantForm.valid && !licenseLocked">Applicant Information Incomplete</span>
            </mat-card-title>
            <mat-card-content>
              <div class="p-b-16 flex flex-col gap-2 f-s-16">
                <div class="flex flex-col lg:flex-row">
                  <span class="w-[20%]"><strong>Legal Name</strong></span>
                  <div class="w-[80%]">
                    <span>{{facilitatorLicense.applicants[0]?.legalFirstName}}</span>
                    <span>{{facilitatorLicense.applicants[0]?.legalMiddleName}}</span>
                    <span>{{facilitatorLicense.applicants[0]?.legalLastName}}</span>
                  </div>
                </div>
                <div class="flex flex-col lg:flex-row">
                  <span class="w-[20%]"><strong>Preferred Name</strong></span>
                  <div class="flex flex-row gap-2 w-[80%]">
                    <span>{{facilitatorLicense.applicants[0]?.preferredFirstName}}</span>
                    <span>{{facilitatorLicense.applicants[0]?.preferredMiddleName}}</span>
                    <span>{{facilitatorLicense.applicants[0]?.preferredLastName}}</span>
                  </div>
                </div>
                <div class="flex flex-col lg:flex-row">
                  <span class="w-[20%]"><strong>Other Names</strong></span>
                  <div class="flex flex-row gap-2 w-[80%]">
                    <span>{{facilitatorLicense.applicants[0]?.alternateNames}}</span>
                  </div>
                </div>
                <div class="flex flex-col lg:flex-row">
                  <span class="w-[20%]"><strong>Physical Address</strong></span>
                  <div class="flex flex-row gap-2 w-[80%]">
                    <span>{{facilitatorLicense.applicants[0]?.physicalStreet}}</span>
                    <span>{{facilitatorLicense.applicants[0]?.physicalCity}}</span>
                    <span>{{facilitatorLicense.applicants[0]?.physicalState}}</span>
                    <span>{{facilitatorLicense.applicants[0]?.physicalZip}}</span>
                    <span>{{facilitatorLicense.applicants[0]?.physicalCounty}}</span>
                  </div>
                </div>
                <div class="flex flex-col lg:flex-row">
                  <span class="w-[20%]"><strong>Mailing Address</strong></span>
                  <div *ngIf="!facilitatorLicense.applicants[0]?.mailingIsPhysical" class="flex flex-row gap-2 w-[80%]">
                    <span>{{facilitatorLicense.applicants[0]?.mailingStreet}}</span>
                    <span>{{facilitatorLicense.applicants[0]?.mailingCity}}</span>
                    <span>{{facilitatorLicense.applicants[0]?.mailingState}}</span>
                    <span>{{facilitatorLicense.applicants[0]?.mailingZip}}</span>
                    <span>{{facilitatorLicense.applicants[0]?.mailingCounty}}</span>
                  </div>
                  <div *ngIf="facilitatorLicense.applicants[0]?.mailingIsPhysical" class="flex flex-row gap-2 w-[80%]">
                    <span>Same as Physical</span>
                  </div>
                </div>
                <div class="flex flex-col lg:flex-row">
                  <span class="w-[20%]"><strong>Primary Phone</strong></span>
                  <div class="flex flex-row gap-2 w-[80%]">
                    <span>{{facilitatorLicense.applicants[0]?.phone | mask: '(000) 000-0000 000000'}}</span>
                  </div>
                </div>
                <div class="flex flex-col lg:flex-row">
                  <span class="w-[20%]"><strong>Alternate Phone</strong></span>
                  <div class="flex flex-row gap-2 w-[80%]">
                    <span>{{facilitatorLicense.applicants[0]?.alternatePhone | mask: '(000) 000-0000 000000'}}</span>
                  </div>
                </div>
                <div class="flex flex-col lg:flex-row">
                  <span class="w-[20%]"><strong>Email</strong></span>
                  <div class="flex flex-row gap-2 w-[80%]">
                    <span>{{facilitatorLicense.applicants[0]?.email}}</span>
                  </div>
                </div>
                <div class="flex flex-col lg:flex-row">
                  <span class="w-[20%]"><strong>Language</strong></span>
                  <div class="flex flex-row gap-2 w-[80%]">
                    <span>{{facilitatorLicense.applicants[0]?.language}}</span>
                  </div>
                </div>
                <div class="flex flex-col lg:flex-row">
                  <span class="w-[20%]"><strong>Training Program</strong></span>
                  <span>{{facilitatorLicense.trainingProgram}}</span>
                </div>

                <div class="flex flex-col lg:flex-row">
                  <span class="w-[20%]"><strong>Completed On:</strong></span>
                  <span>{{facilitatorLicense.trainingDate | date}}</span>
                </div>

                <div class="flex flex-col lg:flex-row" *ngIf="sharedService.isAfterJan1st2027()">
                  <span class="w-[20%]"><strong>Out-of-State Approved Training Program</strong></span>
                  <span>{{facilitatorLicense.oosTrainingProgram}}</span>
                </div>

                <div class="flex flex-col lg:flex-row" *ngIf="sharedService.isAfterJan1st2027()">
                  <span class="w-[20%]"><strong>Completed On:</strong></span>
                  <span>{{facilitatorLicense.oosTrainingDate | date}}</span>
                </div>

                <div *ngIf="facilitatorLicense.applicants[0]?.previousLicense" class="flex flex-col">
                  <mat-checkbox [checked]="true" disabled>
                    Has this individual applied for or received any other licenses from Oregon Psilocybin Services?
                  </mat-checkbox>
                  <div class="flex flex-col">
                    <span>Previous Affiliated License</span>
                    <span>{{facilitatorLicense.applicants[0]?.affiliatedLicenses}}</span>
                  </div>
                </div>

              </div>
            </mat-card-content>
          </mat-card>

          <div class="flex flex-col lg:flex-row gap-2 w-full lg:w-1/2">
            <mat-card class="md:w-[60%] w-full">
              <mat-card-title>
                <div class="flex flex-col">
                  <span>Current Documents</span>
                  <span class="text-red-400" *ngIf="!applicantDocumentsValid || !licenseDocumentsValid || !additionalDocumentsValid">Not All Requirements are Met</span>
                </div>
              </mat-card-title>
              <mat-card-content>
                <div class="flex flex-col  f-s-16">
                  <span class="text-red-400" *ngIf="missingTypes[trainingCertificateType]">{{documentTypeReference[trainingCertificateType]}} required</span>
                  <span class="text-red-400" *ngIf="missingTypes[socialEquityPlanType]">{{documentTypeReference[socialEquityPlanType]}} required</span>
                  <span class="text-red-400" *ngIf="missingTypes[personalIdentificationType]">{{documentTypeReference[personalIdentificationType]}} required</span>
                </div>
                <div class="flex flex-col gap-2 f-s-16">
                  <div *ngIf="!sharedService.mobile" class="flex flex-row md:items-center">
                    <div class="flex w-full md:w-1/2">
                      <span class="f-s-16"><strong>File</strong></span>
                    </div>
                    <div class="flex w-full md:w-1/2 md:flex-row md:items-center md:justify-between">
                      <div class="flex flex-col md:w-[70%]">
                        <span class="f-s-16"><strong>Requirement</strong></span>
                      </div>
                      <div class="flex items-center justify-end">
                      </div>
                    </div>
                  </div>
                  <ng-container *ngFor="let document of facilitatorLicense.applicants[0]?.applicantDocuments">
                    <div class="flex flex-col gap-2 border-b border-gray-200 py-2 last:border-b-0 md:flex-row md:items-center">
                      <div class="flex w-full flex-col md:w-1/2">
                        <span *ngIf="sharedService.mobile" class="f-s-14"><strong>File</strong></span>
                        <span class="w-full break-words text-indigo-A700 f-s-16" style="cursor: pointer" (click)="downloadDocument(document.id, document.name, true)" title="{{document.name}}">{{document.name.length > 15 ? document.name.substring(0,15) + "..." : document.name}}</span>
                      </div>
                      <div class="flex w-full flex-col gap-2 md:w-1/2 md:flex-row md:items-center md:justify-between">
                        <div class="flex flex-col break-words md:w-[70%] f-s-16">
                          <span *ngIf="sharedService.mobile" class="f-s-14"><strong>Requirement</strong></span>
                          <span *ngFor="let type of document.types">
                            {{documentTypeReference[type]}}
                          </span>
                        </div>
                        <div class="flex items-center justify-start md:justify-end">
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngFor="let document of facilitatorLicense?.licenseDocuments">
                    <div class="flex flex-col gap-2 border-b border-gray-200 py-2 last:border-b-0 md:flex-row md:items-center">
                      <div class="flex w-full flex-col md:w-1/2">
                        <span *ngIf="sharedService.mobile" class="f-s-14"><strong>File</strong></span>
                        <span class="w-full break-words text-indigo-A700 f-s-16" style="cursor: pointer" (click)="downloadDocument(document.id, document.name, false)" title="{{document.name}}">{{document.name.length > 15 ? document.name.substring(0,15) + "..." : document.name}}</span>
                      </div>
                      <div class="flex w-full flex-col gap-2 md:w-1/2 md:flex-row md:items-center md:justify-between">
                        <div class="flex flex-col break-words md:w-[70%] f-s-16">
                          <span *ngIf="sharedService.mobile" class="f-s-14"><strong>Requirement</strong></span>
                          <span *ngFor="let type of document.types">
                            {{documentTypeReference[type]}}
                          </span>
                        </div>
                        <div class="flex items-center justify-start md:justify-end">
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </mat-card-content>
            </mat-card>
            <mat-card class="md:w-[40%] w-full">
              <mat-card-title>
                <span *ngIf="facilitatorLicense.passedExam">
                  Facilitator Exam
                </span>
                <span class="text-red-400" *ngIf="!facilitatorLicense.passedExam">
                  You Must Pass the Exam</span>
              </mat-card-title>
              <mat-card-content>
                <div class="flex flex-col gap-2">
                  <div class="flex flex-row gap-2">
                    <span class="f-s-16 w-[30%]"><strong>Score</strong></span>
                    <span class="f-s-16 w-[30%]"><strong>Result</strong></span>
                    <span class="f-s-16 w-[40%]"><strong>Date Taken</strong></span>
                  </div>
                  <div *ngFor="let attempt of facilitatorLicense.examAttempts" class="flex flex-row gap-2 f-s-16">
                    <span class="w-[30%]">{{attempt.score}}%</span>
                    <span *ngIf="attempt.passed" class="f-s-16 w-[30%]"><strong>Passed</strong></span>
                    <span *ngIf="!attempt.passed" class="w-[30%]">Failed</span>
                    <span class="w-[40%]">{{attempt.dateTaken | date}}</span>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>

        </div>
        <div class="flex flex-row gap-2">
          <mat-card class="w-full lg:w-1/2">
            <mat-card-title>
              Sign and Submit
            </mat-card-title>
            <mat-card-content>
              <form [formGroup]="licenseForm">
                <div class="flex flex-col gap-2 f-s-16">
                  <ul class="flex flex-col gap-2">
                    <li class="f-s-16">
                      I certify the information provided in this application is true and complete to the best of my knowledge.
                      I understand falsifying an application, supplying misleading information, or withholding information is grounds for denial of my application or revocation of my license.
                    </li>
                    <li class="f-s-16">
                      I understand I am responsible for making my own determination regarding the legal risks associated with a Schedule 1 substance
                      under the Federal Controlled Substances Act.
                    </li>
                    <li class="f-s-16">
                      I understand the information provided in application materials, including applicant name, is subject to disclosure
                      under Oregon's public records laws and that certain information may be posted on OHA's website for purposes of license verification.
                    </li>
                    <li class="f-s-16">
                      I understand the following information in the application will be used by Oregon Psilocybin Services to start the background check process:
                      legal name; date of birth; physical address; phone number; email address; proof of identity; prior addresses if lived out of state during the
                      past five years; social security number (if consented); and prior names and aliases.
                    </li>
                    <li class="f-s-16">
                      I understand I must complete and pass a background check as a condition of licensure.
                    </li>
                    <li class="f-s-16">
                      I understand I must notify Oregon Psilocybin Services in writing within 10 business days of any conviction for any misdemeanor or felony committed
                      and I will be required to undergo another criminal background check.
                    </li>
                    <li class="f-s-16">
                      I understand I must notify Oregon Psilocybin Services in writing within 10 business days of a change in contact information.
                    </li>
                    <li class="f-s-16">
                      I understand I am also required to obtain a worker permit as described in OAR 333-333-4070.
                    </li>
                    <li class="f-s-16">
                      I have read, understand, and agree to adhere to the Oregon Psilocybin Services Revised Statutes (ORS) Chapter 475A,
                      Oregon Administrative Rules (OAR) Chapter 333, Division 333, as well as any other applicable statutes or laws.
                    </li>
                    <li class="f-s-16">
                      I understand that failure to adhere to these statutes and rules may result in a denial of my application or disciplinary action if
                      I am licensed by Oregon Psilocybin Services.
                    </li>
                    <li class="f-s-16">
                      I understand the psilocybin facilitator license has a term of one year from the effective date of licensure.
                      If I wish to renew my license after that term, I understand I must complete a renewal application.
                    </li>
                    <li class="f-s-16">
                      I understand a license will not be issued until the license fee payment is paid and cleared.
                      A licensee may not operate until the effective date of licensure.
                    </li>
                    <li class="f-s-16" *ngIf="showRequiredApplicantDataAttestation(facilitatorLicense.applicationDate)">
                      Applicant(s) understand and will comply with the requirement to complete and submit the Required 303 Applicant and Licensee REAL & SOGI
                      Data form in accordance with ORS 475A.374.
                    </li>
                    <li class="f-s-16">
                      I understand the psilocybin facilitator application and annual license fees are non-refundable.
                    </li>
                  </ul>

                  <mat-checkbox formControlName="attestation">
                    <span style="white-space: normal; font-size: 16px;">I have read and I understand the above statements</span>
                  </mat-checkbox>

                      <mat-radio-group aria-label="Select an option" formControlName="directoryConsent" style="padding-top: 1em" class="gap-4">
                        <div class="flex flex-col gap-4 f-s-16">
                          <div class="flex flex-row">
                            <mat-radio-button [value]="true">
                              <span class="text-wrap f-s-16">
                                I consent to having my license name, license type, and the contact information selected below listed in the voluntary OPS Licensee Directory.
                              </span>
                            </mat-radio-button>
                          </div>
                            <span>Please select which contact information you would like to include in the directory:</span>

                          <div style="padding-left: 1em" *ngIf="licenseForm.get('directoryConsent').value" class="flex flex-col f-s-16">
                            <div class="gap-[5px]">
                              <mat-checkbox formControlName="directoryPreferredName" *ngIf="applicantForm.get('preferredFirstName').value != '' || applicantForm.get('preferredLastName').value != ''">
                                <span style="white-space: normal;">Display my preferred name in the License Directory instead of my legal name.</span>
                              </mat-checkbox>
                            </div>

                            <div class="gap-[5px] f-s-16">
                              <mat-checkbox formControlName="directoryConsentWebsite">
                                <span id="directoryWebsiteLabel" style="white-space: normal; font-size: 16px;">Website:</span>
                              </mat-checkbox>

                              <mat-form-field *ngIf="licenseForm.get('directoryConsentWebsite').value">
                                <mat-label>
                                  Website
                                </mat-label>
                                <input matInput formControlName="directoryWebsite" aria-describedby="directoryWebsiteLabel">
                                <mat-error role="alert">
                                  <span *ngIf="licenseForm.get('directoryWebsite').hasError('required')">Error: Directory website URL is required</span>
                                  <span *ngIf="licenseForm.get('directoryWebsite').hasError('pattern')">Error: Please enter a valid URL (http:// or https://)</span>
                                </mat-error>
                              </mat-form-field>
                            </div>

                            <div class="gap-[5px]">
                              <mat-checkbox formControlName="directoryConsentEmail">
                                <span id="directoryEmailLabel" style="white-space: normal; font-size: 16px;">Email:</span>
                              </mat-checkbox>

                              <mat-form-field *ngIf="licenseForm.get('directoryConsentEmail').value">
                                <mat-label>
                                  Email
                                </mat-label>
                                <input matInput formControlName="directoryEmail" aria-describedby="directoryEmailLabel">
                                <mat-error role="alert" *ngIf="validateDirectoryConsentEmail()"> Error: This field is required
                                </mat-error>
                              </mat-form-field>
                            </div>

                            <div class="gap-[5px] f-s-16">
                              <mat-checkbox formControlName="directoryConsentPhone">
                                <span id="directoryPhoneLabel" style="white-space: normal; font-size: 16px;">Phone Number:</span>
                              </mat-checkbox>

                              <mat-form-field *ngIf="licenseForm.get('directoryConsentPhone').value">
                                <mat-label>
                                  Phone number
                                </mat-label>
                                <input matInput formControlName="directoryPhone" mask="(000) 000-0000 000000" aria-describedby="directoryPhoneLabel">
                                <mat-error role="alert" *ngIf="validateDirectoryConsentPhone()"> Error: This field is required
                                </mat-error>
                              </mat-form-field>
                            </div>
                          </div>

                          <div class="flex flex-row">
                            <mat-radio-button [value]="false">
                              <span class="text-wrap f-s-16">
                                I <strong>do not</strong> consent to having my license name, license type, and contact information listed in the voluntary OPS Licensee Directory.
                              </span>
                            </mat-radio-button>
                          </div>
                        </div>
                      </mat-radio-group>
                      <mat-error role="alert" *ngIf="licenseForm.get('directoryConsent').invalid"> Error: You must select one statement regarding consent</mat-error>
                      <span class="text-wrap">Please note, if you do not consent, you may still be licensed with Oregon Psilocybin Services.</span>

                  <div class="flex flex-col lg:flex-row gap-2 justify-start items-center">
                    <mat-form-field class="lg:!w-1/3 w-full">
                      <mat-label>
                        Signature
                      </mat-label>
                      <input matInput placeholder="Signature" formControlName="electronicSignature">
                      <mat-error role="alert" *ngIf="licenseForm.get('electronicSignature').invalid"> Error: Signature is required
                      </mat-error>
                    </mat-form-field>
                    <button [disabled]="validateDirectoryConsentWebsite() || !applicationValid || !licenseForm.valid || licenseLocked" type="submit" mat-raised-button
                      color="primary" (click)="submitApplication()">Submit</button>
                  </div>
                </div>
              </form>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
      <div class="p-t-16 flex sm:flex-row flex-col gap-2 w-full md:w-1/2">
        <button mat-raised-button matStepperPrevious>Back</button>
      </div>
    </mat-step>

  </mat-stepper>
</div>

<div *ngIf="!viewForm && !showSubmitted && !renewing">
  <div class="flex flex-col gap-2">
    <div>
      <button *ngIf="showStartButton && canApplyAgain" mat-flat-button type="button" color="primary" (click)="startApplication()">New Application</button>
    </div>
    <div *ngFor="let license of facilitatorLicenses">
      <mat-card [style.background]="cardColor" class="w-full md:!w-[60%]">
        <mat-card-content>
          <div class="flex flex-col lg:flex-row gap-6">
            <div class="flex flex-col gap-2 justify-center flex-1">
              <div class="m-b-0 flex flex-row">
                <span class="f-s-16 w-[40%] lg:w-[40%]"><strong>Facilitator</strong></span>
                <div class="flex flex-row gap-1">
                  <span class="f-s-16">{{license.applicants[0].legalFirstName}}</span>
                  <span class="f-s-16">{{license.applicants[0].legalMiddleName}}</span>
                  <span class="f-s-16">{{license.applicants[0].legalLastName}}</span>
                </div>
              </div>
              <div class="m-b-0 flex flex-row justify-start items-center">
                <span class="f-s-16 w-[40%] lg:w-[40%]"><strong>Facilitator Id</strong></span>
                <span class="f-s-16" id="programId">{{license.licenseId}}</span>
                <button mat-icon-button (click)="sharedService.copyToClipboard(license.licenseId)" color="primary"
                        matTooltip="Copy to Clipboard" matTooltipShowDelay=800 aria-label="Copy to Clipboard">
                  <mat-icon>content_copy</mat-icon>
                </button>
              </div>
              <div class="flex flex-row justify-start items-center">
                <span class="f-s-16 w-[40%] lg:w-[40%]"><strong>Status</strong></span>
                <div class="flex flex-col">
                  <span class="f-s-20 f-w-700" [ngClass]="license.status === sharedService.approved? 'text-light-green-600':
                                  (license.status === sharedService.submitted ||
                                   license.status === sharedService.pending ||
                                   license.status === sharedService.awaitingPayment ||
                                     license.status === sharedService.underReview)? 'text-orange-900' : 'text-red-900'" *ngIf="license.status != sharedService.submittedForApproval && license.status != sharedService.renewalSubmittedForApproval">
                    {{license.status}}
                  </span>
                  <span class="f-s-20 f-w-700" [ngClass]="'text-orange-900'" *ngIf="license.status == sharedService.submittedForApproval || license.status == sharedService.renewalSubmittedForApproval">{{sharedService.underReview}}</span>
                </div>
              </div>
              <div *ngIf="license.status === sharedService.submitted || (license.status === sharedService.closed && license.applicationDate)" class="flex flex-row">
                <span class="w-[40%] lg:w-[40%] f-s-16"><strong>Date Submitted</strong></span>
                <span class="f-s-16">{{license.applicationDate | date}}</span>
              </div>
              <div *ngIf="license.status === sharedService.closed" class="flex flex-row">
                <span class="w-[40%] lg:w-[40%] f-s-16"><strong>Closed Date</strong></span>
                <span class="f-s-16">{{license.closedDate | date}}</span>
              </div>
              <div *ngIf="license.status === sharedService.approved" class="flex flex-row">
                <span class="w-[40%] lg:w-[40%] f-s-16"><strong>Date Approved</strong></span>
                <span class="f-s-16">{{license.approvedDate | date}}</span>
              </div>
              <div *ngIf="license.status === sharedService.approved || license.status === sharedService.expired" class="flex flex-row">
                <span class="w-[40%] lg:w-[40%] f-s-16"><strong>Expiration Date</strong></span>
                <span class="f-s-16">{{license.expirationDate | date}}</span>
              </div>
              <div *ngIf="license.status === sharedService.approved && license.isRenewal" class="flex flex-row">
                <span class="w-[40%] lg:w-[40%] f-s-16"><strong>Date Renewal Approved</strong></span>
                <span class="f-s-16">{{license.renewedDate | date}}</span>
              </div>

            </div>
            <div class="flex flex-col gap-2 justify-start items-start">
              <button *ngIf="license.status !== sharedService.pendingRenewal && license.status !== sharedService.renewalSubmitted && !license.isRenewal"
                      mat-flat-button type="button" color="primary" (click)="viewApplication(license)">
                      <div *ngIf="showEditLoading" class="flex flex-row gap-2">
                        <span>Loading</span>
                        <mat-spinner color="accent" [diameter]="25" [strokeWidth]="5" aria-label="Loading"></mat-spinner>
                      </div>
                      <span *ngIf="!showEditLoading && license.status != 'Pending'">View</span>
                      <span *ngIf="!showEditLoading && license.status == 'Pending'">Edit</span>
              </button>
              <button *ngIf="license.isRenewal"
                mat-flat-button type="button" color="primary" (click)="viewRenewal(license)">
                <div *ngIf="showEditLoading" class="flex flex-row gap-2">
                  <span>Loading</span>
                  <mat-spinner color="accent" [diameter]="25" [strokeWidth]="5" aria-label="Loading"></mat-spinner>
                </div>
                <span *ngIf="license.status === sharedService.pendingRenewal">Continue Renewal</span>
                <span *ngIf="license.status !== sharedService.pendingRenewal">View</span>
              </button>
              <button *ngIf="license.canRenew && !hasRenewal(license) && license.status == sharedService.approved && !startedRenewal"
                mat-flat-button type="button" color="primary" (click)="createRenewal(license)">
                <span>Start Renewal</span>
              </button>
              <button *ngIf="license.status == 'Submitted'" mat-flat-button type="button" color="accent"
                (click)="requestWithdraw(license)">Request Withdraw
              </button>
              <button *ngIf="license.status == 'Approved'" mat-flat-button type="button" color="accent"
                (click)="requestSurrender(license)">Request Surrender
              </button>
              <!-- <button *ngIf="license.status !== sharedService.withdrawn && license.status !== sharedService.closed"
                      mat-flat-button type="button" color="warn" (click)="withdrawApplication(license)">
                <span *ngIf="license.status === sharedService.submitted || license.status === sharedService.underReview">Request Withdrawal</span>
                <span *ngIf="license.status !== sharedService.submitted && license.status !== sharedService.underReview">Withdraw</span>
              </button> -->
              <a *ngIf="licenseHasUnpaidFees(license)" mat-flat-button type="button" color="warn" routerLink="/payments">Pay Fees</a>
              <button *ngIf="license.status == 'Approved'" mat-flat-button color="primary" type="button" (click)="viewPrintScreen(license)">Print License</button>
              <button *ngIf="license.status == 'Approved'" color="primary" mat-flat-button type="button" (click)="changeDirectory(license)">
                <span class="text-wrap">
                  Change OPS Licensee Directory Consent
                </span>
              </button>
            </div>
          </div>

          <div class="m-t-8 flex flex-col lg:flex-row">
            <div class="flex flex-col w-full 2xl:w-1/2">
              <div class="flex flex-row w-full">
                <span class="w-1/2"><strong>Application Fee Status</strong></span>
                <span [ngClass]="hasPaidFee(license, paymentService.applicationFeeType) ? 'text-light-green-600':  'text-red-900'">
                  <span class="f-s-16">{{getPaymentFeeStatus(license, paymentService.applicationFeeType)}}</span>
                </span>
              </div>

              <div *ngIf="hasPaidFee(license, paymentService.applicationFeeType)" class="flex flex-row w-full">
                <span class="w-1/2"><strong>Application Fee Cleared</strong></span>
                <span class="f-s-16">{{getFeeCleared(license, paymentService.applicationFeeType)}}</span>
              </div>
            </div>

            <div class="flex flex-col w-full 2xl:w-1/2">
              <div class="flex flex-row w-full">
                <span class="w-1/2"><strong>License Fee Status</strong></span>
                <span [ngClass]="hasPaidFee(license, paymentService.licenseFeeType) ? 'text-light-green-600':  'text-red-900'">
                  <span class="f-s-16">{{getPaymentFeeStatus(license, paymentService.licenseFeeType)}}</span>
                  <span class="f-s-16">{{getPaymentFeeStatus(license, paymentService.reducedLicenseFeeType)}}</span>
                </span>
              </div>

              <div *ngIf="hasPaidFee(license, paymentService.licenseFeeType)" class="flex flex-row w-1/2">
                <span class="w-1/2"><strong>License Fee Cleared</strong></span>
                <span class="f-s-16">{{getFeeCleared(license, paymentService.licenseFeeType)}}</span>
                <span class="f-s-16">{{getFeeCleared(license, paymentService.reducedLicenseFeeType)}}</span>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>

<div *ngIf="showSubmitted">
  <mat-card class="sticky-header p-y-0" [style.background-color]="sharedService.purple">
    <mat-card-content>
      <div style="color: #303030" class="flex flex-row gap-2 justify-start items-center">
        <mat-icon class="medium-icon m-24">group</mat-icon>
        <span *ngIf="!renewing" class="f-s-20 flex-1">Facilitator Application Submitted</span>
        <span *ngIf="renewing" class="f-s-20 flex-1">Facilitator Application Renewal Submitted</span>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-title *ngIf="!renewing">
      Thank you for submitting the Oregon Psilocybin Services facilitator license application.
    </mat-card-title>
    <mat-card-title *ngIf="renewing">
      Thank you for submitting the Oregon Psilocybin Services facilitator license renewal.
    </mat-card-title>
    <mat-card-content>
      <div class="flex flex-col">
        <div class="flex flex-row">
          <span class="f-s-16 w-[75%]">
            You can review your application status and updates to the status in TLC.
            Please be sure to monitor your email for follow-up communication from the Oregon Psilocybin Services Licensing Team.
            To ensure you receive emails from OPS, please consider
            adding Licensing.Psilocybin&#64;oha.oregon.gov to your email contacts to prevent the email going to your spam folder.
          </span>
        </div>
        <span class="f-s-20 m-t-8" *ngIf="!renewing">
          <strong>A Worker Permit is also required for your license, if you do not already have one click <a [routerLink]="['/license/worker-permit']">here</a> to be taken to your application.</strong>
        </span>
      </div>
    </mat-card-content>
  </mat-card>
  <app-payment-notice *ngIf="facilitatorLicense != null &&
                             facilitatorLicense.payments != null &&
                             licenseHasUnpaidFees(facilitatorLicense)"
                             feeType="ApplicationFee" entityType="FacilitatorLicense" [canPay]="true" [id]="facilitatorLicense.id">
  </app-payment-notice>

  <div class="m-t-16 flex flex-row gap-4">
    <button mat-raised-button  type="button" (click)="continue()">Continue</button>
  </div>
</div>

<!--Renewals-->
<div *ngIf="renewing && !showSubmitted" class="flex flex-col gap-2">
  <mat-stepper class="readable-stepper" [orientation]="sharedService.isMobile? 'vertical' : 'horizontal'" #RenewalStepper
    [selectedIndex]="renewalStep" (selectionChange)="changeRenewalStep($event)">
    <!--Getting Started-->
    <mat-step>
      <ng-template matStepLabel>
        <span matTooltip="Getting Started" matTooltipPosition="below" [matTooltipShowDelay]="500">Getting Started</span>
      </ng-template>
      <div class="p-b-8 flex flex-col gap-2">
        <mat-card>
          <mat-card-title>
            <span>
              Thank you for your interest in applying to renew your psilocybin Facilitator License through the Oregon Psilocybin Services - Training Program, Licensing, and Compliance system (TLC).
            </span>
          </mat-card-title>
          <mat-card-content>
            <div style="padding-top: 2em" class="flex flex-col lg:flex-row gap-3">
              <div class="flex flex-col gap-2">
                <strong class="p-l-24">
                  Applicants must read, understand, and agree to adhere to the Oregon Psilocybin Services Revised Statutes
                  <a  href="https://www.oregonlegislature.gov/bills_laws/ors/ors475a.html" target="_blank" rel="noreferrer noopener" style="word-break: break-all; white-space: normal;">ORS 475A</a>,
                  Oregon Administrative Rules
                  <a  href="https://secure.sos.state.or.us/oard/displayDivisionRules.action?selectedDivision=7102" target="_blank" rel="noreferrer noopener" style="word-break: break-all; white-space: normal;">(OAR) Chapter 333</a>,
                  Division 333, as well as any other applicable statutes or laws.
                </strong>
              </div>
            </div>

            <div style="padding-top: 2em" class="flex flex-col gap-3">
              <strong>A completed renewal application packet contains the following:</strong>
              <ul class="flex flex-col gap-2">
                <li>
                  Completed and signed facilitator license renewal application
                </li>
                <li>
                  Uploaded evaluation of last year's Social Equity Plan
                </li>
                <li>
                  Uploaded copy of the <strong><i>front and back</i></strong> of a valid, unexpired government-issued photo identification
                </li>
              </ul>
            </div>

          <div style="padding-top: 2em" class="flex flex-row">
            <div class="flex flex-col gap-2">
              <strong>Important Notes: </strong>
              <ul class="flex flex-col gap-2 f-s-16">
                <li>
                  Please review each section of the application to ensure it is complete
                </li>
                <li>
                  Toward the end of the renewal application, a fee page will describe how to submit the renewal license fee which may be paid online, by mail or in-person
                </li>
              </ul>


              <strong>Renewal: </strong>
              <span class="p-l-24">
                <strong>Timely Renewal Applications:</strong>
              </span>
              <span class="p-l-24">
                To be considered a timely renewal under OAR 333-333, renewal applications must be complete, meet all submission requirements, and be
                submitted at least 60 days before the license expiration date. The TLC system will open 120 days before the license expires to allow licensees to apply for the renewal license.
              </span>
              <span class="p-l-24">
                If a timely application is submitted, licensees may continue to operate after the license expires, provided OPS has not yet processed the renewal. Incomplete renewal applications
                will not be considered timely unless all required information is submitted at least 60 days before the expiration date.
              </span>
              <span class="p-l-24">
                <strong>Important:</strong> If your renewal application fee does not clear 30 days after your renewal application is moved to “Renewal approved, pending fee payment and clearance”
                status, your renewal application will be closed. If your license has expired, you will no longer be able to exercise the privileges of the license upon expiration.
              </span>
              <span class="p-l-24">
                You are welcome to re-apply for an OPS license in the future through the TLC system or by mail. To re-apply, you will have to complete the application process, pay the application and license fee, and
                complete a new background check, along with all other requirements of licensure.
              </span>

              <span class="flex-1"></span>

              <span class="p-l-24">
                <strong>Untimely  Renewal Applications:</strong>
              </span>
              <span class="p-l-24">
                Under OAR 333-333, any renewal applications submitted fewer than 60 days prior to the license expiration date are considered untimely.
              </span>
              <span class="p-l-24">
                Per ORS 333-333, licensees who submit untimely applications may not continue to operate if OPS is unable to process the untimely renewal before the license expires. In such cases, all licensed
                activities must cease as of the expiration date until the renewal is approved and a new license is issued.
              </span>
              <span class="p-l-24">
                <strong>Important:</strong> If your renewal payment does not clear within 30 days of your renewal application being moved to “Renewal approved, pending fee payment and clearance” status, your
                renewal application will be closed. If your license has expired, you will no longer  be able to exercise the privileges of the license upon expiration.
              </span>
              <span class="p-l-24">
                You are welcome to re-apply for an OPS license in the future through the TLC system or by mail. To re-apply, you will have to
                complete the application process, pay the application and license fee, and complete a new background check, along with all other requirements of licensure.
              </span>
            </div>
          </div>

          <div style="padding-top: 2em" class="flex flex-col gap-2">
            <span>
              <strong>When you click the continue button at the bottom of this page, you will proceed to the psilocybin facilitator license application.</strong>
              The renewal automatically saves in TLC. You may exit the application and come back later to complete and submit the renewal application, if needed
            </span>
          </div>
          <div style="padding-top: 2em;" class="flex flex-col gap-2">
            <span>
              <strong>DISCLAIMER:</strong>
              Psilocybin remains a schedule I drug under the federal Controlled Substances Act.
              Applicants are responsible for making their own determinations regarding the legal risks associated with participating in this program.
              The information you provide in your application materials, including applicant name, is subject to disclosure under Oregon's public records laws.
            </span>
          </div>
          </mat-card-content>
        </mat-card>
        <div class="p-t-16 flex flex-row w-full md:w-1/2">
          <button mat-raised-button matStepperNext>Continue</button>
        </div>
      </div>
    </mat-step>

    <!--Applicant-->
    <mat-step [stepControl]="applicantForm">
      <form [formGroup]="applicantForm" class="gap-2">
        <ng-template matStepLabel>
          <span class="text-red-400" *ngIf="(!applicantForm.valid && !applicantForm.pristine && !licenseLocked) || !applicantDocumentsValid"
            matTooltip="Personal Information Incomplete" matTooltipPosition="below" [matTooltipShowDelay]="500">
            Applicant Information Incomplete</span>
          <span *ngIf="(applicantForm.valid || applicantForm.pristine || licenseLocked) && applicantDocumentsValid"
            matTooltip="Applicant Information" matTooltipPosition="below" [matTooltipShowDelay]="500">Applicant Information</span>
        </ng-template>
        <div class="flex flex-col">
          <div class="flex flex-col 2xl:flex-row gap-2">
            <mat-card class="w-full 2xl:w-1/2">
              <mat-card-title>
                <div class="flex flex-col lg:flex-row">
                  <span class="flex-1">Applicant Information</span>
                  <div class="flex flex-row gap-2 justify-start items-center">
                    <span class="f-s-16"><strong>Facilitator Id</strong></span>
                    <span class="f-s-16" id="programId">{{facilitatorLicense.licenseId}}</span>
                    <button mat-icon-button (click)="sharedService.copyToClipboard(facilitatorLicense.licenseId)" color="primary"
                            matTooltip="Copy to Clipboard" matTooltipShowDelay=800 aria-label="Copy to Clipboard">
                      <mat-icon>content_copy</mat-icon>
                    </button>
                  </div>
                </div>
              </mat-card-title>
              <mat-card-content>
                <div class="flex flex-col gap-2">
                  <span id="legalNameLabel2"><strong>Legal Name</strong></span>
                  <div class="flex flex-col md:flex-row gap-2">
                    <mat-form-field class="w-full md:w-[40%]">
                      <input matInput placeholder="First" formControlName="legalFirstName" aria-describedby="legalNameLabel2">
                      <mat-error role="alert" *ngIf="applicantForm.get('legalFirstName').invalid"> Error: Please enter your first name
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field class="w-full md:w-[40%]">
                      <input matInput placeholder="Last" formControlName="legalLastName" aria-describedby="legalNameLabel2">
                      <mat-error role="alert" *ngIf="applicantForm.get('legalLastName').invalid"> Error: Please enter your last name
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field class="w-full md:w-[20%]">
                      <input matInput placeholder="Middle" formControlName="legalMiddleName" aria-describedby="legalNameLabel2">
                    </mat-form-field>
                  </div>

                  <span id="preferredNameLabel2" id="preferredNameLabel2"><strong>Preferred Name</strong></span>
                  <div class="flex flex-col md:flex-row gap-2">
                    <mat-form-field class="w-full md:w-[40%]">
                      <input matInput placeholder="First" formControlName="preferredFirstName" aria-describedby="preferredNameLabel2">
                    </mat-form-field>

                    <mat-form-field disabled class="w-full md:w-[40%]">
                      <input matInput placeholder="Last" formControlName="preferredLastName" aria-describedby="preferredNameLabel2">
                    </mat-form-field>

                    <mat-form-field disabled class="w-full md:w-[20%]">
                      <input matInput placeholder="Middle" formControlName="preferredMiddleName" aria-describedby="preferredNameLabel2">
                    </mat-form-field>
                  </div>

                  <div class="flex flex-col">
                    <span><strong>Prior Names and Aliases</strong></span>
                    <span>This information is used for the purposes of the background check</span>
                    <div class="flex flex-col lg:flex-row gap-2">
                      <mat-form-field disabled class="w-full md:w-[80%]">
                        <input matInput placeholder="Name, other name, any other names"
                          formControlName="alternateNames">
                      </mat-form-field>

                      <mat-form-field>
                        <mat-label>Date of Birth</mat-label>
                        <input placeholder="mm/dd/yyyy" formControlName="dob" matInput [matDatepicker]="dob"
                          [max]="sharedService.today" [disabled]="renewing"/>
                        <mat-datepicker-toggle matSuffix [for]="dob"></mat-datepicker-toggle>
                        <mat-datepicker #dob>
                          <mat-datepicker-actions>
                            <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                            <button mat-button matDatepickerCancel>Cancel</button>
                          </mat-datepicker-actions>
                        </mat-datepicker>
                        <mat-error role="alert" *ngIf="applicantForm.get('dob').value > sharedService.today">
                          Error: Please choose an earlier date.
                        </mat-error>
                        <mat-error role="alert" *ngIf="applicantForm.get('dob').hasError('required')"> Error: Date of birth is required
                        </mat-error>

                      </mat-form-field>

                    </div>
                  </div>

                  <div class="flex flex-col">
                    <span><strong>*SOCIAL SECURITY NUMBER DISCLOSURE:</strong></span>
                    <span style="padding-top: 1em; padding-left: 1em"><strong>• </strong>
                      As part of your application for an initial or renewal license, Federal and State laws require you to provide your
                      Social Security Number (SSN),
                      if you have one, to Oregon Psilocybin Services for child support enforcement purposes (42 USC § 666(a)(13) & ORS
                      25.785).
                      If you are an applicant or licensee and you have an SSN but fail to provide your SSN, Oregon Psilocybin Services may
                      refuse to process your application.
                      Your SSN will be used only for child support enforcement purposes unless you confirm your agreement that OPS can use
                      it for administrative purposes
                      as well.
                    </span>

                    <span style="padding-top: 1em; padding-left: 1em">
                      <strong>IMPORTANT NOTE: If you do not have a social security number, you may still be licensed or permitted by Oregon
                        Psilocybin Services.</strong>
                    </span>

                    <span style="padding-top: 1em; padding-left: 1em"><strong>• </strong>
                      Based on our authority under OAR 333-333-4100, we are requesting your voluntary consent to use your SSN for the
                      following administrative purposes only:
                      to positively confirm your identity during the criminal records check. Oregon Psilocybin Services will not deny you
                      any rights, benefits or privileges
                      otherwise provided by law if you do not consent to use of your SSN for these administrative purposes (5 USC§
                      552(a)).
                      <strong>Please check the appropriate box next to the social security field indicating whether you consent or do not
                        consent.</strong>
                    </span>
                    <div class="flex flex-col lg:flex-row gap-4 justify-start items-center">
                      <mat-form-field class="w-full md:w-[25%]">
                        <input matInput placeholder="SSN" formControlName="ssn" mask="000-00-0000">
                        <mat-error role="alert" *ngIf="validateSsn()"> Error: SSN is Required
                        </mat-error>
                      </mat-form-field>
                      <mat-checkbox formControlName="noSsn" [disabled]="renewing">
                        I don't have a social security number
                      </mat-checkbox>
                    </div>
                     <div class="flex flex-col gap-2">
                      <span [ngStyle]="{'color': validateSsnAttestation()? 'red' : ''}">Do you consent to use of SSN for purposes of confirming identity during a criminal records check?</span>
                      <mat-checkbox formControlName="ssnAttestation" (click)="changeAttestation(true)">
                        <span class="f-s-16">Yes</span>
                      </mat-checkbox>
                      <mat-checkbox formControlName="ssnNoAttestation" (click)="changeAttestation(false)">
                        <span class="f-s-16">No</span>
                      </mat-checkbox>
                    </div>
                    <span id="changeInConvictionHistory" class="text-wrap">Since the last time you applied for a license/renewal have you had any updates to your convictions history related to misdemeanors or felonies?</span>
                    <mat-radio-group aria-label="Select an option" formControlName="changeInConvictionHistory" aria-describedby="changeInConvictionHistory" class="gap-2">
                      <mat-radio-button [value]="true"><span class="f-s-16">Yes</span></mat-radio-button>
                      <mat-radio-button [value]="false"><span class="f-s-16">No</span></mat-radio-button>
                    </mat-radio-group>
                    <mat-error role="alert" *ngIf="applicantForm.get('changeInConvictionHistory').hasError('required')"> Error: This field is required</mat-error>
                    <span class="text-wrap"><i>Oregon Background Check Unit provides background checks for OPS. We will reach out if additional background check work is required.</i></span>
                  </div>
                  <div class="flex flex-col gap-3">
                    <span><strong>
                      *For purposes of these questions, “license” means any professional or occupational license, permit or certification that authorizes an individual
                      to engage in an occupation or business, issued by a local, state, or tribal governmental entity, or by a governmental body in another country.
                    </strong></span>
                    <span id="heldLicense" class="text-wrap">In the last 10 years, have you held a license in Oregon or in another state or country? If yes, please describe the type of license, what state or country it was issued in, and provide dates that the license was in effect.</span>
                    <mat-radio-group aria-label="Select an option" formControlName="heldLicense" aria-describedby="heldLicense" class="gap-2">
                      <mat-radio-button [value]="true"><span class="f-s-16">Yes</span></mat-radio-button>
                      <mat-radio-button [value]="false"><span class="f-s-16">No</span></mat-radio-button>
                    </mat-radio-group>
                    <mat-error role="alert" *ngIf="validateHeldLicense()"> Error: This field is required</mat-error>
                    <mat-form-field *ngIf="applicantForm.get('heldLicense').value" class="w-full lg:w-[75%]">
                      <textarea matInput placeholder="Previous Licenses Held" cols="2" formControlName="licensesHeld" aria-describedby="heldLicense"></textarea>
                    </mat-form-field>
                    <mat-error role="alert" *ngIf="validateHeldLicenses()">Error: You must enter the license numbers</mat-error>

                    <span id="deniedLicense" class="text-wrap">In the last 10 years, have you been denied a license? If yes, please upload documentation explaining why and provide all relevant information.</span>
                    <mat-radio-group aria-label="Select an option" formControlName="deniedLicense" aria-describedby="deniedLicense" class="gap-2">
                      <mat-radio-button [value]="true"><span class="f-s-16">Yes</span></mat-radio-button>
                      <mat-radio-button [value]="false"><span class="f-s-16">No</span></mat-radio-button>
                    </mat-radio-group>
                    <mat-error role="alert" *ngIf="validateDeniedLicense()"> Error: This field is required</mat-error>
                    <mat-error role="alert" *ngIf="!validDeniedLicenseDocument()"> Error: You must upload a supporting document</mat-error>
                    <div *ngIf="applicantForm.get('deniedLicense').value">
                      <input type="file" class="file-input" (change)="uploadAdditionalDocument($event, deniedLicenseType)"
                        #deniedLicenseUpload />
                      <div class="flex flex-row gap-2">
                        <div class="file-upload">
                          <button type="button" [disabled]="licenseLocked"
                            mat-raised-button color="primary" class="upload-btn" (click)="deniedLicenseUpload.click()">
                            Browse
                            <mat-icon>attach_file</mat-icon>
                          </button>
                        </div>
                      </div>
                    </div>

                    <span id="subjectToDiscipline" class="text-wrap">For any license you have held, have you been subject to discipline by the entity that issued the license or had the license suspended or revoked in the last 10 years?
                      If so, please upload documentation explaining the reasons for the discipline or revocation and provide all relevant documentation.</span>
                    <mat-radio-group aria-label="Select an option" formControlName="subjectToDiscipline" aria-describedby="subjectToDiscipline" class="gap-2">
                      <mat-radio-button [value]="true"><span class="f-s-16">Yes</span></mat-radio-button>
                      <mat-radio-button [value]="false"><span class="f-s-16">No</span></mat-radio-button>
                    </mat-radio-group>
                    <mat-error role="alert" *ngIf="validateSubjectToDiscipline()"> Error: This field is required</mat-error>
                    <mat-error role="alert" *ngIf="!validSubjectToDisciplineDocument()"> Error: You must upload a supporting document</mat-error>
                    <div *ngIf="applicantForm.get('subjectToDiscipline').value">
                      <input type="file" class="file-input" (change)="uploadAdditionalDocument($event, subjectToDisciplineType)"
                        #subjectToDisciplineUpload />
                      <div class="flex flex-row gap-2">
                        <div class="file-upload">
                          <button type="button" [disabled]="licenseLocked"
                            mat-raised-button color="primary" class="upload-btn" (click)="subjectToDisciplineUpload.click()">
                            Browse
                            <mat-icon>attach_file</mat-icon>
                          </button>
                        </div>
                      </div>
                    </div>

                    <span id="suedForDamages" class="text-wrap">In the last 10 years, have you been sued for money damages related to work you provided under a license? If yes, please upload documentation to explain and provide all relevant documentation.</span>
                    <mat-radio-group aria-label="Select an option" formControlName="suedForDamages" aria-describedby="suedForDamages" class="gap-2">
                      <mat-radio-button [value]="true"><span class="f-s-16">Yes</span></mat-radio-button>
                      <mat-radio-button [value]="false"><span class="f-s-16">No</span></mat-radio-button>
                    </mat-radio-group>
                    <mat-error role="alert" *ngIf="validateSuedForDamages()"> Error: This field is required</mat-error>
                    <mat-error role="alert" *ngIf="!validSuedForDamagesDocument()"> Error: You must upload a supporting document</mat-error>
                    <div *ngIf="applicantForm.get('suedForDamages').value">
                      <input type="file" class="file-input" (change)="uploadAdditionalDocument($event, suedForDamagesType)"
                        #suedForDamagesUpload />
                      <div class="flex flex-row gap-2">
                        <div class="file-upload">
                          <button type="button" [disabled]="licenseLocked"
                            mat-raised-button color="primary" class="upload-btn" (click)="suedForDamagesUpload.click()">
                            Browse
                            <mat-icon>attach_file</mat-icon>
                          </button>
                        </div>
                      </div>
                    </div>

                    <span id="settledAllegations" class="text-wrap">In the last 10 years, have you settled allegations or claims against you related to a license? If so, please upload documentation to explain and provide all relevant documentation.</span>
                    <mat-radio-group aria-label="Select an option" formControlName="settledAllegations" aria-describedby="settledAllegations" class="gap-2">
                      <mat-radio-button [value]="true"><span class="f-s-16">Yes</span></mat-radio-button>
                      <mat-radio-button [value]="false"><span class="f-s-16">No</span></mat-radio-button>
                    </mat-radio-group>
                    <mat-error role="alert" *ngIf="validateSettledAllegations()"> Error: This field is required</mat-error>
                    <mat-error role="alert" *ngIf="!validSettledAllegationsDocument()"> Error: You must upload a supporting document</mat-error>
                    <div *ngIf="applicantForm.get('settledAllegations').value">
                      <input type="file" class="file-input" (change)="uploadAdditionalDocument($event, settledAllegationsType)"
                        #settledAllegationsUpload />
                      <div class="flex flex-row gap-2">
                        <div class="file-upload">
                          <button type="button" [disabled]="licenseLocked"
                            mat-raised-button color="primary" class="upload-btn" (click)="settledAllegationsUpload.click()">
                            Browse
                            <mat-icon>attach_file</mat-icon>
                          </button>
                        </div>
                      </div>
                    </div>

                    <span id="allegedAbuse" class="text-wrap">Has anyone ever alleged that you abused a child or an adult? If you answered yes, please upload documentation to explain the events and provide all relevant documentation.</span>
                    <mat-radio-group aria-label="Select an option" formControlName="allegedAbuse" aria-describedby="allegedAbuse" class="gap-2">
                      <mat-radio-button [value]="true"><span class="f-s-16">Yes</span></mat-radio-button>
                      <mat-radio-button [value]="false"><span class="f-s-16">No</span></mat-radio-button>
                    </mat-radio-group>
                    <mat-error role="alert" *ngIf="validateAllegedAbuse()"> Error: This field is required</mat-error>

                    <div *ngIf="applicantForm.get('allegedAbuse').value">
                      <div class="flex flex-row">
                        <span id="substantiatedAllegation" class="text-wrap">Was the allegation substantiated? If you answered yes, please upload documentation to explain the events and provide all relevant documentation.</span>
                      </div>
                      <div class="flex flex-row">
                        <mat-radio-group aria-label="Select an option" formControlName="substantiatedAllegation" aria-describedby="substantiatedAllegation" class="gap-2">
                          <mat-radio-button [value]="true"><span class="f-s-16">Yes</span></mat-radio-button>
                          <mat-radio-button [value]="false"><span class="f-s-16">No</span></mat-radio-button>
                        </mat-radio-group>
                      </div>
                    </div>
                    <mat-error role="alert" *ngIf="validateSubstantiatedAllegation()"> Error: This field is required</mat-error>
                    <mat-error role="alert" *ngIf="!validAllegedAbuseDocument()"> Error: You must upload a supporting document</mat-error>

                    <div *ngIf="applicantForm.get('allegedAbuse').value">
                      <input type="file" class="file-input" (change)="uploadAdditionalDocument($event, allegedAbuseType)"
                        #allegedAbuseUpload />
                      <div class="flex flex-row gap-2">
                        <div class="file-upload">
                          <button type="button" [disabled]="licenseLocked"
                            mat-raised-button color="primary" class="upload-btn" (click)="allegedAbuseUpload.click()">
                            Browse
                            <mat-icon>attach_file</mat-icon>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>

            <div class="flex flex-col w-full lg:w-1/2">
              <mat-card>
                <mat-card-title>
                  Contact Information
                </mat-card-title>
                <mat-card-content>
                  <div class="flex flex-col gap-2">
                    <div class="flex flex-col lg:flex-row gap-2">
                      <div class="flex flex-col w-full lg:w-1/2">
                        <span id="primaryPhoneLabel2" class="f-2-20"><strong>Primary Phone</strong></span>
                        <mat-form-field>
                          <input matInput placeholder="Phone" formControlName="phone" mask="(000) 000-0000 000000" [validation]="false" aria-describedby="primaryPhoneLabel2">
                          <mat-error role="alert" *ngIf="applicantForm.get('phone').hasError('required')"> Error: A primary phone number is required
                          </mat-error>
                          <mat-error role="alert" *ngIf="applicantForm.get('phone').hasError('pattern')"> Error: Phone should match this format: 999-999-9999 x1234
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="flex flex-col w-full lg:w-1/2">
                        <span id="alternatePhoneLabel2" class="f-2-20"><strong>Alternate Phone</strong></span>
                        <mat-form-field>
                          <input matInput placeholder="Alt Phone" formControlName="alternatePhone" mask="(000) 000-0000 000000" [validation]="false" aria-describedby="alternatePhoneLabel2">
                          <mat-error role="alert" *ngIf="applicantForm.get('alternatePhone').hasError('pattern')"> Error: Phone should match this format: 999-999-9999 x1234
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <div class="flex flex-col lg:flex-row gap-2">
                      <div class="flex flex-col w-full lg:w-1/2">
                        <span id="primaryEmailLabel2" class="f-2-20"><strong>Primary Email Address</strong></span>
                        <mat-form-field>
                          <input matInput placeholder="Email" formControlName="email" aria-describedby="primaryEmailLabel2">
                          <mat-error role="alert" *ngIf="applicantForm.get('email').hasError('required')"> Error: Please enter an email adress
                          </mat-error>
                          <mat-error role="alert" *ngIf="applicantForm.get('email').hasError('email')"> Error: This doesn't look like a valid email address
                          </mat-error>
                        </mat-form-field>
                      </div>
                      <div class="flex flex-col w-full lg:w-1/2">
                        <span id="confirmEmailLabel2" class="f-2-20"><strong>Confirm Email Address</strong></span>
                        <mat-form-field>
                          <input matInput placeholder="Confirm Email" formControlName="confirmEmail" aria-describedby="confirmEmailLabel2">
                          <mat-error role="alert" *ngIf="validateEmail()"> Error: Email does not match
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>

                    <div class="flex flex-col lg:flex-row gap-2">
                      <div class="flex flex-col w-full lg:w-1/2">
                        <span id="preferredLanguageLabel2" class="f-2-18"><strong>Preferred Language</strong></span>
                        <mat-form-field>
                          <input matInput placeholder="Language" formControlName="language" aria-describedby="preferredLanguageLabel2">
                        </mat-form-field>
                      </div>
                    </div>

                    <div class="flex flex-col">
                      <span class="f-2-20"><strong>Other OPS Licenses or Permits:</strong></span>
                      <mat-checkbox formControlName="previousLicense" (change)="validatePreviousLicense()">
                        Check the box if the applicant applied for or received any other licenses or permits from Oregon Psilocybin Services
                      </mat-checkbox>
                      <div class="m-t-8 flex flex-col" *ngIf="this.applicantForm.get('previousLicense').value">
                        <span>Please provide the license id(s) for each Oregon Psilocybin Services license.</span>
                        <mat-form-field>
                          <input matInput formControlName="affiliatedLicenses">
                          <mat-label style="color:red" *ngIf="applicantForm.get('affiliatedLicenses').value == ''">Affiliated Licenses*</mat-label>
                          <mat-label style="color:grey" *ngIf="applicantForm.get('affiliatedLicenses').value != ''">Affiliated Licenses</mat-label>
                          <mat-error role="alert" *ngIf="validatePreviousLicense()"> Error: Please provide all license numbers
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>

              <mat-card *ngIf="showRequiredApplicantDataAttestation(facilitatorLicense.applicationDate)">
                <mat-card-title class="f-s-16">
                  Required 303 Applicant and Licensee REAL & SOGI Data
                </mat-card-title>
                <mat-card-content>
                  <div class="flex flex-col gap-2 f-s-16">
                    <span>Senate Bill 303 (SB 303) was adopted by the Oregon Legislature in 2023 and is now codified in
                      <a  href="https://www.oregonlegislature.gov/bills_laws/ors/ors475A.html#:~:text=475A.372%20Requirement%20of%20psilocybin%20service%20center%20operator%20to%20collect%2c%20maintain%2c%20aggregate%20and%20submit%20to%20Oregon%20Health%20Authority%20specified%20information"
                        target="_blank" rel="noreferrer noopener" style="word-break: break-all; white-space: normal;">ORS 475A.372</a>
                      and
                      <a  href="https://www.oregonlegislature.gov/bills_laws/ors/ors475A.html#:~:text=475A.374%20Oregon%20Health%20Authority%20collection%2c%20publication%20of%20certain%20data%3b%20rules."
                        target="_blank" rel="noreferrer noopener" style="word-break: break-all; white-space: normal;">ORS 475A.374</a>
                      . SB 303 requires Oregon Psilocybin Services (OPS) to collect and compile information about OPS license applicants and licensees. The 303 Applicant Data is kept separate from your application materials and will not be used to make any decisions related to your license application.
                    </span>
                    <span>All initial and renewal applicants are required to click the link below and complete the questions as part of the OPS application process: </span>
                    <a routerLink="/applicant-data"  target="_blank">https://psilocybin.oregon.gov/applicant-data</a>

                    <span>By signing below, the applicant hereby attests and confirms that:</span>
                    <ul>
                      <li>The Required 303 Applicant and Licensee REAL & SOGI Data form has been completed and submitted in accordance with applicable Oregon Administrative Rules (OAR).</li>
                      <li>The information provided on the Required 303 Applicant and Licensee REAL & SOGI Data form is true, accurate, and complete to the best of the applicant's knowledge at the time of submission.</li>
                      <li>The applicant understands that submission of this form is a required component of the licensure or application process under ORS Chapter 475A and applicable to OAR 333-333.</li>
                      <li>The applicant acknowledges that providing false information may result in administrative penalties.</li>
                    </ul>
                    <span><strong>Signature:</strong></span>
                    <mat-form-field class="flex md:w-1/2 w-full">
                      <mat-label>Signature</mat-label>
                      <input matInput placeholder="Signature" formControlName="realSogiSignature" aria-describedby="realSogiSignature">
                      <mat-error role="alert" *ngIf="applicantForm.get('realSogiSignature').invalid"> Error: Please provide a signature
                      </mat-error>
                    </mat-form-field>
                    <span><strong>Date 303 Applicant and Licensee REAL & SOGI Data form was submitted:</strong></span>
                    <mat-form-field class="flex md:w-1/2 w-full">
                      <mat-label>Date Submitted</mat-label>
                      <input placeholder="mm/dd/yyyy" formControlName="realSogiDate" matInput [matDatepicker]="realSogiDate"/>
                      <mat-datepicker-toggle matSuffix [for]="realSogiDate"></mat-datepicker-toggle>
                      <mat-datepicker #realSogiDate>
                        <mat-datepicker-actions>
                          <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                          <button mat-button matDatepickerCancel>Cancel</button>
                        </mat-datepicker-actions>
                      </mat-datepicker>
                      <mat-error role="alert" *ngIf="applicantForm.get('realSogiDate').invalid"> Error: Please provide a date for when the Applicant and Licensee REAL & SOGI Data form was submitted
                      </mat-error>
                    </mat-form-field>
                  </div>
                </mat-card-content>
              </mat-card>

              <mat-card>
                <mat-card-title>Address</mat-card-title>
                <mat-card-content>
                  <div class="flex flex-col">
                    <span id="physicalAddressLabel2"><strong>Physical Address</strong></span>
                    <div class="flex flex-col md:flex-row gap-4">
                      <mat-form-field class="w-full md:w-[50%]">
                        <input matInput placeholder="Street Apt/Unit/Suite" formControlName="physicalStreet" aria-describedby="physicalAddressLabel2">
                        <mat-error role="alert" *ngIf="applicantForm.get('physicalStreet').invalid"> Error: Please provide a street
                        </mat-error>
                      </mat-form-field>

                      <mat-form-field class="w-full md:w-[50%]">
                        <input matInput placeholder="City" formControlName="physicalCity" aria-describedby="physicalAddressLabel2">
                        <mat-error role="alert" *ngIf="applicantForm.get('physicalCity').invalid"> Error: Please provide a city
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="flex flex-col md:flex-row gap-4">
                      <mat-form-field class="w-full">
                        <mat-label>State/US territory/freely associated state</mat-label>
                        <mat-select formControlName="physicalState">
                          <mat-option *ngFor="let state of sharedService.states" value={{state}}>{{state}}</mat-option>
                        </mat-select>
                        <mat-error role="alert" *ngIf="applicantForm.get('physicalState').invalid"> Error: Please provide a state, US territory or freely associated state
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="flex flex-col md:flex-row gap-4">
                      <mat-form-field class="w-full md:w-[40%]">
                        <input matInput placeholder="Zip" formControlName="physicalZip" aria-describedby="physicalAddressLabel2">
                        <mat-error role="alert" *ngIf="applicantForm.get('physicalZip').hasError('required')"> Error: Please provide a zipcode
                        </mat-error>
                        <mat-error role="alert" *ngIf="applicantForm.get('physicalZip').hasError('pattern')"> Error: Zipcode should match this format: 99999 or 99999-1234
                        </mat-error>
                      </mat-form-field>

                      <mat-form-field *ngIf="applicantForm.get('physicalState').value === 'OR'" class="w-full md:w-[40%]">
                        <mat-label>County</mat-label>
                        <mat-select formControlName="physicalCounty">
                          <mat-option>-- None --</mat-option>
                          <mat-option *ngFor="let county of sharedService.counties" value={{county}}>{{county}}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="m-t-8 flex flex-col">
                    <div class="flex flex-row gap-6 items-center">
                      <span id="mailingAddressLabel3"><strong>Mailing Address</strong></span>
                      <mat-checkbox formControlName="mailingIsPhysical" (change)="mailingIsSame()">
                        Same as physical
                      </mat-checkbox>
                    </div>
                    <div [@slideInOut] *ngIf="!applicantForm.get('mailingIsPhysical').value" class="flex flex-col">
                      <div class="flex flex-col md:flex-row gap-4">
                        <mat-form-field class="w-full md:w-[50%]">
                          <input matInput placeholder="Street Apt/Unit/Suite" formControlName="mailingStreet"
                            (blur)="validateMailingStreet()" aria-describedby="mailingAddressLabel3">
                          <mat-error role="alert" *ngIf="validateMailingStreet()"> Error: Please provide a street
                          </mat-error>
                        </mat-form-field>



                        <mat-form-field class="w-full md:w-[50%]">
                          <input matInput placeholder="City" formControlName="mailingCity" (blur)="validateMailingCity()" aria-describedby="mailingAddressLabel3">
                          <mat-error role="alert" *ngIf="validateMailingCity()"> Error: Please provide a city
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="flex flex-col md:flex-row gap-4">
                        <mat-form-field class="w-full">
                          <mat-label>State/US territory/freely associated state</mat-label>
                          <mat-select formControlName="mailingState" (blur)="validateMailingState()">
                            <mat-option *ngFor="let state of sharedService.states" value={{state}}>{{state}}</mat-option>
                          </mat-select>
                          <mat-error role="alert" *ngIf="validateMailingState()"> Error: Please provide a state, US territory or freely associated state
                          </mat-error>
                        </mat-form-field>
                      </div>

                      <div class="flex flex-col md:flex-row gap-4">
                        <mat-form-field class="w-full md:w-[40%]">
                          <input matInput placeholder="Zip" formControlName="mailingZip" (blur)="validateMailingZip()" aria-describedby="mailingAddressLabel3">
                          <mat-error role="alert" *ngIf="validateMailingZip()"> Error: Please provide a zipcode
                          </mat-error>
                          <mat-error role="alert" *ngIf="applicantForm.get('mailingZip').hasError('pattern')"> Error: Zipcode should match this format: 99999 or 99999-1234
                          </mat-error>
                        </mat-form-field>

                        <mat-form-field *ngIf="applicantForm.get('mailingState').value === 'OR'" class="w-full md:w-[40%]">
                          <mat-label>County</mat-label>
                          <mat-select formControlName="mailingCounty">
                            <mat-option>-- None --</mat-option>
                            <mat-option *ngFor="let county of sharedService.counties" value={{county}}>{{county}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>

                  <app-residential-history [applicantId]="facilitatorLicense.applicants[0]?.id"
                                           [residentialHistory]="facilitatorLicense.applicants[0]?.residentialHistory"
                                           [licenseLocked]="licenseLocked"
                                           *ngIf="backgroundExpiring">
                  </app-residential-history>
                </mat-card-content>
              </mat-card>

              <mat-card *ngIf="sharedService.isAfterJan1st()">
                <mat-card-title>Licensed By</mat-card-title>
                <mat-card-content>
                  <div class="flex flex-col gap-3">
                    <span>Are you licensed by the boards listed below?</span>

                    <mat-card class="flex flex-col gap-2" *ngIf="sharedService.isAfterJan1st2027()">
                      <span id="occupationalTherapyLicensingBoard" class="text-wrap" [ngStyle]="{'color': (applicantForm.get('occupationalTherapyLicensingBoard').value == null && sharedService.isAfterJan1st2027())? 'red' : ''}">The Occupational Therapy Licensing Board</span>
                      <mat-radio-group aria-label="Select an option" formControlName="occupationalTherapyLicensingBoard" aria-describedby="occupationalTherapyLicensingBoard" class="gap-2">
                        <mat-radio-button [value]="true"><span class="f-s-16">Yes</span> </mat-radio-button>
                        <mat-radio-button [value]="false"><span class="f-s-16">No</span></mat-radio-button>
                      </mat-radio-group>
                      <mat-form-field *ngIf="applicantForm.get('occupationalTherapyLicensingBoard').value" class="w-full lg:w-[75%]">
                        <textarea matInput placeholder="License Number" cols="2" formControlName="occupationalTherapyLicensingBoardLicenseNumber" aria-describedby="occupationalTherapyLicensingBoard"></textarea>
                        <mat-error role="alert" *ngIf="validateOccupationalTherapyLicensingBoardLicenseNumber()"> Error: This field is required</mat-error>
                      </mat-form-field>
                      <mat-form-field *ngIf="applicantForm.get('occupationalTherapyLicensingBoard').value">
                        <mat-label>Expiration date of license</mat-label>
                        <input placeholder="mm/dd/yyyy" formControlName="occupationalTherapyLicensingBoardExpirationDate" matInput [matDatepicker]="occupationalTherapyLicensingBoardExpirationDate"/>
                        <mat-datepicker-toggle matSuffix [for]="occupationalTherapyLicensingBoardExpirationDate"></mat-datepicker-toggle>
                        <mat-datepicker #occupationalTherapyLicensingBoardExpirationDate>
                          <mat-datepicker-actions>
                            <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                            <button mat-button matDatepickerCancel>Cancel</button>
                          </mat-datepicker-actions>
                        </mat-datepicker>
                        <mat-error role="alert" *ngIf="validateOccupationalTherapyLicensingBoardExpirationDate()"> Error: This field is required</mat-error>
                      </mat-form-field>
                    </mat-card>

                    <mat-card class="flex flex-col gap-2">
                      <span id="boardOfLicensedCounselors" class="text-wrap" [ngStyle]="{'color': (applicantForm.get('boardOfLicensedCounselors').value == null && sharedService.isAfterJan1st())? 'red' : ''}">The Oregon Board of Licensed Professional Counselors and Therapists</span>
                      <mat-radio-group aria-label="Select an option" formControlName="boardOfLicensedCounselors" aria-describedby="boardOfLicensedCounselors" class="gap-2">
                        <mat-radio-button [value]="true"><span class="f-s-16">Yes</span></mat-radio-button>
                        <mat-radio-button [value]="false"><span class="f-s-16">No</span></mat-radio-button>
                      </mat-radio-group>
                      <mat-form-field *ngIf="applicantForm.get('boardOfLicensedCounselors').value" class="w-full lg:w-[75%]">
                        <textarea matInput placeholder="License Number" cols="2" formControlName="boardOfLicensedCounselorsLicenseNumber" aria-describedby="boardOfLicensedCounselors"></textarea>
                        <mat-error role="alert" *ngIf="validateBoardOfLicensedCounselorsLicenseNumber()"> Error: This field is required</mat-error>
                      </mat-form-field>
                      <mat-form-field *ngIf="applicantForm.get('boardOfLicensedCounselors').value">
                        <mat-label>Expiration date of license</mat-label>
                        <input placeholder="mm/dd/yyyy" formControlName="boardOfLicensedCounselorsExpirationDate" matInput [matDatepicker]="boardOfLicensedCounselorsExpirationDate"/>
                        <mat-datepicker-toggle matSuffix [for]="boardOfLicensedCounselorsExpirationDate"></mat-datepicker-toggle>
                        <mat-datepicker #boardOfLicensedCounselorsExpirationDate>
                          <mat-datepicker-actions>
                            <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                            <button mat-button matDatepickerCancel>Cancel</button>
                          </mat-datepicker-actions>
                        </mat-datepicker>
                        <mat-error role="alert" *ngIf="validateBoardOfLicensedCounselorsExpirationDate()"> Error: This field is required</mat-error>
                      </mat-form-field>
                    </mat-card>

                    <mat-card class="flex flex-col gap-2">
                      <span id="boardOfNaturopathic" class="text-wrap" [ngStyle]="{'color': (applicantForm.get('boardOfNaturopathic').value == null && sharedService.isAfterJan1st()) ? 'red' : ''}">The Oregon Board of Naturopathic Medicine</span>
                      <mat-radio-group aria-label="Select an option" formControlName="boardOfNaturopathic" aria-describedby="boardOfNaturopathic" class="gap-2">
                        <mat-radio-button [value]="true"><span class="f-s-16">Yes</span></mat-radio-button>
                        <mat-radio-button [value]="false"><span class="f-s-16">No</span></mat-radio-button>
                      </mat-radio-group>

                      <mat-form-field *ngIf="applicantForm.get('boardOfNaturopathic').value" class="w-full lg:w-[75%]">
                        <textarea matInput placeholder="License Number" cols="2" formControlName="boardOfNaturopathicLicenseNumber" aria-describedby="boardOfNaturopathic"></textarea>
                        <mat-error role="alert" *ngIf="validateBoardOfNaturopathicLicenseNumber()"> Error: This field is required</mat-error>
                      </mat-form-field>

                      <mat-form-field *ngIf="applicantForm.get('boardOfNaturopathic').value">
                        <mat-label>Expiration date of license</mat-label>
                        <input placeholder="mm/dd/yyyy" formControlName="boardOfNaturopathicExpirationDate" matInput [matDatepicker]="boardOfNaturopathicExpirationDate"/>
                        <mat-datepicker-toggle matSuffix [for]="boardOfNaturopathicExpirationDate"></mat-datepicker-toggle>
                        <mat-datepicker #boardOfNaturopathicExpirationDate>
                          <mat-datepicker-actions>
                            <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                            <button mat-button matDatepickerCancel>Cancel</button>
                          </mat-datepicker-actions>
                        </mat-datepicker>
                        <mat-error role="alert" *ngIf="validateBoardOfNaturopathicExpirationDate()"> Error: This field is required</mat-error>
                      </mat-form-field>
                    </mat-card>

                    <mat-card class="flex flex-col gap-2" *ngIf="sharedService.isAfterJan1st2027()">
                      <span id="boardOfPhysicalTherapy" class="text-wrap" [ngStyle]="{'color': (applicantForm.get('boardOfPhysicalTherapy').value == null && sharedService.isAfterJan1st2027())? 'red' : ''}">The Oregon Board of Physical Therapy</span>
                      <mat-radio-group aria-label="Select an option" formControlName="boardOfPhysicalTherapy" aria-describedby="boardOfPhysicalTherapy" class="gap-2">
                        <mat-radio-button [value]="true"><span class="f-s-16">Yes</span> </mat-radio-button>
                        <mat-radio-button [value]="false"><span class="f-s-16">No</span></mat-radio-button>
                      </mat-radio-group>
                      <mat-form-field *ngIf="applicantForm.get('boardOfPhysicalTherapy').value" class="w-full lg:w-[75%]">
                        <textarea matInput placeholder="License Number" cols="2" formControlName="boardOfPhysicalTherapyLicenseNumber" aria-describedby="boardOfPhysicalTherapy"></textarea>
                        <mat-error role="alert" *ngIf="validateBoardOfPhysicalTherapyLicenseNumber()"> Error: This field is required</mat-error>
                      </mat-form-field>
                      <mat-form-field *ngIf="applicantForm.get('boardOfPhysicalTherapy').value">
                        <mat-label>Expiration date of license</mat-label>
                        <input placeholder="mm/dd/yyyy" formControlName="boardOfPhysicalTherapyExpirationDate" matInput [matDatepicker]="boardOfPhysicalTherapyExpirationDate"/>
                        <mat-datepicker-toggle matSuffix [for]="boardOfPhysicalTherapyExpirationDate"></mat-datepicker-toggle>
                        <mat-datepicker #boardOfPhysicalTherapyExpirationDate>
                          <mat-datepicker-actions>
                            <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                            <button mat-button matDatepickerCancel>Cancel</button>
                          </mat-datepicker-actions>
                        </mat-datepicker>
                        <mat-error role="alert" *ngIf="validateBoardOfPhysicalTherapyExpirationDate()"> Error: This field is required</mat-error>
                      </mat-form-field>
                    </mat-card>

                    <mat-card class="flex flex-col gap-2">
                      <span id="medicalBoard" class="text-wrap" [ngStyle]="{'color': (applicantForm.get('medicalBoard').value == null && sharedService.isAfterJan1st()) ? 'red' : ''}">The Oregon Medical Board</span>
                      <mat-radio-group aria-label="Select an option" formControlName="medicalBoard" aria-describedby="medicalBoard" class="gap-2">
                        <mat-radio-button [value]="true"><span class="f-s-16">Yes</span></mat-radio-button>
                        <mat-radio-button [value]="false"><span class="f-s-16">No</span></mat-radio-button>
                      </mat-radio-group>


                      <mat-form-field *ngIf="applicantForm.get('medicalBoard').value" class="w-full lg:w-[75%]">
                        <textarea matInput placeholder="License Number" cols="2" formControlName="medicalBoardLicenseNumber" aria-describedby="medicalBoard"></textarea>
                        <mat-error role="alert" *ngIf="validateMedicalBoardLicenseNumber()"> Error: This field is required</mat-error>
                      </mat-form-field>

                      <mat-form-field *ngIf="applicantForm.get('medicalBoard').value">
                        <mat-label>Expiration date of license</mat-label>
                        <input placeholder="mm/dd/yyyy" formControlName="medicalBoardExpirationDate" matInput [matDatepicker]="medicalBoardExpirationDate"/>
                        <mat-datepicker-toggle matSuffix [for]="medicalBoardExpirationDate"></mat-datepicker-toggle>
                        <mat-datepicker #medicalBoardExpirationDate>
                          <mat-datepicker-actions>
                            <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                            <button mat-button matDatepickerCancel>Cancel</button>
                          </mat-datepicker-actions>
                        </mat-datepicker>
                        <mat-error role="alert" *ngIf="validateMedicalBoardExpirationDate()"> Error: This field is required</mat-error>
                      </mat-form-field>
                    </mat-card>

                    <mat-card class="flex flex-col gap-2">
                      <span id="boardOfPsychology" class="text-wrap" [ngStyle]="{'color': (applicantForm.get('boardOfPsychology').value == null && sharedService.isAfterJan1st()) ? 'red' : ''}">The Oregon Board of Psychology</span>
                      <mat-radio-group aria-label="Select an option" formControlName="boardOfPsychology" aria-describedby="boardOfPsychology" class="gap-2">
                        <mat-radio-button [value]="true"><span class="f-s-16">Yes</span></mat-radio-button>
                        <mat-radio-button [value]="false"><span class="f-s-16">No</span></mat-radio-button>
                      </mat-radio-group>


                      <mat-form-field *ngIf="applicantForm.get('boardOfPsychology').value" class="w-full lg:w-[75%]">
                        <textarea matInput placeholder="License Number" cols="2" formControlName="boardOfPsychologyLicenseNumber" aria-describedby="boardOfPsychology"></textarea>
                        <mat-error role="alert" *ngIf="validateBoardOfPsychologyLicenseNumber()"> Error: This field is required</mat-error>
                      </mat-form-field>

                      <mat-form-field *ngIf="applicantForm.get('boardOfPsychology').value">
                        <mat-label>Expiration date of license</mat-label>
                        <input placeholder="mm/dd/yyyy" formControlName="boardOfPsychologyExpirationDate" matInput [matDatepicker]="boardOfPsychologyExpirationDate"/>
                        <mat-datepicker-toggle matSuffix [for]="boardOfPsychologyExpirationDate"></mat-datepicker-toggle>
                        <mat-datepicker #boardOfPsychologyExpirationDate>
                          <mat-datepicker-actions>
                            <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                            <button mat-button matDatepickerCancel>Cancel</button>
                          </mat-datepicker-actions>
                        </mat-datepicker>
                        <mat-error role="alert" *ngIf="validateBoardOfPsychologyExpirationDate()"> Error: This field is required</mat-error>
                      </mat-form-field>
                    </mat-card>

                    <mat-card class="flex flex-col gap-2">
                      <span id="boardOfNursing" class="text-wrap" [ngStyle]="{'color': (applicantForm.get('boardOfNursing').value == null && sharedService.isAfterJan1st()) ? 'red' : ''}">The Oregon State Board of Nursing</span>
                      <mat-radio-group aria-label="Select an option" formControlName="boardOfNursing" aria-describedby="boardOfNursing" class="gap-2">
                        <mat-radio-button [value]="true"><span class="f-s-16">Yes</span></mat-radio-button>
                        <mat-radio-button [value]="false"><span class="f-s-16">No</span></mat-radio-button>
                      </mat-radio-group>

                      <mat-form-field *ngIf="applicantForm.get('boardOfNursing').value" class="w-full lg:w-[75%]">
                        <textarea matInput placeholder="License Number" cols="2" formControlName="boardOfNursingLicenseNumber" aria-describedby="boardOfNursing"></textarea>
                        <mat-error role="alert" *ngIf="validateBoardOfNursingLicenseNumber()"> Error: This field is required</mat-error>
                      </mat-form-field>

                      <mat-form-field *ngIf="applicantForm.get('boardOfNursing').value">
                        <mat-label>Expiration date of license</mat-label>
                        <input placeholder="mm/dd/yyyy" formControlName="boardOfNursingExpirationDate" matInput [matDatepicker]="boardOfNursingExpirationDate"/>
                        <mat-datepicker-toggle matSuffix [for]="boardOfNursingExpirationDate"></mat-datepicker-toggle>
                        <mat-datepicker #boardOfNursingExpirationDate>
                          <mat-datepicker-actions>
                            <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                            <button mat-button matDatepickerCancel>Cancel</button>
                          </mat-datepicker-actions>
                        </mat-datepicker>
                        <mat-error role="alert" *ngIf="validateBoardOfNursingExpirationDate()"> Error: This field is required</mat-error>
                      </mat-form-field>
                    </mat-card>

                    <mat-card class="flex flex-col gap-2">
                      <span id="boardOfSocialWorkers" class="text-wrap" [ngStyle]="{'color': (applicantForm.get('boardOfSocialWorkers').value == null && sharedService.isAfterJan1st()) ? 'red' : ''}">The State Board of Licensed Social Workers</span>
                      <mat-radio-group aria-label="Select an option" formControlName="boardOfSocialWorkers" aria-describedby="boardOfSocialWorkers" class="gap-2">
                        <mat-radio-button [value]="true"><span class="f-s-16">Yes</span></mat-radio-button>
                        <mat-radio-button [value]="false"><span class="f-s-16">No</span></mat-radio-button>
                      </mat-radio-group>

                      <mat-form-field *ngIf="applicantForm.get('boardOfSocialWorkers').value" class="w-full lg:w-[75%]">
                        <textarea matInput placeholder="License Number" cols="2" formControlName="boardOfSocialWorkersLicenseNumber" aria-describedby="boardOfSocialWorkers"></textarea>
                        <mat-error role="alert" *ngIf="validateBoardOfSocialWorkersLicenseNumber()"> Error: This field is required</mat-error>
                      </mat-form-field>

                      <mat-form-field *ngIf="applicantForm.get('boardOfSocialWorkers').value">
                        <mat-label>Expiration date of license</mat-label>
                        <input placeholder="mm/dd/yyyy" formControlName="boardOfSocialWorkersExpirationDate" matInput [matDatepicker]="boardOfSocialWorkersExpirationDate"/>
                        <mat-datepicker-toggle matSuffix [for]="boardOfSocialWorkersExpirationDate"></mat-datepicker-toggle>
                        <mat-datepicker #boardOfSocialWorkersExpirationDate>
                          <mat-datepicker-actions>
                            <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                            <button mat-button matDatepickerCancel>Cancel</button>
                          </mat-datepicker-actions>
                        </mat-datepicker>
                        <mat-error role="alert" *ngIf="validateBoardOfSocialWorkersExpirationDate()"> Error: This field is required</mat-error>
                      </mat-form-field>
                    </mat-card>

                    <mat-card class="flex flex-col gap-2">
                      <span id="boardOfPharmacy" class="text-wrap" [ngStyle]="{'color': (applicantForm.get('boardOfPharmacy').value == null && sharedService.isAfterJan1st()) ? 'red' : ''}">The State Board of Pharmacy</span>
                      <mat-radio-group aria-label="Select an option" formControlName="boardOfPharmacy" aria-describedby="boardOfPharmacy" class="gap-2">
                        <mat-radio-button [value]="true"><span class="f-s-16">Yes</span></mat-radio-button>
                        <mat-radio-button [value]="false"><span class="f-s-16">No</span></mat-radio-button>
                      </mat-radio-group>

                      <mat-form-field *ngIf="applicantForm.get('boardOfPharmacy').value" class="w-full lg:w-[75%]">
                        <textarea matInput placeholder="License Number" cols="2" formControlName="boardOfPharmacyLicenseNumber"></textarea>
                        <mat-error role="alert" *ngIf="validateBoardOfPharmacyLicenseNumber()"> Error: This field is required</mat-error>
                      </mat-form-field>

                      <mat-form-field *ngIf="applicantForm.get('boardOfPharmacy').value">
                        <mat-label>Expiration date of license</mat-label>
                        <input placeholder="mm/dd/yyyy" formControlName="boardOfPharmacyExpirationDate" matInput [matDatepicker]="boardOfPharmacyExpirationDate"/>
                        <mat-datepicker-toggle matSuffix [for]="boardOfPharmacyExpirationDate"></mat-datepicker-toggle>
                        <mat-datepicker #boardOfPharmacyExpirationDate>
                          <mat-datepicker-actions>
                            <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                            <button mat-button matDatepickerCancel>Cancel</button>
                          </mat-datepicker-actions>
                        </mat-datepicker>
                        <mat-error role="alert" *ngIf="validateBoardOfPharmacyExpirationDate()"> Error: This field is required</mat-error>
                      </mat-form-field>
                    </mat-card>
                  </div>
                </mat-card-content>
              </mat-card>
            </div>
          </div>

          <div class="flex flex-col 2xl:flex-row gap-2">
            <mat-card class="w-full 2xl:w-1/2">
              <mat-card-title>
                <span *ngIf="applicantDocumentsValid && showOregonResidency(facilitatorLicense.applicationDate)">
                  Identity and Residency Verification
                </span>
                <span *ngIf="!applicantDocumentsValid && showOregonResidency(facilitatorLicense.applicationDate)" class="text-red-400">
                  Identity and Residency Verification Incomplete
                </span>
                <span *ngIf="applicantDocumentsValid && !showOregonResidency(facilitatorLicense.applicationDate)">
                  Identity Verification
                </span>
                <span *ngIf="!applicantDocumentsValid && !showOregonResidency(facilitatorLicense.applicationDate)" class="text-red-400">
                  Identity Verification Incomplete
                </span>
              </mat-card-title>
              <mat-card-content>
                <div *ngIf="showOregonResidency(facilitatorLicense.applicationDate)" class="flex flex-row">
                <mat-checkbox formControlName="oregonResidency">
                  <span class="text-wrap" [ngStyle]="{'color': applicantForm.get('oregonResidency').hasError('required') && applicantForm.get('oregonResidency').touched? 'red' : ''}">I certify that I am a current Oregon resident and have been a resident of Oregon for two or more years</span>
                  <mat-error role="alert" *ngIf="applicantForm.get('oregonResidency').hasError('required') && applicantForm.get('oregonResidency').touched"> Error: You must attest to being an Oregon resident
                  </mat-error>
                </mat-checkbox>
              </div>
              <div class="flex flex-row">
                <mat-checkbox formControlName="highSchoolDiploma">
                  <span class="text-wrap" [ngStyle]="{'color': applicantForm.get('highSchoolDiploma').hasError('required') && applicantForm.get('highSchoolDiploma').touched? 'red' : ''}">I certify I have a high school diploma or equivalent education as required by ORS 475A.325 (2)(d)</span>
                  <mat-error role="alert" *ngIf="applicantForm.get('highSchoolDiploma').hasError('required') && applicantForm.get('highSchoolDiploma').touched"> Error: You must attest to having a high school diploma or equivalent education
                  </mat-error>
                </mat-checkbox>
              </div>
                <div style="padding-top: 2em" class="flex flex-col">
                  <span>You must upload a copy of the <strong><i>front and back</i></strong> of a valid, unexpired government-issued photo identification. Accepted identification includes:</span>
                  <ul class="flex flex-col gap-2 f-s-16">
                    <li>
                      Passport;
                    </li>
                    <li>
                      Driver license, whether issued by the State of Oregon or by another state of the United States - <i>front and back</i>;
                    </li>
                    <li>
                      Identification card issued under ORS 807.400 - <i>front and back</i>;
                    </li>
                    <li>
                      United States military identification card - <i>front and back</i>;
                    </li>
                    <li>
                      An identification card issued by a federally recognized Indian tribe with photo, name and date of birth - <i>front and back</i>; or
                    </li>
                    <li>
                      Any other identification card issued by a state or territory that bears a picture of the person,
                      the name of the person, the person's date of birth and a physical description of the person - <i>front and back</i>
                    </li>
                  </ul>

                  <div class="m-t-8 flex flex-col gap-2">
                    <span class="f-s-14" [ngClass]="applicantDocumentsValid ? '' : 'text-red-400'">Upload Your Identification</span>
                    <input type="file" accept=".doc,.docx,.rtf,.xls,.xlsx,.pdf,.txt,.png,.jpg,.jpeg,.bmp" class="file-input" (change)="uploadApplicantDocument($event)"
                      #applicantFileUpload />
                    <div class="flex flex-row gap-2">
                      <div class="file-upload">
                        <button type="button" [disabled]="licenseLocked"
                          mat-raised-button color="primary" class="upload-btn" (click)="applicantFileUpload.click()">
                          Browse
                          <mat-icon>attach_file</mat-icon>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
            <mat-card class="w-full lg:w-1/2">
              <mat-card-title>
                <span>Current Documents</span>
              </mat-card-title>
              <mat-card-content>
                <div class="flex flex-col gap-2 f-s-16">
                  <div *ngIf="!sharedService.mobile" class="flex flex-row md:items-center">
                    <div class="flex w-full md:w-1/2">
                      <span class="f-s-16"><strong>File</strong></span>
                    </div>
                    <div class="flex w-full md:w-1/2 md:flex-row md:items-center md:justify-between">
                      <div class="flex flex-col md:w-[70%]">
                        <span class="f-s-16"><strong>Requirement</strong></span>
                      </div>
                      <div class="flex items-center justify-end">
                      </div>
                    </div>
                  </div>
                  <ng-container *ngFor="let document of facilitatorLicense.applicants[0]?.applicantDocuments">
                    <div class="flex flex-col gap-2 border-b border-gray-200 py-2 last:border-b-0 md:flex-row md:items-center">
                      <div class="flex w-full flex-col md:w-1/2">
                        <span *ngIf="sharedService.mobile" class="f-s-14"><strong>File</strong></span>
                        <span class="w-full break-words text-indigo-A700 f-s-16" style="cursor: pointer" (click)="downloadDocument(document.id, document.name, true)" title="{{document.name}}">{{document.name.length > 15 ? document.name.substring(0,15) + "..." : document.name}}</span>
                      </div>
                      <div class="flex w-full flex-col gap-2 md:w-1/2 md:flex-row md:items-center md:justify-between">
                        <div class="flex flex-col break-words md:w-[70%] f-s-16">
                          <span *ngIf="sharedService.mobile" class="f-s-14"><strong>Requirement</strong></span>
                          <span *ngFor="let type of document.types">
                            {{documentTypeReference[type]}}
                          </span>
                        </div>
                        <div class="flex items-center justify-start gap-2 md:justify-end">
                          <button *ngIf="!licenseLocked && !document.deprecated" type="button" mat-icon-button class="m-8" (click)="deleteFile(document.id, document.name, true)"
                            color="warn" aria-label="Delete">
                            <mat-icon>delete</mat-icon>
                          </button>
                          <span *ngIf="document.deprecated" style="color:red">Deprecated</span>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>

        <mat-card class="flex flex-col gap-2">
          <div class="flex flex-row">
              <div class="flex flex-col gap-2">
                <span class="text-wrap">Is all the information on this screen current and correct?</span>
                <span id="applicantPageCorrect" class="text-wrap">Some information may be outdated or incorrect but you cannot change it on this application.
                  These changes require additional documentation and possibly additional fees. These changes are made by a Change Request.
                  If information is incorrect or outdated, please select "No," below and follow the instructions for a Change Request.</span>
                <mat-radio-group aria-label="Select an option" formControlName="applicantPageCorrect" aria-describedby="applicantPageCorrect" class="gap-2">
                  <mat-radio-button [value]="true"><span class="f-s-16">Yes</span></mat-radio-button>
                  <mat-radio-button [value]="false"><span class="f-s-16">No</span></mat-radio-button>
                </mat-radio-group>
                <mat-error role="alert" *ngIf="applicantForm.get('applicantPageCorrect').hasError('required')"> Error: This field is required</mat-error>
              </div>
          </div>

          <div *ngIf="applicantForm.get('applicantPageCorrect').value == false" class="flex flex-row">
            <div class="flex flex-col md:!w-[40%] w-full">
              <mat-form-field>
                <textarea rows="2" matInput placeholder="Please list the information that is not current and correct" formControlName="applicantPageCorrectReason" aria-describedby="applicantPageCorrect"></textarea>
                <mat-error role="alert" *ngIf="validateApplicantPageCorrect()"> Error: This field is required
                </mat-error>
               </mat-form-field>
               <span>You are required to submit a Change Request to update this information. For more information on Change Requests, please see the TLC Home Page, Change Requests section. This is the first page you see when you log into TLC.</span>
            </div>
          </div>
        </mat-card>
      </form>

      <div class="p-t-16 flex sm:flex-row flex-col gap-2 w-full md:w-1/2">
        <button mat-raised-button matStepperPrevious>{{!licenseLocked? "Save and " : ""}}Back</button>
        <button mat-raised-button matStepperNext>{{!licenseLocked? "Save and " : ""}}Continue</button>
      </div>
    </mat-step>

    <!--Documents-->
     <mat-step [stepControl]="documentsForm" *ngIf="facilitatorLicenses.length > 0">
      <form [formGroup]="documentsForm">
        <ng-template matStepLabel>

          <span *ngIf="((documentsForm.valid && licenseDocumentsValid) || documentsForm.pristine || licenseLocked)"
            matTooltip="Documents" matTooltipPosition="below" [matTooltipShowDelay]="500">Documents</span>

          <span class="text-red-400" *ngIf="((!documentsForm.valid && !documentsForm.pristine) || !licenseDocumentsValid) && !licenseLocked"
            matTooltip="Documents Incomplete" matTooltipPosition="below" [matTooltipShowDelay]="500">Documents Incomplete</span>

          </ng-template>
        <div class="flex flex-col gap-2">
          <div class="flex flex-col lg:flex-row">
            <mat-card class="w-full">
              <mat-card-title>
                Upload the Following Documentation to Apply to Renew Your Psilocybin Facilitator License:
              </mat-card-title>
              <mat-card-content>
                <div class="p-b-8 flex flex-col gap-2">
                  <ul class="flex flex-col gap-2 f-s-16">
                    <li>Social Equity Plan Evaluation</li>
                    <li><a href="https://www.oregon.gov/oha/PH/PREVENTIONWELLNESS/Documents/Continuing-Facilitator-Education-Hours-Log.pdf" target="_blank">OPS Continuing Facilitator Education Hours Log</a> AND proof of attendance
                      <ul>
                        <li>This form can be located on the <a href="https://www.oregon.gov/oha/PH/PREVENTIONWELLNESS/Pages/Oregon-Psilocybin-Services.aspx" target="_blank">OPS website</a></li>
                        <li>A certificate or other proof of attendance is required from the training, conference, or organization you attended to verify the completion of your continuing education hours. This documentation must be submitted along with this form.</li>
                      </ul>
                    </li>
                    <li>Updated Social Equity Plan (not required)</li>
                    <li *ngIf="!sharedService.isAfterJan1st2027()">A copy of your certificate of completion from a psilocybin facilitator training program with an OPS approved curriculum (not required)</li>
                    <li *ngIf="sharedService.isAfterJan1st2027()">A copy of your certificate of completion from a psilocybin facilitator training program with OPS-approved curriculum or by an out-of-state training program that meets or exceeds OPS curriculum. Currently the only other state that meets or exceeds OPS curriculum is the State of Colorado. (not required)</li>
                    <div style="padding-left: 2em" class="flex flex-col" *ngIf="!sharedService.isAfterJan1st2027()">
                      <li>Please note: the facilitator training program must have an OPS approved curriculum</li>
                    </div>
                    <li>If you are requesting a reduced licensing fee, please upload one of the following required supporting documents:</li>

                    <div style="padding-left: 2em" class="flex flex-col">
                      <li>A copy of a current monthly Supplemental Security Income benefit statement showing dates of coverage</li>
                    </div>
                    <div style="padding-left: 2em" class="flex flex-col">
                      <li>A copy of the applicant's current eligibility statement or card if enrolled in Oregon Health Plan</li>
                    </div>
                    <div style="padding-left: 2em" class="flex flex-col">
                      <li>A copy of current proof of food stamp benefits from the Oregon Supplemental Nutrition Assistance Program </li>
                    </div>
                    <div style="padding-left: 2em" class="flex flex-col">
                      <li>A copy of proof of having served in the Armed Forces, such as but not limited to, submitting a Veteran's Administration form DD-214</li>
                    </div>
                  </ul>
                </div>
              </mat-card-content>
            </mat-card>
          </div>

          <div class="flex flex-col 2xl:flex-row gap-4 w-full">
            <mat-card class="w-full 2xl:w-1/2">
              <mat-card-title>
                Upload Supporting Documents
              </mat-card-title>
              <mat-card-content>
                <div class="flex flex-col gap-2">
                  <span class="f-2-16">For each document select the requirements it verifies</span>
                  <div class="p-t-8 flex flex-col gap-2">

                    <div class="flex flex-col">
                      <mat-checkbox formControlName="trainingCertificate" [labelPosition]="'before'">
                       <span [ngClass]="missingTypes[trainingCertificateType]? 'text-red-400' : ''">Training Certificate</span>
                      </mat-checkbox>

                      <mat-checkbox formControlName="updatedEquityPlan" [labelPosition]="'before'">
                        <span [ngClass]="missingTypes[updatedEquityPlanType]? 'text-red-400' : ''">
                          Updated Social Equity Plan
                        </span>
                      </mat-checkbox>

                      <mat-checkbox formControlName="equityPlanEvaluation" [labelPosition]="'before'">
                        <span [ngClass]="missingTypes[equityPlanEvaluationType]? 'text-red-400' : ''">
                          Social Equity Plan Evaluation
                        </span>
                      </mat-checkbox>

                      <mat-checkbox formControlName="educationHoursLog" [labelPosition]="'before'">
                        <span [ngClass]="missingTypes[educationHoursLogType]? 'text-red-400' : ''">
                          Continuing Facilitator Education Hours Log AND proof of attendance
                        </span>
                      </mat-checkbox>

                      <mat-checkbox formControlName="reducedFee" [labelPosition]="'before'">Reduced Fee</mat-checkbox>
                    </div>

                    <input type="file" accept=".doc,.docx,.rtf,.xls,.xlsx,.pdf,.txt,.png,.jpg,.jpeg,.bmp" class="file-input" (change)="uploadLicenseDocument($event)" #fileUpload />
                    <div class="flex flex-row gap-2">
                      <div class="file-upload">
                        <button [disabled]="!documentsForm.get('trainingCertificate').value &&
                                            !documentsForm.get('socialEquityPlan').value &&
                                            !documentsForm.get('reducedFee').value &&
                                            !documentsForm.get('updatedEquityPlan').value &&
                                            !documentsForm.get('equityPlanEvaluation').value &&
                                            !documentsForm.get('educationHoursLog').value"
                                mat-raised-button color="primary" class="upload-btn" (click)="fileUpload.click()">
                          Browse
                          <mat-icon>attach_file</mat-icon>
                        </button>
                      </div>
                    </div>

                  </div>
                </div>
              </mat-card-content>
            </mat-card>

            <mat-card class="w-full lg:w-1/2">
              <mat-card-title>
                <span *ngIf="applicantDocumentsValid">Current Documents</span>
              </mat-card-title>
              <mat-card-content>
                <div class="flex flex-col gap-2 f-s-16">
                  <div *ngIf="!sharedService.mobile" class="flex flex-row md:items-center">
                    <div class="flex w-full md:w-1/2">
                      <span class="f-s-16"><strong>File</strong></span>
                    </div>
                    <div class="flex w-full md:w-1/2 md:flex-row md:items-center md:justify-between">
                      <div class="flex flex-col md:w-[70%]">
                        <span class="f-s-16"><strong>Requirement</strong></span>
                      </div>
                      <div class="flex items-center justify-end">
                      </div>
                    </div>
                  </div>
                  <ng-container *ngFor="let document of this.facilitatorLicense.licenseDocuments">
                    <div class="flex flex-col gap-2 border-b border-gray-200 py-2 last:border-b-0 md:flex-row md:items-center">
                      <div class="flex w-full flex-col md:w-1/2">
                        <span *ngIf="sharedService.mobile" class="f-s-14"><strong>File</strong></span>
                        <span class="w-full break-words text-indigo-A700 f-s-16" style="cursor: pointer" (click)="downloadDocument(document.id, document.name, false)" title="{{document.name}}">{{document.name.length > 15 ? document.name.substring(0,15) + "..." : document.name}}</span>
                      </div>
                      <div class="flex w-full flex-col gap-2 md:w-1/2 md:flex-row md:items-center md:justify-between">
                        <div class="flex flex-col break-words md:w-[70%] f-s-16">
                          <span *ngIf="sharedService.mobile" class="f-s-14"><strong>Requirement</strong></span>
                          <span *ngFor="let type of document.types">
                            {{documentTypeReference[type]}}
                          </span>
                        </div>
                        <div class="flex items-center justify-start md:justify-end">
                          <button *ngIf="!licenseLocked" type="button" mat-icon-button class="m-8" (click)="deleteFile(document.id, document.name, false)"
                            color="warn" aria-label="Delete">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </mat-card-content>
            </mat-card>
          </div>

          <div class="flex flex-row">
            <mat-card class="w-full">
              <mat-card-title>
                Training Program Information
              </mat-card-title>
              <mat-card-content>
                <div class="flex flex-col gap-2 w-full lg:w-1/2">
                  <span>Name of Training Program with OHA Approved Curriculum</span>
                  <div class="flex flex-col lg:flex-row gap-2">

                    <div class="flex flex-col gap-2 md:w-[75%] w-full">

                      <mat-form-field>
                        <mat-label>Approved Training Programs</mat-label>
                        <input type="text"
                               placeholder="Training Program"
                               aria-label="Training Program"
                               matInput
                               formControlName="trainingProgram"
                               [matAutocomplete]="auto">
                        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                          <mat-option *ngFor="let trainingProgram of filteredOptions | async" [value]="trainingProgram">
                            {{trainingProgram}}
                          </mat-option>
                        </mat-autocomplete>
                      </mat-form-field>
                  </div>
                  <div class="flex flex-col gap-2 md:w-[25%] w-full">
                    <mat-form-field>
                      <mat-label>Date Completed</mat-label>
                      <input placeholder="mm/dd/yyyy" formControlName="trainingDate" matInput [matDatepicker]="trainingDate"
                        [max]="sharedService.today" />
                      <mat-datepicker-toggle matSuffix [for]="trainingDate"></mat-datepicker-toggle>
                      <mat-datepicker #trainingDate>
                        <mat-datepicker-actions>
                          <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                          <button mat-button matDatepickerCancel>Cancel</button>
                        </mat-datepicker-actions>
                      </mat-datepicker>
                      <mat-error role="alert" *ngIf="documentsForm.get('trainingDate').value > sharedService.today">
                        Error: Please choose an earlier date.
                      </mat-error>
                      <mat-error role="alert" *ngIf="documentsForm.get('trainingDate').hasError('required')"> Error: Training Date is required
                      </mat-error>
                    </mat-form-field>
                    </div>
                  </div>
                  <div class="flex flex-col gap-2 w-full lg:w-1/2 f-s-16" *ngIf="sharedService.isAfterJan1st2027()">
                    <span>Name of Training Program with Out-of-State Approved Curriculum</span>
                    <div class="flex flex-col lg:flex-row gap-2">
                      <div class="flex flex-col gap-2 md:w-[75%] w-full">
                        <mat-form-field>
                          <mat-label>Out-of-State Approved Training Program</mat-label>
                          <mat-select formControlName="oosTrainingProgram"
                                      placeholder="Training Program"
                                      aria-label="Training Program">
                            <mat-option [value]="''">-- None --</mat-option>
                            <mat-option *ngFor="let oosTrainingProgram of oosTrainingPrograms" [value]="oosTrainingProgram">
                              {{oosTrainingProgram}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="flex flex-col gap-2 md:w-[25%] w-full">
                        <mat-form-field>
                          <mat-label>Date Completed</mat-label>
                          <input placeholder="mm/dd/yyyy" formControlName="oosTrainingDate" matInput [matDatepicker]="oosTrainingDate"
                            [max]="sharedService.today" />
                          <mat-datepicker-toggle matSuffix [for]="oosTrainingDate"></mat-datepicker-toggle>
                          <mat-datepicker #oosTrainingDate>
                            <mat-datepicker-actions>
                              <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                              <button mat-button matDatepickerCancel>Cancel</button>
                            </mat-datepicker-actions>
                          </mat-datepicker>
                          <mat-error role="alert" *ngIf="documentsForm.get('oosTrainingDate').value > sharedService.today">
                            Error: Please choose an earlier date.
                          </mat-error>
                          <mat-error role="alert" *ngIf="documentsForm.get('oosTrainingDate').hasError('required')"> Error: Training Date is required
                          </mat-error>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
          <mat-card class="flex flex-col gap-2">
            <div class="flex flex-row">
                <div class="flex flex-col gap-2">
                  <span class="text-wrap">Is all the information on this screen current and correct?</span>
                  <span id="documentPageCorrect" class="text-wrap">Some information may be outdated or incorrect but you cannot change it on this application.
                    These changes require additional documentation and possibly additional fees. These changes are made by a Change Request.
                    If information is incorrect or outdated, please select "No," below and follow the instructions for a Change Request.</span>
                  <mat-radio-group aria-label="Select an option" formControlName="documentPageCorrect" aria-describedby="documentPageCorrect" class="gap-2">
                    <mat-radio-button [value]="true"><span class="f-s-16">Yes</span></mat-radio-button>
                    <mat-radio-button [value]="false"><span class="f-s-16">No</span></mat-radio-button>
                  </mat-radio-group>
                  <mat-error role="alert" *ngIf="documentsForm.get('documentPageCorrect').hasError('required')"> Error: This field is required</mat-error>
                </div>
            </div>

            <div *ngIf="documentsForm.get('documentPageCorrect').value == false" class="flex flex-row">
              <div class="flex flex-col md:w-[40%] w-full">
                <mat-form-field>
                  <textarea rows="2" matInput placeholder="Please list the information that is not current and correct" formControlName="documentPageCorrectReason" aria-describedby="documentPageCorrect"></textarea>
                  <mat-error role="alert" *ngIf="validateDocumentsCorrect()"> Error: This field is required
                  </mat-error>
                 </mat-form-field>
                 <span>You are required to submit a Change Request to update this information. For more information on Change Requests, please see the TLC Home Page, Change Requests section. This is the first page you see when you log into TLC.</span>
              </div>
            </div>
          </mat-card>
        </div>
      </form>
      <div class="p-t-16 flex sm:flex-row flex-col gap-2 w-full md:w-1/2">
        <button mat-raised-button matStepperPrevious>{{!licenseLocked? "Save and " : ""}}Back</button>
        <button mat-raised-button matStepperNext>{{!licenseLocked? "Save and " : ""}}Continue</button>
      </div>
    </mat-step>

    <!--Fees-->
    <mat-step *ngIf="facilitatorLicenses.length > 0">
      <ng-template matStepLabel>
        <span matTooltip="Fee Information" matTooltipPosition="below" [matTooltipShowDelay]="500">Fee Information</span>
      </ng-template>
      <div class="flex flex-col gap-2 w-full lg:w-1/2">
        <span *ngIf="sharedService.tablet" class="f-s-16">Fees</span>
        <app-payment-notice [canPay]="false" entityType="FacilitatorLicense" feeType="ApplicationFee" [renewal]="renewing"></app-payment-notice>
        <div class="p-t-16 flex sm:flex-row flex-col gap-2 w-full md:w-1/2">
          <button mat-raised-button matStepperPrevious>Back</button>
          <button mat-raised-button matStepperNext>Continue</button>
        </div>
      </div>
    </mat-step>

    <!--Verify and Submit-->
    <mat-step [stepControl]="licenseForm" (ngSubmit)="submitApplication()" *ngIf="facilitatorLicenses.length > 0">
      <ng-template matStepLabel>
        <span matTooltip="Review and Submit" matTooltipPosition="below" [matTooltipShowDelay]="500">Review and Submit</span>
      </ng-template>
      <div class="flex flex-col gap-2">
        <div class="flex flex-col 2xl:flex-row gap-2">
          <mat-card class="w-full 2xl:w-1/2">
            <mat-card-title>
              <span *ngIf="applicantForm.valid || licenseLocked">Applicant Information</span>
              <span class="text-red-400" *ngIf="!applicantForm.valid && !licenseLocked">Applicant Information Incomplete</span>
            </mat-card-title>
            <mat-card-content>
              <div class="p-b-16 flex flex-col gap-2">
                <div class="flex flex-col lg:flex-row">
                  <span class="w-[20%]"><strong>Legal Name</strong></span>
                  <div class="w-[80%]">
                    <span>{{facilitatorLicense.applicants[0]?.legalFirstName}}</span>
                    <span>{{facilitatorLicense.applicants[0]?.legalMiddleName}}</span>
                    <span>{{facilitatorLicense.applicants[0]?.legalLastName}}</span>
                  </div>
                </div>
                <div class="flex flex-col lg:flex-row">
                  <span class="w-[20%]"><strong>Preferred Name</strong></span>
                  <div class="flex flex-row gap-2 w-[80%]">
                    <span>{{facilitatorLicense.applicants[0]?.preferredFirstName}}</span>
                    <span>{{facilitatorLicense.applicants[0]?.preferredMiddleName}}</span>
                    <span>{{facilitatorLicense.applicants[0]?.preferredLastName}}</span>
                  </div>
                </div>
                <div class="flex flex-col lg:flex-row">
                  <span class="w-[20%]"><strong>Other Names</strong></span>
                  <div class="flex flex-row gap-2 w-[80%]">
                    <span>{{facilitatorLicense.applicants[0]?.alternateNames}}</span>
                  </div>
                </div>
                <div class="flex flex-col lg:flex-row">
                  <span class="w-[20%]"><strong>Physical Address</strong></span>
                  <div class="flex flex-row gap-2 w-[80%]">
                    <span>{{facilitatorLicense.applicants[0]?.physicalStreet}}</span>
                    <span>{{facilitatorLicense.applicants[0]?.physicalCity}}</span>
                    <span>{{facilitatorLicense.applicants[0]?.physicalState}}</span>
                    <span>{{facilitatorLicense.applicants[0]?.physicalZip}}</span>
                    <span>{{facilitatorLicense.applicants[0]?.physicalCounty}}</span>
                  </div>
                </div>
                <div class="flex flex-col lg:flex-row">
                  <span class="w-[20%]"><strong>Mailing Address</strong></span>
                  <div *ngIf="!facilitatorLicense.applicants[0]?.mailingIsPhysical" class="flex flex-row gap-2 w-[80%]">
                    <span>{{facilitatorLicense.applicants[0]?.mailingStreet}}</span>
                    <span>{{facilitatorLicense.applicants[0]?.mailingCity}}</span>
                    <span>{{facilitatorLicense.applicants[0]?.mailingState}}</span>
                    <span>{{facilitatorLicense.applicants[0]?.mailingZip}}</span>
                    <span>{{facilitatorLicense.applicants[0]?.mailingCounty}}</span>
                  </div>
                  <div *ngIf="facilitatorLicense.applicants[0]?.mailingIsPhysical" class="flex flex-row gap-2 w-[80%]">
                    <span>Same as Physical</span>
                  </div>
                </div>
                <div class="flex flex-col lg:flex-row">
                  <span class="w-[20%]"><strong>Primary Phone</strong></span>
                  <div class="flex flex-row gap-2 w-[80%]">
                    <span>{{facilitatorLicense.applicants[0]?.phone | mask: '(000) 000-0000 000000'}}</span>
                  </div>
                </div>
                <div class="flex flex-col lg:flex-row">
                  <span class="w-[20%]"><strong>Alternate Phone</strong></span>
                  <div class="flex flex-row gap-2 w-[80%]">
                    <span>{{facilitatorLicense.applicants[0]?.alternatePhone | mask: '(000) 000-0000 000000'}}</span>
                  </div>
                </div>
                <div class="flex flex-col lg:flex-row">
                  <span class="w-[20%]"><strong>Email</strong></span>
                  <div class="flex flex-row gap-2 w-[80%]">
                    <span>{{facilitatorLicense.applicants[0]?.email}}</span>
                  </div>
                </div>
                <div class="flex flex-col lg:flex-row">
                  <span class="w-[20%]"><strong>Language</strong></span>
                  <div class="flex flex-row gap-2 w-[80%]">
                    <span>{{facilitatorLicense.applicants[0]?.language}}</span>
                  </div>
                </div>
                <div class="flex flex-col lg:flex-row">
                  <span class="w-[20%]"><strong>Training Program</strong></span>
                  <span>{{facilitatorLicense.trainingProgram}}</span>
                </div>

                <div class="flex flex-col lg:flex-row">
                  <span class="w-[20%]"><strong>Completed On:</strong></span>
                  <span>{{facilitatorLicense.trainingDate | date}}</span>
                </div>

                <div class="flex flex-col lg:flex-row" *ngIf="sharedService.isAfterJan1st2027()">
                  <span class="w-[20%]"><strong>Out-of-State Approved Training Program</strong></span>
                  <span>{{facilitatorLicense.oosTrainingProgram}}</span>
                </div>

                <div class="flex flex-col lg:flex-row" *ngIf="sharedService.isAfterJan1st2027()">
                  <span class="w-[20%]"><strong>Completed On:</strong></span>
                  <span>{{facilitatorLicense.oosTrainingDate | date}}</span>
                </div>

                <div *ngIf="facilitatorLicense.applicants[0]?.previousLicense" class="flex flex-col">
                  <mat-checkbox [checked]="true" disabled>
                    Has this individual applied for or received any other licenses from Oregon Psilocybin Services?
                  </mat-checkbox>
                  <div class="flex flex-col">
                    <span>Previous Affiliated License</span>
                    <span>{{facilitatorLicense.applicants[0]?.affiliatedLicenses}}</span>
                  </div>
                </div>

              </div>
            </mat-card-content>
          </mat-card>

          <div class="flex flex-col lg:flex-row gap-2 w-full lg:w-1/2">
            <mat-card class="md:w-[60%] w-full">
              <mat-card-title>
                <div class="flex flex-col">
                  <span>Current Documents</span>
                  <span class="text-red-400 f-s-16" *ngIf="!applicantDocumentsValid || !licenseDocumentsValid || (!documentsForm.valid && !documentsForm.pristine)">Not All Requirements are Met</span>
                </div>
              </mat-card-title>
              <mat-card-content>
                <div class="flex flex-col">
                  <span class="text-red-400" *ngIf="missingTypes[trainingCertificateType]">{{documentTypeReference[trainingCertificateType]}} required</span>
                  <span class="text-red-400" *ngIf="missingTypes[socialEquityPlanType]">{{documentTypeReference[socialEquityPlanType]}} required</span>
                  <span class="text-red-400" *ngIf="missingTypes[personalIdentificationType]">{{documentTypeReference[personalIdentificationType]}} required</span>
                  <span class="text-red-400" *ngIf="missingTypes[updatedEquityPlanType]">{{documentTypeReference[updatedEquityPlanType]}} required</span>
                  <span class="text-red-400" *ngIf="missingTypes[educationHoursLogType]">{{documentTypeReference[educationHoursLogType]}} required</span>
                  <span class="text-red-400" *ngIf="missingTypes[equityPlanEvaluationType]">{{documentTypeReference[equityPlanEvaluationType]}} required</span>
                  <span class="text-red-400" *ngIf="!documentsForm.valid && !documentsForm.pristine">Document Form Incomplete</span>
                </div>
                <div class="flex flex-col gap-2 f-s-16">
                  <div *ngIf="!sharedService.mobile" class="flex flex-row md:items-center">
                    <div class="flex w-full md:w-1/2">
                      <span class="f-s-16"><strong>File</strong></span>
                    </div>
                    <div class="flex w-full md:w-1/2 md:flex-row md:items-center md:justify-between">
                      <div class="flex flex-col md:w-[70%]">
                        <span class="f-s-16"><strong>Requirement</strong></span>
                      </div>
                      <div class="flex items-center justify-end">
                      </div>
                    </div>
                  </div>
                  <ng-container *ngFor="let document of facilitatorLicense.applicants[0]?.applicantDocuments">
                    <div class="flex flex-col gap-2 border-b border-gray-200 py-2 last:border-b-0 md:flex-row md:items-center">
                      <div class="flex w-full flex-col md:w-1/2">
                        <span *ngIf="sharedService.mobile" class="f-s-14"><strong>File</strong></span>
                        <span title="{{document.name}}" class="w-full break-words">{{document.name.length > 15 ? document.name.substring(0,15) + "..." : document.name}}</span>
                      </div>
                      <div class="flex w-full flex-col gap-2 md:w-1/2 md:flex-row md:items-center md:justify-between">
                        <div class="flex flex-col break-words md:w-[70%] f-s-16">
                          <span *ngIf="sharedService.mobile" class="f-s-14"><strong>Requirement</strong></span>
                          <span *ngFor="let type of document.types">
                            {{documentTypeReference[type]}}
                          </span>
                        </div>
                        <div class="flex items-center justify-start md:justify-end">
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngFor="let document of facilitatorLicense?.licenseDocuments">
                    <div class="flex flex-col gap-2 border-b border-gray-200 py-2 last:border-b-0 md:flex-row md:items-center">
                      <div class="flex w-full flex-col md:w-1/2">
                        <span *ngIf="sharedService.mobile" class="f-s-14"><strong>File</strong></span>
                        <span title="{{document.name}}" class="w-full break-words">{{document.name.length > 15 ? document.name.substring(0,15) + "..." : document.name}}</span>
                      </div>
                      <div class="flex w-full flex-col gap-2 md:w-1/2 md:flex-row md:items-center md:justify-between">
                        <div class="flex flex-col break-words md:w-[70%] f-s-16">
                          <span *ngIf="sharedService.mobile" class="f-s-14"><strong>Requirement</strong></span>
                          <span *ngFor="let type of document.types">
                            {{documentTypeReference[type]}}
                          </span>
                        </div>
                        <div class="flex items-center justify-start md:justify-end">
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </mat-card-content>
            </mat-card>
            <mat-card class="md:w-[40%] w-full">
              <mat-card-title>
                <span *ngIf="facilitatorLicense.passedExam">
                  Facilitator Exam
                </span>
                <span class="text-red-400" *ngIf="!facilitatorLicense.passedExam">
                  You Must Pass the Exam</span>
              </mat-card-title>
              <mat-card-content>
                <div class="flex flex-col gap-2">
                  <div class="flex flex-row gap-2">
                    <span class="f-s-16 w-[30%]"><strong>Score</strong></span>
                    <span class="f-s-16 w-[30%]"><strong>Result</strong></span>
                    <span class="f-s-16 w-[40%]"><strong>Date Taken</strong></span>
                  </div>
                  <div *ngFor="let attempt of facilitatorLicense.examAttempts" class="flex flex-row gap-2">
                    <span class="w-[30%]">{{attempt.score}}%</span>
                    <span *ngIf="attempt.passed" class="f-s-16 w-[30%]"><strong>Passed</strong></span>
                    <span *ngIf="!attempt.passed" class="w-[30%]">Failed</span>
                    <span class="w-[40%]">{{attempt.dateTaken | date}}</span>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>

        </div>
        <div class="flex flex-row gap-2">
          <mat-card class="w-full lg:w-1/2">
            <mat-card-title>
              Sign and Submit
            </mat-card-title>
            <mat-card-content>
              <form [formGroup]="licenseForm">
                <div class="flex flex-col gap-2">
                  <ul class="flex flex-col gap-2 f-s-16">
                    <li>
                      I certify the information provided in this application is true and complete to the best of my knowledge.
                      I understand falsifying an application, supplying misleading information, or withholding information is grounds for denial of my application or revocation of my license.
                    </li>
                    <li>
                      I understand I am responsible for making my own determination regarding the legal risks associated with a Schedule 1 substance
                      under the Federal Controlled Substances Act.
                    </li>
                    <li>
                      I understand the information provided in application materials, including applicant name, is subject to disclosure
                      under Oregon's public records laws and that certain information may be posted on OHA's website for purposes of license verification.
                    </li>
                    <li>
                      I understand the following information in the application will be used by Oregon Psilocybin Services to start the background check process:
                      legal name; date of birth; physical address; phone number; email address; proof of identity; prior addresses if lived out of state during the
                      past five years; social security number (if consented); and prior names and aliases.
                    </li>
                    <li>
                      I understand I must complete and pass a background check as a condition of licensure.
                    </li>
                    <li>
                      I understand I must notify Oregon Psilocybin Services in writing within 10 business days of any conviction for any misdemeanor or felony committed
                      and I will be required to undergo another criminal background check.
                    </li>
                    <li>
                      I understand I must notify Oregon Psilocybin Services in writing within 10 business days of a change in contact information.
                    </li>
                    <li>
                      I understand I am also required to obtain a worker permit as described in OAR 333-333-4070.
                    </li>
                    <li>
                      I have read, understand, and agree to adhere to the Oregon Psilocybin Services Revised Statutes (ORS) Chapter 475A,
                      Oregon Administrative Rules (OAR) Chapter 333, Division 333, as well as any other applicable statutes or laws.
                    </li>
                    <li>
                      I understand that failure to adhere to these statutes and rules may result in a denial of my application or disciplinary action if
                      I am licensed by Oregon Psilocybin Services.
                    </li>
                    <li>
                      I understand the psilocybin facilitator license has a term of one year from the effective date of licensure.
                      If I wish to renew my license after that term, I understand I must complete a renewal application.
                    </li>
                    <li>
                      I understand a license will not be issued until the license fee payment is paid and cleared.
                      A licensee may not operate until the effective date of licensure.
                    </li>
                    <li *ngIf="showRequiredApplicantDataAttestation(facilitatorLicense.applicationDate)">
                      Applicant(s) understand and will comply with the requirement to complete and submit the Required 303 Applicant and Licensee REAL & SOGI
                      Data form in accordance with ORS 475A.374.
                    </li>
                    <li>
                      I understand the psilocybin facilitator application and annual license fees are non-refundable.
                    </li>
                  </ul>

                  <mat-checkbox formControlName="attestation">
                    <span class="f-s-16" style="white-space: normal;" [ngStyle]="{'color': licenseForm.get('attestation').hasError('required')? 'red' : ''}">I have read and I understand the above statements</span>
                  </mat-checkbox>

                      <mat-radio-group aria-label="Select an option" formControlName="directoryConsent" style="padding-top: 1em" class="gap-4">
                        <div class="flex flex-col gap-4">
                          <div class="flex flex-row">
                            <mat-radio-button [value]="true">
                              <span class="text-wrap f-s-16">
                                I consent to having my license name, license type, and the contact information selected below listed in the voluntary OPS Licensee Directory.
                              </span>
                            </mat-radio-button>
                          </div>
                            <span *ngIf="licenseForm.get('directoryConsent').value">Please select which contact information you would like to include in the directory:</span>

                          <div style="padding-left: 1em" *ngIf="licenseForm.get('directoryConsent').value" class="flex flex-col">
                            <div class="gap-[5px]">
                              <mat-checkbox formControlName="directoryPreferredName" *ngIf="applicantForm.get('preferredFirstName').value != '' || applicantForm.get('preferredLastName').value != ''">
                                <span class="f-s-16" style="white-space: normal;">Display my preferred name in the License Directory instead of my legal name.</span>
                              </mat-checkbox>
                            </div>

                            <div class="gap-[5px]">
                              <mat-checkbox formControlName="directoryConsentWebsite">
                                <span class="f-s-16" style="white-space: normal;">Website:</span>
                              </mat-checkbox>

                              <mat-form-field *ngIf="licenseForm.get('directoryConsentWebsite').value">
                                <mat-label class="f-s-16">
                                  Website
                                </mat-label>
                                <input matInput formControlName="directoryWebsite">
                                <mat-error role="alert">
                                  <span *ngIf="licenseForm.get('directoryWebsite').hasError('required')">Error: Directory website URL is required</span>
                                  <span *ngIf="licenseForm.get('directoryWebsite').hasError('pattern')">Error: Please enter a valid URL (http:// or https://)</span>
                                </mat-error>
                              </mat-form-field>
                            </div>

                            <div class="gap-[5px]">
                              <mat-checkbox formControlName="directoryConsentEmail">
                                <span class="f-s-16" style="white-space: normal;">Email:</span>
                              </mat-checkbox>

                              <mat-form-field *ngIf="licenseForm.get('directoryConsentEmail').value">
                                <mat-label class="f-s-16">
                                  Email
                                </mat-label>
                                <input matInput formControlName="directoryEmail">
                                <mat-error role="alert" *ngIf="validateDirectoryConsentEmail()"> Error: This field is required
                                </mat-error>
                              </mat-form-field>
                            </div>

                            <div class="gap-[5px]">
                              <mat-checkbox formControlName="directoryConsentPhone">
                                <span class="f-s-16" style="white-space: normal;">Phone Number:</span>
                              </mat-checkbox>

                              <mat-form-field *ngIf="licenseForm.get('directoryConsentPhone').value">
                                <mat-label class="f-s-16">
                                  Phone number
                                </mat-label>
                                <input matInput formControlName="directoryPhone" mask="(000) 000-0000 000000">
                                <mat-error role="alert" *ngIf="validateDirectoryConsentPhone()"> Error: This field is required
                                </mat-error>
                              </mat-form-field>
                            </div>
                          </div>

                          <div class="flex flex-row">
                            <mat-radio-button [value]="false">
                              <span class="text-wrap f-s-16">
                                I <strong>do not</strong> consent to having my license name, license type, and contact information listed in the voluntary OPS Licensee Directory.
                              </span>
                            </mat-radio-button>
                          </div>
                        </div>
                      </mat-radio-group>
                      <mat-error role="alert" *ngIf="licenseForm.get('directoryConsent').invalid"> Error: You must select one statement regarding consent</mat-error>
                      <span class="text-wrap f-s-16">Please note, if you do not consent, you may still be licensed with Oregon Psilocybin Services.</span>

                  <div class="flex flex-col lg:flex-row gap-2 justify-start items-center">
                    <mat-form-field class="md:!w-1/3 w-full">
                      <mat-label class="f-s-16">
                        Signature
                      </mat-label>
                      <input matInput placeholder="Signature" formControlName="electronicSignature">
                      <mat-error role="alert" *ngIf="licenseForm.get('electronicSignature').invalid"> Error: Signature is required
                      </mat-error>
                    </mat-form-field>
                    <button [disabled]="validateDirectoryConsentWebsite() || !applicationValid || !licenseForm.valid || licenseLocked" type="submit" mat-raised-button
                      color="primary" (click)="submitRenewal()">Submit Renewal</button>
                  </div>
                </div>
              </form>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
      <div class="p-t-16 flex sm:flex-row flex-col gap-2 w-full md:w-1/2">
        <button mat-raised-button matStepperPrevious>Back</button>
      </div>
    </mat-step>

  </mat-stepper>
</div>

<div *ngIf="loadingFacilitator">
  <div [ngClass]="{'global-loader': true, 'global-loader-dark': sharedService.darkMode}">
    <h2>Loading</h2>
  </div>
</div>
